import { useState, useEffect, useRef } from "react";
import { 
  X, Shield, Settings, Users, Bot, RefreshCw, Plus, Trash2, 
  Check, AlertTriangle, Database, Phone, MessageSquare, 
  FileText, Link2, Sparkles, ChevronRight, Key, Webhook,
  Terminal, Cloud, Edit2, Save, Eye, EyeOff, Zap, Globe,
  HardDrive, Clock, Activity, Trash, ChevronDown, ChevronUp,
  PhoneOff, UserCog, Crown, Target, Calendar, TrendingUp,
  Award, Brain, Users2, Pause, Play, BarChart3, Mail, Send,
  History, Inbox, MessageCircle, BellRing, CheckCircle, Search, User,
  ExternalLink, Info, LayoutGrid, TableProperties, Bell, Folder, Building2, Plug, ArrowUpDown, Calculator, Mic, CreditCard, Edit3, Layers, Bookmark, Book, LayoutDashboard, GitBranch, Package, ToggleLeft, ToggleRight, Power
} from "lucide-react";
import AdminPage from "./AdminPage";
import SaniaLearningSection from "./components/SaniaLearningSection";
import ClientFieldsConfigurator from "./components/ClientFieldsConfigurator";
import DynamicTabsConfig from "./components/DynamicTabsConfig";
import GoogleAdsIntegrationCard from "./components/GoogleAdsIntegrationCard";
import CanvaIntegrationCard from "./components/CanvaIntegrationCard";
import PennylaneConfigCard from "./components/PennylaneConfigCard";
import PennylaneWriteConfigCard from "./components/PennylaneWriteConfigCard";
import WhatsAppServiceUrlConfig from "./components/WhatsAppServiceUrlConfig";
import ConnectorsList from "./components/ConnectorsList";
import IntegrationsClesDashboard from "./components/IntegrationsClesDashboard";
import ConnectionHistory from "./components/ConnectionHistory";
import AmoMarManager from "./components/SuperBatard/AmoMarManager";
import SocietesManager from "./components/SuperBatard/SocietesManager";
import TenantsManager from "./components/SuperBatard/TenantsManager";
import TenantPermissionsManager from "./components/SuperBatard/TenantPermissionsManager";
import DiagnosticPanel from "./components/SuperBatard/DiagnosticPanel";
import IntegrationsHealthPanel from "./components/SuperBatard/IntegrationsHealthPanel";
import CatalogueDevisManager from "./components/SuperBatard/CatalogueDevisManager";
import CatalogueProduitsAdmin from "./components/SuperBatard/CatalogueProduitsAdmin";
import WidgetRegistryManager from "./components/SuperBatard/widgets/WidgetRegistryManager";
import GedDashboard from "./components/GedDashboard";
import IAPermissionsDashboard from "./components/IAPermissionsDashboard";
import RachelAccountingPanel from "./components/RachelAccountingPanel";
import ChristelleConfigPanel from "./components/ChristelleConfigPanel";
// Project Hub Components
import ProjectKnowledgeCenter from "./components/ProjectKnowledgeCenter";
import ProjectManagement from "./components/ProjectManagement";
import ProjectAuditIA from "./components/ProjectAuditIA";
import AgentDirectives from "./components/AgentDirectives";
import ElementsDeclenchement from "./components/SuperBatard/ElementsDeclenchement";
import PipelineConfigPanel from "./components/SuperBatard/PipelineConfigPanel";
import LeadSourcesConfigPanel from "./components/SuperBatard/LeadSourcesConfigPanel";
import StatutsQualificationConfigPanel from "./components/SuperBatard/StatutsQualificationConfigPanel";
import SMSConfigPanel from "./components/SuperBatard/SMSConfigPanel";
import DashboardConfigPanel from "./components/SuperBatard/DashboardConfigPanel";
import YaelConsole from "./components/SuperBatard/YaelConsole";
import SecurityDashboard from "./components/admin/SecurityDashboard";
import BillingDashboard from "./components/admin/BillingDashboard";
import PipelineWorkflow from "./components/admin/PipelineWorkflow";
import SocialACWorkflow from "./components/admin/SocialACWorkflow";
import WhatsAppManager from "./components/admin/WhatsAppManager";
import SchedulerManager from "./components/admin/SchedulerManager";
import DashboardManager from "./components/admin/DashboardManager";
import ConversationsHistory from "./components/admin/ConversationsHistory";
import CrmVariablesList from "./components/admin/CrmVariablesList";
import CloneSpace from "./components/admin/CloneSpace";
import FormulairesMapping from "./components/admin/FormulairesMapping";
import AppelsEntrantsConfigPanel from "./components/SuperBatard/AppelsEntrantsConfigPanel";
import TarifsRenoConfig from "./components/admin/TarifsRenoConfig";
import getApiUrl from './utils/getApiUrl';

const API = `${getApiUrl()}/api`;

// ── Wrapper fetch avec credentials automatiques ──
// Resout le probleme des 86+ fetch sans auth qui cassent la prod
const authFetch = (url, options = {}) => {
  const token = localStorage.getItem("auth_token");
  const merged = {
    ...options,
    credentials: "include",
    headers: {
      ...(options.headers || {}),
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
  };
  return fetch(url, merged);
};

// Section Catalogue Devis avec selection de societe
const CatalogueDevisSection = () => {
  const [societes, setSocietes] = useState([]);
  const [selectedSociete, setSelectedSociete] = useState("");
  useEffect(() => {
    authFetch(`${API}/societes`).then(r => r.json()).then(data => {
      setSocietes(data);
      if (data.length === 1) setSelectedSociete(data[0].id);
    }).catch(() => {});
  }, []);
  return (
    <div className="space-y-4">
      {societes.length > 1 && (
        <div className="flex items-center gap-3">
          <label className="text-sm text-slate-400">Societe :</label>
          <select value={selectedSociete} onChange={e => setSelectedSociete(e.target.value)} className="bg-slate-800 border border-slate-700 rounded-lg px-3 py-2 text-sm text-white">
            <option value="">-- Choisir --</option>
            {societes.map(s => <option key={s.id} value={s.id}>{s.raison_sociale}</option>)}
          </select>
        </div>
      )}
      <CatalogueDevisManager societeId={selectedSociete} />
    </div>
  );
};

// Widget de transcription des appels
const TranscriptionWidget = () => {
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(false);
  const [launching, setLaunching] = useState(false);

  const fetchStatus = async () => {
    try {
      const resp = await authFetch(`${API}/ringover/transcribe/status`);
      if (resp.ok) {
        setStatus(await resp.json());
      }
    } catch (e) {
      console.error("Erreur fetch status:", e);
    }
  };

  useEffect(() => {
    fetchStatus();
    const interval = setInterval(fetchStatus, 30000); // Refresh toutes les 30s
    return () => clearInterval(interval);
  }, []);

  const launchTranscription = async () => {
    setLaunching(true);
    try {
      const resp = await authFetch(`${API}/ringover/transcribe/all`, { method: "POST" });
      if (resp.ok) {
        const data = await resp.json();
        alert(`🚀 ${data.message}\n\nCoût estimé: $${data.estimated_cost_usd} USD`);
        fetchStatus();
      }
    } catch (e) {
      alert("Erreur: " + e.message);
    }
    setLaunching(false);
  };

  if (!status) return null;

  const progress = status.percentage || 0;

  return (
    <div className="bg-slate-800/50 rounded-xl border border-slate-700/50 p-6">
      <h3 className="font-semibold mb-4 flex items-center gap-2">
        <Brain className="w-5 h-5 text-purple-400" />
        🎙️ Transcription des appels (Whisper)
      </h3>
      
      <div className="space-y-4">
        {/* Stats */}
        <div className="grid grid-cols-4 gap-3">
          <div className="bg-slate-900/50 rounded-lg p-3 text-center">
            <p className="text-2xl font-bold text-blue-400">{status.total_calls}</p>
            <p className="text-xs text-slate-400">Total appels</p>
          </div>
          <div className="bg-slate-900/50 rounded-lg p-3 text-center">
            <p className="text-2xl font-bold text-green-400">{status.transcribed}</p>
            <p className="text-xs text-slate-400">Transcrits</p>
          </div>
          <div className="bg-slate-900/50 rounded-lg p-3 text-center">
            <p className="text-2xl font-bold text-orange-400">{status.pending}</p>
            <p className="text-xs text-slate-400">En attente</p>
          </div>
          <div className="bg-slate-900/50 rounded-lg p-3 text-center">
            <p className="text-2xl font-bold text-purple-400">{progress}%</p>
            <p className="text-xs text-slate-400">Progression</p>
          </div>
        </div>
        
        {/* Progress bar */}
        <div className="w-full bg-slate-700 rounded-full h-3">
          <div 
            className="bg-gradient-to-r from-purple-500 to-blue-500 h-3 rounded-full transition-all duration-500"
            style={{ width: `${progress}%` }}
          />
        </div>
        
        {/* Boutons */}
        <div className="flex gap-3">
          <button
            onClick={fetchStatus}
            className="flex-1 py-2 px-4 bg-slate-700 hover:bg-slate-600 rounded-lg text-sm flex items-center justify-center gap-2"
          >
            <RefreshCw className={`w-4 h-4 ${loading ? 'animate-spin' : ''}`} />
            Rafraîchir
          </button>
          
          {status.pending > 0 && (
            <button
              onClick={launchTranscription}
              disabled={launching}
              className="flex-1 py-2 px-4 bg-purple-600 hover:bg-purple-500 disabled:bg-purple-800 rounded-lg text-sm flex items-center justify-center gap-2"
            >
              {launching ? (
                <><RefreshCw className="w-4 h-4 animate-spin" /> Lancement...</>
              ) : (
                <><Play className="w-4 h-4" /> Transcrire {status.pending} appels</>
              )}
            </button>
          )}
        </div>
        
        {/* Info coût */}
        {status.pending > 0 && (
          <p className="text-xs text-slate-500 text-center">
            💰 Coût estimé: ~${(status.pending * 1.6 * 0.006).toFixed(2)} USD (OpenAI Whisper)
          </p>
        )}
        
        {/* Note */}
        <p className="text-xs text-slate-500">
          ✅ Transcription automatique activée : 5 appels transcrits toutes les 10 minutes
        </p>
      </div>
    </div>
  );
};

// ═══════════════════════════════════════════════════════════════
// SECTION CONNECTEURS FOURNISSEURS
// ═══════════════════════════════════════════════════════════════
const ConnecteursFournisseursSection = () => {
  const [loading, setLoading] = useState(true);
  const [suppliers, setSuppliers] = useState({});
  const [availableApis, setAvailableApis] = useState({});
  const [sortBy, setSortBy] = useState("missing"); // "missing", "count", "amount"
  const [error, setError] = useState(null);

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    setLoading(true);
    try {
      const resp = await authFetch(`${API}/rapprochement/consolidation`);
      if (resp.ok) {
        const data = await resp.json();
        setSuppliers(data.suppliers || {});
        setAvailableApis(data.available_apis || {});
      }
    } catch (e) {
      setError("Erreur chargement des données");
    }
    setLoading(false);
  };

  // Convertir suppliers en array et trier
  const suppliersList = Object.entries(suppliers)
    .map(([name, info]) => ({
      name,
      ...info,
      hasApi: Object.keys(availableApis).some(key => name.toUpperCase().includes(key)),
      apiInfo: Object.entries(availableApis).find(([key]) => name.toUpperCase().includes(key))?.[1]
    }))
    .sort((a, b) => {
      if (sortBy === "missing") return (b.without_justif || 0) - (a.without_justif || 0);
      if (sortBy === "count") return (b.count || 0) - (a.count || 0);
      if (sortBy === "amount") return (b.total_amount || 0) - (a.total_amount || 0);
      return 0;
    });

  // Stats globales
  const totalMissing = suppliersList.reduce((sum, s) => sum + (s.without_justif || 0), 0);
  const totalTransactions = suppliersList.reduce((sum, s) => sum + (s.count || 0), 0);
  const suppliersWithApi = suppliersList.filter(s => s.hasApi).length;

  if (loading) {
    return (
      <div className="flex items-center justify-center py-20">
        <RefreshCw className="w-8 h-8 animate-spin text-slate-500" />
      </div>
    );
  }

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="bg-gradient-to-br from-blue-500/10 to-cyan-500/10 border border-blue-500/30 rounded-xl p-6">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-4">
            <div className="w-14 h-14 bg-gradient-to-br from-blue-500 to-cyan-500 rounded-xl flex items-center justify-center">
              <Plug className="w-7 h-7 text-white" />
            </div>
            <div>
              <h2 className="text-xl font-bold">Connecteurs API Fournisseurs</h2>
              <p className="text-slate-400">Récupérez automatiquement vos factures fournisseurs</p>
            </div>
          </div>
          <button
            onClick={loadData}
            className="px-4 py-2 bg-blue-600 hover:bg-blue-700 rounded-lg flex items-center gap-2"
          >
            <RefreshCw className="w-4 h-4" />
            Actualiser
          </button>
        </div>
      </div>

      {/* Stats rapides */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
        <div className="bg-slate-800/50 border border-slate-700 rounded-xl p-4">
          <div className="flex items-center gap-3 mb-2">
            <Building2 className="w-5 h-5 text-slate-400" />
            <span className="text-sm text-slate-400">Fournisseurs</span>
          </div>
          <div className="text-2xl font-bold">{suppliersList.length}</div>
        </div>
        <div className="bg-slate-800/50 border border-red-500/30 rounded-xl p-4">
          <div className="flex items-center gap-3 mb-2">
            <AlertTriangle className="w-5 h-5 text-red-400" />
            <span className="text-sm text-red-400">Factures manquantes</span>
          </div>
          <div className="text-2xl font-bold text-red-400">{totalMissing}</div>
        </div>
        <div className="bg-slate-800/50 border border-slate-700 rounded-xl p-4">
          <div className="flex items-center gap-3 mb-2">
            <FileText className="w-5 h-5 text-slate-400" />
            <span className="text-sm text-slate-400">Total transactions</span>
          </div>
          <div className="text-2xl font-bold">{totalTransactions}</div>
        </div>
        <div className="bg-slate-800/50 border border-emerald-500/30 rounded-xl p-4">
          <div className="flex items-center gap-3 mb-2">
            <Plug className="w-5 h-5 text-emerald-400" />
            <span className="text-sm text-emerald-400">Avec API disponible</span>
          </div>
          <div className="text-2xl font-bold text-emerald-400">{suppliersWithApi}</div>
        </div>
      </div>

      {/* Tri */}
      <div className="bg-slate-800/50 border border-slate-700 rounded-xl p-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <ArrowUpDown className="w-4 h-4 text-slate-400" />
            <span className="text-sm text-slate-400">Trier par :</span>
          </div>
          <div className="flex gap-2">
            <button
              onClick={() => setSortBy("missing")}
              className={`px-3 py-1.5 rounded-lg text-sm font-medium transition-all ${
                sortBy === "missing"
                  ? "bg-red-600 text-white"
                  : "bg-slate-700 text-slate-300 hover:bg-slate-600"
              }`}
            >
              📋 Factures manquantes
            </button>
            <button
              onClick={() => setSortBy("count")}
              className={`px-3 py-1.5 rounded-lg text-sm font-medium transition-all ${
                sortBy === "count"
                  ? "bg-blue-600 text-white"
                  : "bg-slate-700 text-slate-300 hover:bg-slate-600"
              }`}
            >
              🔢 Nb transactions
            </button>
            <button
              onClick={() => setSortBy("amount")}
              className={`px-3 py-1.5 rounded-lg text-sm font-medium transition-all ${
                sortBy === "amount"
                  ? "bg-emerald-600 text-white"
                  : "bg-slate-700 text-slate-300 hover:bg-slate-600"
              }`}
            >
              💰 Montant total
            </button>
          </div>
        </div>
      </div>

      {/* Liste des fournisseurs */}
      <div className="bg-slate-800/30 border border-slate-700 rounded-xl overflow-hidden">
        <div className="p-4 border-b border-slate-700 bg-slate-800/50">
          <h3 className="font-semibold flex items-center gap-2">
            <Building2 className="w-5 h-5 text-slate-400" />
            Liste des fournisseurs
            <span className="text-sm text-slate-500">({suppliersList.length})</span>
          </h3>
        </div>
        
        <div className="divide-y divide-slate-700/50">
          {suppliersList.map((supplier, idx) => (
            <FournisseurRow key={idx} supplier={supplier} rank={idx + 1} />
          ))}
        </div>
      </div>

      {error && (
        <div className="bg-red-500/20 border border-red-500/30 rounded-lg p-4 text-red-400">
          {error}
        </div>
      )}
    </div>
  );
};

// Composant ligne fournisseur
const FournisseurRow = ({ supplier, rank }) => {
  const [expanded, setExpanded] = useState(false);
  const hasMissing = (supplier.without_justif || 0) > 0;
  
  return (
    <div className={`${hasMissing ? 'bg-red-500/5' : ''}`}>
      <div 
        className="p-4 flex items-center justify-between hover:bg-slate-800/30 cursor-pointer transition-colors"
        onClick={() => setExpanded(!expanded)}
      >
        <div className="flex items-center gap-4">
          {/* Rang */}
          <div className={`w-8 h-8 rounded-lg flex items-center justify-center font-bold text-sm ${
            rank <= 3 ? 'bg-red-500/20 text-red-400' : 'bg-slate-700 text-slate-400'
          }`}>
            {rank}
          </div>
          
          {/* Icône */}
          <div className={`w-10 h-10 rounded-lg flex items-center justify-center ${
            supplier.hasApi ? 'bg-blue-500/20' : 'bg-slate-700'
          }`}>
            {supplier.hasApi ? (
              <Plug className="w-5 h-5 text-blue-400" />
            ) : (
              <Building2 className="w-5 h-5 text-slate-400" />
            )}
          </div>
          
          {/* Infos */}
          <div>
            <div className="flex items-center gap-2">
              <span className="font-medium">{supplier.name}</span>
              {supplier.hasApi && (
                <span className="px-2 py-0.5 bg-blue-500/20 text-blue-400 text-xs rounded">
                  API disponible
                </span>
              )}
            </div>
            <div className="flex items-center gap-4 text-sm text-slate-400">
              <span>{supplier.count} transactions</span>
              <span>{parseFloat(supplier.total_amount || 0).toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' })}</span>
            </div>
          </div>
        </div>
        
        {/* Badge manquantes */}
        <div className="flex items-center gap-4">
          {hasMissing ? (
            <div className="flex items-center gap-2">
              <span className="px-3 py-1.5 bg-red-600 text-white rounded-lg font-bold text-sm animate-pulse">
                {supplier.without_justif} facture{supplier.without_justif > 1 ? 's' : ''} manquante{supplier.without_justif > 1 ? 's' : ''}
              </span>
            </div>
          ) : (
            <span className="px-3 py-1.5 bg-emerald-500/20 text-emerald-400 rounded-lg text-sm flex items-center gap-1">
              <CheckCircle className="w-4 h-4" />
              Complet
            </span>
          )}
          
          <ChevronDown className={`w-5 h-5 text-slate-400 transition-transform ${expanded ? 'rotate-180' : ''}`} />
        </div>
      </div>
      
      {/* Panel étendu */}
      {expanded && (
        <div className="px-4 pb-4 pt-2 border-t border-slate-700/50 bg-slate-900/30">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {/* Infos */}
            <div className="space-y-3">
              <h4 className="font-medium text-sm text-slate-400">Statistiques</h4>
              <div className="grid grid-cols-2 gap-2 text-sm">
                <div className="bg-slate-800/50 rounded-lg p-2">
                  <span className="text-slate-500">Transactions:</span>
                  <span className="ml-2 font-medium">{supplier.count}</span>
                </div>
                <div className="bg-slate-800/50 rounded-lg p-2">
                  <span className="text-slate-500">Montant:</span>
                  <span className="ml-2 font-medium">{parseFloat(supplier.total_amount || 0).toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' })}</span>
                </div>
                <div className="bg-slate-800/50 rounded-lg p-2">
                  <span className="text-slate-500">Sans justif:</span>
                  <span className={`ml-2 font-medium ${supplier.without_justif > 0 ? 'text-red-400' : 'text-emerald-400'}`}>
                    {supplier.without_justif || 0}
                  </span>
                </div>
                <div className="bg-slate-800/50 rounded-lg p-2">
                  <span className="text-slate-500">Manquantes PL:</span>
                  <span className={`ml-2 font-medium ${supplier.missing_pennylane > 0 ? 'text-orange-400' : 'text-emerald-400'}`}>
                    {supplier.missing_pennylane || 0}
                  </span>
                </div>
              </div>
            </div>
            
            {/* Actions */}
            <div className="space-y-3">
              <h4 className="font-medium text-sm text-slate-400">Actions</h4>
              {supplier.hasApi ? (
                <div className="space-y-2">
                  <div className="bg-blue-500/10 border border-blue-500/30 rounded-lg p-3">
                    <div className="flex items-center gap-2 mb-2">
                      <Plug className="w-4 h-4 text-blue-400" />
                      <span className="font-medium text-blue-400">{supplier.apiInfo?.name}</span>
                    </div>
                    <p className="text-xs text-slate-400 mb-3">{supplier.apiInfo?.description || 'Connecteur disponible'}</p>
                    <div className="flex gap-2">
                      <button className="flex-1 px-3 py-2 bg-blue-600 hover:bg-blue-700 rounded-lg text-sm font-medium flex items-center justify-center gap-2">
                        <Settings className="w-4 h-4" />
                        Configurer
                      </button>
                      {supplier.apiInfo?.url && (
                        <a
                          href={supplier.apiInfo.url}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="px-3 py-2 bg-slate-700 hover:bg-slate-600 rounded-lg text-sm flex items-center gap-1"
                        >
                          <ExternalLink className="w-4 h-4" />
                        </a>
                      )}
                    </div>
                  </div>
                </div>
              ) : (
                <div className="bg-slate-800/50 rounded-lg p-3 text-center">
                  <p className="text-sm text-slate-400 mb-3">Pas de connecteur automatique disponible</p>
                  <button className="px-4 py-2 bg-slate-700 hover:bg-slate-600 rounded-lg text-sm">
                    Import manuel des factures
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

// ═══════════════════════════════════════════════════════════════
// COMPOSANT: Configuration des Conditions de Règlement
// ═══════════════════════════════════════════════════════════════
const PaymentConditionsConfig = () => {
  const [conditions, setConditions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [newConditionLabel, setNewConditionLabel] = useState('');
  const [addingNew, setAddingNew] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [editLabel, setEditLabel] = useState('');

  const API = getApiUrl();

  useEffect(() => {
    loadConditions();
  }, []);

  const loadConditions = async () => {
    try {
      const token = localStorage.getItem('auth_token');
      const resp = await authFetch(`${API}/api/compta-new/payment-conditions`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      if (resp.ok) {
        const data = await resp.json();
        setConditions(data.conditions || []);
      }
    } catch (e) {
      console.error('Erreur chargement conditions:', e);
    }
    setLoading(false);
  };

  const handleAddCondition = async () => {
    if (!newConditionLabel.trim()) return;
    
    setAddingNew(true);
    try {
      const token = localStorage.getItem('auth_token');
      const resp = await authFetch(`${API}/api/compta-new/payment-conditions/add`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ label: newConditionLabel.trim() })
      });
      
      if (resp.ok) {
        await loadConditions();
        setNewConditionLabel('');
      }
    } catch (e) {
      console.error('Erreur ajout condition:', e);
    }
    setAddingNew(false);
  };

  const handleDeleteCondition = async (conditionId) => {
    if (!window.confirm('Supprimer cette condition de règlement ?')) return;
    
    try {
      const token = localStorage.getItem('auth_token');
      const resp = await authFetch(`${API}/api/compta-new/payment-conditions/${conditionId}`, {
        method: 'DELETE',
        headers: { 'Authorization': `Bearer ${token}` }
      });
      
      if (resp.ok) {
        await loadConditions();
      }
    } catch (e) {
      console.error('Erreur suppression condition:', e);
    }
  };

  const handleSaveEdit = async (conditionId) => {
    if (!editLabel.trim()) return;
    
    const updatedConditions = conditions.map(c => 
      c.id === conditionId ? { ...c, label: editLabel.trim() } : c
    );
    
    setSaving(true);
    try {
      const token = localStorage.getItem('auth_token');
      const resp = await authFetch(`${API}/api/compta-new/payment-conditions`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ conditions: updatedConditions })
      });
      
      if (resp.ok) {
        await loadConditions();
        setEditingId(null);
        setEditLabel('');
      }
    } catch (e) {
      console.error('Erreur sauvegarde:', e);
    }
    setSaving(false);
  };

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="bg-gradient-to-r from-green-500/10 to-emerald-500/10 border border-green-500/30 rounded-xl p-4">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-xl bg-green-500/20 flex items-center justify-center">
            <CreditCard className="w-5 h-5 text-green-400" />
          </div>
          <div>
            <h2 className="font-bold text-white">Conditions de Règlement</h2>
            <p className="text-sm text-slate-400">Gérez les objets de règlement pour les encaissements clients</p>
          </div>
        </div>
      </div>

      {loading ? (
        <div className="flex items-center justify-center py-12">
          <RefreshCw className="w-8 h-8 animate-spin text-green-400" />
        </div>
      ) : (
        <>
          {/* Liste des conditions */}
          <div className="bg-slate-800/50 rounded-xl border border-slate-700/50 overflow-hidden">
            <div className="bg-slate-700/30 px-4 py-3 border-b border-slate-700/50">
              <h3 className="font-semibold text-white flex items-center gap-2">
                💰 Conditions existantes ({conditions.length})
              </h3>
            </div>
            
            <div className="p-4 space-y-2 max-h-96 overflow-y-auto">
              {conditions.map((cond, idx) => (
                <div
                  key={cond.id}
                  className="flex items-center justify-between p-3 bg-slate-700/30 rounded-lg border border-slate-600/30"
                >
                  {editingId === cond.id ? (
                    <div className="flex-1 flex items-center gap-2">
                      <input
                        type="text"
                        value={editLabel}
                        onChange={(e) => setEditLabel(e.target.value)}
                        className="flex-1 px-3 py-2 bg-slate-800 border border-slate-600 rounded text-white text-sm"
                        autoFocus
                      />
                      <button
                        onClick={() => handleSaveEdit(cond.id)}
                        disabled={saving}
                        className="px-3 py-2 bg-green-600 hover:bg-green-700 rounded text-sm"
                      >
                        ✓
                      </button>
                      <button
                        onClick={() => { setEditingId(null); setEditLabel(''); }}
                        className="px-3 py-2 bg-slate-600 hover:bg-slate-500 rounded text-sm"
                      >
                        ✕
                      </button>
                    </div>
                  ) : (
                    <>
                      <div className="flex items-center gap-3">
                        <span className="text-slate-500 text-sm w-6">{idx + 1}.</span>
                        <span className="text-white">{cond.label}</span>
                      </div>
                      <div className="flex items-center gap-2">
                        <button
                          onClick={() => { setEditingId(cond.id); setEditLabel(cond.label); }}
                          className="p-2 hover:bg-slate-600 rounded text-slate-400 hover:text-white"
                          title="Modifier"
                        >
                          <Edit3 className="w-4 h-4" />
                        </button>
                        <button
                          onClick={() => handleDeleteCondition(cond.id)}
                          className="p-2 hover:bg-red-600/30 rounded text-slate-400 hover:text-red-400"
                          title="Supprimer"
                        >
                          <Trash2 className="w-4 h-4" />
                        </button>
                      </div>
                    </>
                  )}
                </div>
              ))}
            </div>
          </div>

          {/* Ajouter une nouvelle condition */}
          <div className="bg-slate-800/50 rounded-xl border border-slate-700/50 p-4">
            <h3 className="font-medium text-white mb-4 flex items-center gap-2">
              <Plus className="w-4 h-4" />
              Ajouter une condition
            </h3>
            <div className="flex gap-3">
              <input
                type="text"
                value={newConditionLabel}
                onChange={(e) => setNewConditionLabel(e.target.value)}
                placeholder="Ex: Acompte 30%"
                className="flex-1 px-4 py-3 bg-slate-800 border border-slate-600 rounded-lg text-white placeholder:text-slate-500"
                onKeyDown={(e) => e.key === 'Enter' && handleAddCondition()}
              />
              <button
                onClick={handleAddCondition}
                disabled={!newConditionLabel.trim() || addingNew}
                className="px-6 py-3 bg-green-600 hover:bg-green-700 disabled:opacity-50 rounded-lg font-medium flex items-center gap-2"
              >
                {addingNew ? (
                  <RefreshCw className="w-4 h-4 animate-spin" />
                ) : (
                  <Plus className="w-4 h-4" />
                )}
                Ajouter
              </button>
            </div>
          </div>

          {/* Info */}
          <div className="bg-slate-800/30 rounded-xl p-4 border border-slate-700/30">
            <h4 className="font-medium text-slate-300 mb-2">💡 Utilisation</h4>
            <ul className="text-sm text-slate-400 space-y-1">
              <li>• Ces conditions apparaissent dans la modal "Rattacher à un client" de COMPTA FI NEW</li>
              <li>• Elles sont utilisées uniquement pour les <span className="text-green-400">encaissements</span> (argent qui rentre)</li>
              <li>• Les encaissements sont visibles dans l'onglet "Encaissements" de chaque fiche client</li>
            </ul>
          </div>
        </>
      )}
    </div>
  );
};

export default function SuperBatardDashboard({ onBack, authUser, isConsoleAdmin = false, initialSection = null }) {
  const [activeSection, setActiveSection] = useState(initialSection || "overview");
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const mainContentRef = useRef(null);
  
  // Sections du menu repliées/dépliées
  const [collapsedSections, setCollapsedSections] = useState({});
  
  // Config IA
  const [aiConfig, setAiConfig] = useState(null);
  const [availableModels, setAvailableModels] = useState({});
  const [selectedProvider, setSelectedProvider] = useState("openai");
  const [selectedModel, setSelectedModel] = useState("gpt-5.2");
  const [aiEnabled, setAiEnabled] = useState(true);
  const [savingAi, setSavingAi] = useState(false);
  
  // Gestion utilisateurs
  const [users, setUsers] = useState([]);
  const [newEmail, setNewEmail] = useState("");
  const [newRole, setNewRole] = useState("user");
  const [addingUser, setAddingUser] = useState(false);
  
  // Gestion des équipes
  const [teams, setTeams] = useState([]);
  const [loadingTeams, setLoadingTeams] = useState(false);
  const [newTeamName, setNewTeamName] = useState("");
  const [newTeamDescription, setNewTeamDescription] = useState("");
  const [newTeamColor, setNewTeamColor] = useState("#6B7280");
  const [editingTeam, setEditingTeam] = useState(null);
  const [teamMembers, setTeamMembers] = useState({}); // Membres de chaque équipe avec visibilité
  const [expandedTeams, setExpandedTeams] = useState({}); // Équipes dont on affiche les membres
  
  // Intégrations
  const [integrations, setIntegrations] = useState([]);
  const [editingIntegration, setEditingIntegration] = useState(null);
  const [integrationValue, setIntegrationValue] = useState("");
  const [showKeys, setShowKeys] = useState({});
  
  // Prompts
  const [prompts, setPrompts] = useState([]);
  const [editingPrompt, setEditingPrompt] = useState(null);
  const [promptValue, setPromptValue] = useState("");
  
  // Webhooks
  const [webhooks, setWebhooks] = useState([]);
  const [editingWebhook, setEditingWebhook] = useState(null);
  const [webhookUrl, setWebhookUrl] = useState("");
  const [webhookEnabled, setWebhookEnabled] = useState(false);
  
  // Logs
  const [logs, setLogs] = useState([]);
  const [logType, setLogType] = useState("backend");
  const [loadingLogs, setLoadingLogs] = useState(false);
  
  // DB Collections
  const [collections, setCollections] = useState([]);
  const [syncStatus, setSyncStatus] = useState(null);
  
  // Pôle Direction - Agents IA
  const [iaDirectors, setIaDirectors] = useState([]);
  const [directionSummary, setDirectionSummary] = useState(null);
  const [selectedDirector, setSelectedDirector] = useState(null);
  const [showDirectorModal, setShowDirectorModal] = useState(false);
  const [savingDirector, setSavingDirector] = useState(false);
  const [newObjective, setNewObjective] = useState("");
  const [newKpi, setNewKpi] = useState({ name: "", target: "", unit: "" });
  
  // Enrichissement Agents IA - Nouvelles fonctionnalités
  const [directorModalTab, setDirectorModalTab] = useState("config"); // config, knowledge, resources
  const [agentKnowledge, setAgentKnowledge] = useState([]);
  const [agentResources, setAgentResources] = useState([]);
  const [loadingKnowledge, setLoadingKnowledge] = useState(false);
  const [uploadingFile, setUploadingFile] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(null);
  const [newKnowledgeItem, setNewKnowledgeItem] = useState({ type: "information", contenu: "" });

  // Supervision PDG - Notifications et Conversations Inter-Agents
  const [pdgNotifications, setPdgNotifications] = useState([]);
  const [pdgUnreadCount, setPdgUnreadCount] = useState(0);
  const [agentConversations, setAgentConversations] = useState([]);
  const [loadingPdgData, setLoadingPdgData] = useState(false);
  const [selectedConversation, setSelectedConversation] = useState(null);
  const [newConversation, setNewConversation] = useState({ initiator: "", participants: [], subject: "", message: "" });
  const [showNewConversationModal, setShowNewConversationModal] = useState(false);
  const [creatingConversation, setCreatingConversation] = useState(false);

  // Enrichissement Client SAN-IA
  const [enrichmentConfig, setEnrichmentConfig] = useState(null);
  const [enrichmentHistory, setEnrichmentHistory] = useState([]);
  const [enrichmentStats, setEnrichmentStats] = useState(null);
  const [newEmailAddress, setNewEmailAddress] = useState("");
  const [newEmailLabel, setNewEmailLabel] = useState("");
  const [savingEnrichment, setSavingEnrichment] = useState(false);

  // IMAP Email Connector
  const [imapConfigs, setImapConfigs] = useState([]);
  const [showImapModal, setShowImapModal] = useState(false);
  const [showEmailUsersModal, setShowEmailUsersModal] = useState(false);
  const [selectedEmailConfig, setSelectedEmailConfig] = useState(null);
  const [imapForm, setImapForm] = useState({
    email_address: "",
    server: "",
    port: 993,
    password: "",
    use_ssl: true,
    label: ""
  });
  const [testingImap, setTestingImap] = useState(false);
  const [imapTestResult, setImapTestResult] = useState(null);
  const [syncingEmails, setSyncingEmails] = useState(false);
  const [fetchedEmails, setFetchedEmails] = useState([]);

  // Dépenses IA
  const [costData, setCostData] = useState(null);
  const [costPeriod, setCostPeriod] = useState(30);
  const [loadingCosts, setLoadingCosts] = useState(false);
  const [costError, setCostError] = useState(null);
  const [servicesConfig, setServicesConfig] = useState([]);
  const [togglingService, setTogglingService] = useState(null);

  // Email Processing & Enrichment
  const [emailHistory, setEmailHistory] = useState([]);
  const [emailStats, setEmailStats] = useState({ pending: 0, processed: 0, total: 0, pending_link: 0, identified: 0 });
  const [processingEmails, setProcessingEmails] = useState(false);
  
  // Échanges à rattacher
  const [pendingExchanges, setPendingExchanges] = useState([]);
  const [linkingExchange, setLinkingExchange] = useState(null);
  const [showLinkModal, setShowLinkModal] = useState(false);
  const [selectedExchange, setSelectedExchange] = useState(null);
  const [clientSearchTerm, setClientSearchTerm] = useState("");
  const [clientSearchResults, setClientSearchResults] = useState([]);
  
  // Factures à valider (Espace Compta Julia)
  const [pendingInvoices, setPendingInvoices] = useState([]);
  const [validatedInvoices, setValidatedInvoices] = useState([]);
  const [validatingInvoice, setValidatingInvoice] = useState(null);
  
  // SMS/Calls History
  const [smsHistory, setSmsHistory] = useState([]);
  const [smsStats, setSmsStats] = useState({ total: 0, inbound: 0, outbound: 0 });
  const [callsHistory, setCallsHistory] = useState([]);
  const [callsStats, setCallsStats] = useState({ total: 0, inbound: 0, outbound: 0, answered: 0 });
  
  // Configuration centralisée des dashboards
  const [dashboardConfig, setDashboardConfig] = useState(null);
  // Configuration des collaborateurs
  const [collaborateursConfig, setCollaborateursConfig] = useState(null);
  
  // Fonction pour rafraîchir les collaborateurs uniquement
  const refreshCollaborateurs = async () => {
    try {
      const resp = await authFetch(`${API}/config/collaborateurs`);
      if (resp.ok) {
        const data = await resp.json();
        setCollaborateursConfig(data);
        console.log("👥 Collaborateurs rafraîchis:", data.tous_collaborateurs?.length || 0);
      }
    } catch (e) { 
      console.error("Erreur rafraîchissement collaborateurs:", e); 
    }
  };
  
  // Configuration Globale des Dashboards (nouveau système)
  const [globalConfig, setGlobalConfig] = useState(null);
  const [globalConfigLoading, setGlobalConfigLoading] = useState(false);
  const [globalConfigSaving, setGlobalConfigSaving] = useState(false);
  const [globalConfigTab, setGlobalConfigTab] = useState("marche"); // marche, dashboards
  
  // Configuration spécifique Télépro (alertes, messages SAN-IA)
  const [teleproConfigTab, setTeleproConfigTab] = useState("alertes"); // alertes, messages, widgets
  
  // Configuration des widgets et colonnes par dashboard
  const [dashboardsConfig, setDashboardsConfig] = useState({});
  const [selectedDashboardConfig, setSelectedDashboardConfig] = useState("telepro");
  const [dashboardConfigLoading, setDashboardConfigLoading] = useState(false);

  // Configuration des champs de la fiche client
  const [clientFieldsConfig, setClientFieldsConfig] = useState(null);
  const [clientFieldsLoading, setClientFieldsLoading] = useState(false);
  const [clientFieldsSaving, setClientFieldsSaving] = useState(false);

  // Suivi Formations Admin
  const [formationsCollaborators, setFormationsCollaborators] = useState([]);
  const [formationsStats, setFormationsStats] = useState(null);
  const [formationsLoading, setFormationsLoading] = useState(false);
  const [selectedCollaboratorAnalysis, setSelectedCollaboratorAnalysis] = useState(null);
  const [analyzingCollaborator, setAnalyzingCollaborator] = useState(null);

  // Permissions Super Batard du tenant
  const [tenantPermissions, setTenantPermissions] = useState({});
  const [isTenantPermissionsLoaded, setIsTenantPermissionsLoaded] = useState(false);

  useEffect(() => {
    loadData();
    // Charger les permissions Super Batard du tenant
    const loadTenantPermissions = async () => {
      try {
        const token = localStorage.getItem("auth_token");
        const r = await authFetch(`${API}/admin/tenant-permissions/my-permissions`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (r.ok) {
          const data = await r.json();
          if (!data.is_platform_admin) {
            setTenantPermissions(data.permissions || {});
          }
        }
      } catch (e) {
        console.error("Erreur chargement permissions tenant:", e);
      }
      setIsTenantPermissionsLoaded(true);
    };
    loadTenantPermissions();
  }, []);

  const loadData = async () => {
    setLoading(true);
    
    // Charger la config des dashboards (source unique de vérité)
    try {
      const resp = await authFetch(`${API}/config/dashboards`);
      if (resp.ok) {
        const data = await resp.json();
        setDashboardConfig(data);
        console.log("📊 Config dashboards chargée:", Object.keys(data.dashboards || {}).length, "dashboards");
      }
    } catch (e) { console.error("Erreur chargement config dashboards:", e); }
    
    // Charger la liste des collaborateurs
    try {
      const resp = await authFetch(`${API}/config/collaborateurs`);
      if (resp.ok) {
        const data = await resp.json();
        setCollaborateursConfig(data);
        console.log("👥 Collaborateurs chargés:", data.tous_collaborateurs?.length || 0);
      }
    } catch (e) { console.error("Erreur chargement collaborateurs:", e); }
    
    // Stats
    try {
      const resp = await authFetch(`${API}/admin/stats`);
      if (resp.ok) setStats(await resp.json());
    } catch (e) { console.error(e); }
    
    // Config IA
    try {
      const resp = await authFetch(`${API}/admin/ai/config`);
      if (resp.ok) {
        const data = await resp.json();
        setAiConfig(data.current);
        setAvailableModels(data.available_models || {});
        setSelectedProvider(data.current?.provider || "openai");
        setSelectedModel(data.current?.model || "gpt-5.2");
        setAiEnabled(data.current?.enabled !== false);
      }
    } catch (e) { console.error(e); }
    
    // Users
    try {
      const resp = await authFetch(`${API}/admin/users`, {
        headers: { Authorization: `Bearer ${localStorage.getItem("auth_token")}` }
      });
      if (resp.ok) setUsers((await resp.json()).users || []);
    } catch (e) { console.error(e); }
    
    // Teams (équipes)
    try {
      const resp = await authFetch(`${API}/teams`);
      if (resp.ok) setTeams((await resp.json()).teams || []);
    } catch (e) { console.error(e); }
    
    // Integrations
    try {
      const resp = await authFetch(`${API}/admin/integrations`);
      if (resp.ok) setIntegrations((await resp.json()).integrations || []);
    } catch (e) { console.error(e); }
    
    // Prompts
    try {
      const resp = await authFetch(`${API}/admin/prompts`);
      if (resp.ok) setPrompts((await resp.json()).prompts || []);
    } catch (e) { console.error(e); }
    
    // Webhooks
    try {
      const resp = await authFetch(`${API}/admin/webhooks`);
      if (resp.ok) setWebhooks((await resp.json()).webhooks || []);
    } catch (e) { console.error(e); }
    
    // DB Collections
    try {
      const resp = await authFetch(`${API}/admin/db/collections`);
      if (resp.ok) setCollections((await resp.json()).collections || []);
    } catch (e) { console.error(e); }
    
    // Sync Status
    try {
      const resp = await authFetch(`${API}/admin/sync/status`);
      if (resp.ok) setSyncStatus(await resp.json());
    } catch (e) { console.error(e); }
    
    // Agents IA Direction
    try {
      const resp = await authFetch(`${API}/direction/agents`);
      if (resp.ok) setIaDirectors((await resp.json()).agents || []);
    } catch (e) { console.error(e); }
    
    // Direction Summary
    try {
      const resp = await authFetch(`${API}/direction/dashboard-summary`);
      if (resp.ok) setDirectionSummary(await resp.json());
    } catch (e) { console.error(e); }
    
    // Enrichissement Client Config
    try {
      const resp = await authFetch(`${API}/enrichment/config`);
      if (resp.ok) setEnrichmentConfig(await resp.json());
    } catch (e) { console.error(e); }
    
    // Enrichissement Stats
    try {
      const resp = await authFetch(`${API}/enrichment/stats`);
      if (resp.ok) setEnrichmentStats(await resp.json());
    } catch (e) { console.error(e); }
    
    // Enrichissement Historique
    try {
      const resp = await authFetch(`${API}/enrichment/history?limit=20`);
      if (resp.ok) setEnrichmentHistory((await resp.json()).history || []);
    } catch (e) { console.error(e); }
    
    // IMAP Configs
    try {
      const resp = await authFetch(`${API}/imap/configs`);
      if (resp.ok) setImapConfigs((await resp.json()).configs || []);
    } catch (e) { console.error(e); }
    
    // Fetched Emails
    try {
      const resp = await authFetch(`${API}/imap/fetched-emails?limit=20`);
      if (resp.ok) setFetchedEmails((await resp.json()).emails || []);
    } catch (e) { console.error(e); }
    
    // Email History with processing status
    try {
      const resp = await authFetch(`${API}/connectors/email/history?limit=100`);
      if (resp.ok) {
        const data = await resp.json();
        setEmailHistory(data.emails || []);
        setEmailStats(data.stats || { pending: 0, processed: 0, total: 0 });
      }
    } catch (e) { console.error(e); }
    
    // Pending emails count
    try {
      const resp = await authFetch(`${API}/emails/pending-count`);
      if (resp.ok) {
        const data = await resp.json();
        setEmailStats(prev => ({ ...prev, ...data }));
      }
    } catch (e) { console.error(e); }
    
    // Échanges à rattacher
    try {
      const resp = await authFetch(`${API}/exchanges/pending-link`);
      if (resp.ok) setPendingExchanges((await resp.json()).exchanges || []);
    } catch (e) { console.error(e); }
    
    // Factures à valider (Julia)
    try {
      const resp = await authFetch(`${API}/invoices/pending-validation`);
      if (resp.ok) setPendingInvoices((await resp.json()).invoices || []);
    } catch (e) { console.error(e); }
    
    // Factures validées
    try {
      const resp = await authFetch(`${API}/invoices/validated?limit=20`);
      if (resp.ok) setValidatedInvoices((await resp.json()).invoices || []);
    } catch (e) { console.error(e); }
    
    // SMS History
    try {
      const resp = await authFetch(`${API}/connectors/sms/history?limit=30`);
      if (resp.ok) {
        const data = await resp.json();
        setSmsHistory(data.sms || []);
        setSmsStats(data.stats || { total: 0, inbound: 0, outbound: 0 });
      }
    } catch (e) { console.error(e); }
    
    // Calls History
    try {
      const resp = await authFetch(`${API}/connectors/calls/history?limit=30`);
      if (resp.ok) {
        const data = await resp.json();
        setCallsHistory(data.calls || []);
        setCallsStats(data.stats || { total: 0, inbound: 0, outbound: 0, answered: 0 });
      }
    } catch (e) { console.error(e); }
    
    setLoading(false);
  };

  const loadLogs = async () => {
    setLoadingLogs(true);
    try {
      const resp = await authFetch(`${API}/admin/logs?log_type=${logType}&lines=100`);
      if (resp.ok) setLogs((await resp.json()).lines || []);
    } catch (e) { console.error(e); }
    setLoadingLogs(false);
  };

  // Charger la configuration globale des dashboards
  const loadGlobalConfig = async () => {
    setGlobalConfigLoading(true);
    try {
      const resp = await authFetch(`${API}/config/global`);
      if (resp.ok) {
        const data = await resp.json();
        setGlobalConfig(data);
      }
    } catch (e) { console.error("Erreur chargement config globale:", e); }
    setGlobalConfigLoading(false);
  };

  // Sauvegarder une section de la configuration globale
  const saveGlobalConfigSection = async (section, data) => {
    setGlobalConfigSaving(true);
    try {
      const resp = await authFetch(`${API}/config/global/${section}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data)
      });
      if (resp.ok) {
        await loadGlobalConfig();
        alert("✅ Configuration sauvegardée !");
      } else {
        alert("❌ Erreur lors de la sauvegarde");
      }
    } catch (e) { 
      console.error("Erreur sauvegarde config:", e);
      alert("❌ Erreur lors de la sauvegarde");
    }
    setGlobalConfigSaving(false);
  };

  // Charger la configuration widgets/colonnes de tous les dashboards
  const loadDashboardsConfig = async () => {
    setDashboardConfigLoading(true);
    try {
      const resp = await authFetch(`${API}/config/dashboards-config`);
      if (resp.ok) {
        const data = await resp.json();
        setDashboardsConfig(data);
      }
    } catch (e) { console.error("Erreur chargement config dashboards:", e); }
    setDashboardConfigLoading(false);
  };

  // Charger la configuration des champs de la fiche client
  const loadClientFieldsConfig = async () => {
    setClientFieldsLoading(true);
    try {
      const resp = await authFetch(`${API}/config/client-fields`);
      if (resp.ok) {
        const data = await resp.json();
        setClientFieldsConfig(data);
      }
    } catch (e) { 
      console.error("Erreur chargement config champs client:", e); 
    }
    setClientFieldsLoading(false);
  };

  // Sauvegarder la configuration des champs de la fiche client
  const saveClientFieldsConfig = async () => {
    if (!clientFieldsConfig) return;
    setClientFieldsSaving(true);
    try {
      const resp = await authFetch(`${API}/config/client-fields`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(clientFieldsConfig)
      });
      if (resp.ok) {
        alert("Configuration des champs sauvegardée !");
      } else {
        alert("Erreur lors de la sauvegarde");
      }
    } catch (e) { 
      console.error("Erreur sauvegarde config champs client:", e); 
      alert("Erreur lors de la sauvegarde");
    }
    setClientFieldsSaving(false);
  };

  // Toggle un champ client (activer/désactiver)
  const toggleClientField = (categoryId, fieldId) => {
    if (!clientFieldsConfig) return;
    
    setClientFieldsConfig(prev => {
      const newConfig = JSON.parse(JSON.stringify(prev));
      const category = newConfig.categories[categoryId];
      if (category) {
        const field = category.fields.find(f => f.id === fieldId);
        if (field) {
          field.enabled = !field.enabled;
        }
      }
      return newConfig;
    });
  };

  // Charger les données de suivi des formations
  const loadFormationsData = async () => {
    setFormationsLoading(true);
    try {
      const resp = await authFetch(`${API}/admin/formations/collaborators`);
      if (resp.ok) {
        const data = await resp.json();
        setFormationsCollaborators(data.collaborators || []);
        setFormationsStats(data.stats);
      }
    } catch (e) { 
      console.error("Erreur chargement formations:", e); 
    }
    setFormationsLoading(false);
  };

  // Lancer une analyse pour un collaborateur
  const analyzeCollaborator = async (email) => {
    setAnalyzingCollaborator(email);
    try {
      const resp = await authFetch(`${API}/admin/formations/analyze-collaborator/${encodeURIComponent(email)}?limit=5`, {
        method: "POST"
      });
      if (resp.ok) {
        const data = await resp.json();
        if (data.success) {
          setSelectedCollaboratorAnalysis({
            email,
            ...data
          });
          // Rafraîchir les données
          await loadFormationsData();
        } else {
          alert(data.message || "Erreur lors de l'analyse");
        }
      }
    } catch (e) {
      console.error("Erreur analyse:", e);
      alert("Erreur lors de l'analyse");
    }
    setAnalyzingCollaborator(null);
  };

  // Voir l'historique des analyses d'un collaborateur
  const viewCollaboratorAnalyses = async (email) => {
    try {
      const resp = await authFetch(`${API}/admin/formations/collaborator/${encodeURIComponent(email)}/analyses?limit=10`);
      if (resp.ok) {
        const data = await resp.json();
        setSelectedCollaboratorAnalysis(data);
      }
    } catch (e) {
      console.error("Erreur récupération analyses:", e);
    }
  };

  // Sauvegarder la configuration d'un dashboard spécifique
  const saveDashboardConfig = async (dashboardId, config) => {
    setGlobalConfigSaving(true);
    try {
      const resp = await authFetch(`${API}/config/dashboard/${dashboardId}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(config)
      });
      if (resp.ok) {
        await loadDashboardsConfig();
        alert(`✅ Configuration de ${dashboardId} sauvegardée !`);
      } else {
        alert("❌ Erreur lors de la sauvegarde");
      }
    } catch (e) { 
      console.error("Erreur sauvegarde config dashboard:", e);
      alert("❌ Erreur lors de la sauvegarde");
    }
    setGlobalConfigSaving(false);
  };

  // Toggle widget enabled/disabled
  const toggleWidget = (dashboardId, widgetId) => {
    setDashboardsConfig(prev => ({
      ...prev,
      [dashboardId]: {
        ...prev[dashboardId],
        widgets: {
          ...prev[dashboardId]?.widgets,
          [widgetId]: {
            ...prev[dashboardId]?.widgets?.[widgetId],
            enabled: !prev[dashboardId]?.widgets?.[widgetId]?.enabled
          }
        }
      }
    }));
  };

  // Toggle column enabled/disabled
  const toggleColumn = (dashboardId, columnId) => {
    setDashboardsConfig(prev => ({
      ...prev,
      [dashboardId]: {
        ...prev[dashboardId],
        columns: {
          ...prev[dashboardId]?.columns,
          [columnId]: {
            ...prev[dashboardId]?.columns?.[columnId],
            enabled: !prev[dashboardId]?.columns?.[columnId]?.enabled
          }
        }
      }
    }));
  };

  // Update widget/column label
  const updateLabel = (dashboardId, type, itemId, newLabel) => {
    setDashboardsConfig(prev => ({
      ...prev,
      [dashboardId]: {
        ...prev[dashboardId],
        [type]: {
          ...prev[dashboardId]?.[type],
          [itemId]: {
            ...prev[dashboardId]?.[type]?.[itemId],
            label: newLabel
          }
        }
      }
    }));
  };

  useEffect(() => {
    if (activeSection === "logs") loadLogs();
  }, [activeSection, logType]);

  useEffect(() => {
    if (activeSection === "dashboard-config") {
      loadGlobalConfig();
      loadDashboardsConfig();
    }
  }, [activeSection]);

  useEffect(() => {
    if (activeSection === "telepro-config") {
      loadGlobalConfig();
      loadDashboardsConfig();
    };
  }, [activeSection]);

  useEffect(() => {
    if (activeSection === "client-fields-config") {
      loadClientFieldsConfig();
    }
  }, [activeSection]);

  useEffect(() => {
    if (activeSection === "formations-suivi") {
      loadFormationsData();
    }
  }, [activeSection]);

  useEffect(() => {
    if (activeSection === "costs") {
      loadCostData();
      loadServicesConfig();
    }
  }, [activeSection, costPeriod]);

  const loadCostData = async () => {
    setLoadingCosts(true);
    setCostError(null);
    try {
      const resp = await authFetch(`${API}/admin/costs?days=${costPeriod}`);
      if (resp.ok) {
        const data = await resp.json();
        setCostData(data);
      } else {
        setCostError(`Erreur ${resp.status} lors du chargement des coûts`);
      }
    } catch (e) {
      console.error("Erreur chargement dépenses:", e);
      setCostError("Impossible de charger les données de coûts");
    }
    setLoadingCosts(false);
  };

  const loadServicesConfig = async () => {
    try {
      const resp = await authFetch(`${API}/integrations/tenant-config`);
      if (resp.ok) {
        const data = await resp.json();
        setServicesConfig(data.integrations || []);
      }
    } catch (e) {
      console.error("Erreur chargement config services:", e);
    }
  };

  const toggleServiceEnabled = async (integrationId, currentMode) => {
    setTogglingService(integrationId);
    const newMode = currentMode === "disabled" ? "platform" : "disabled";
    try {
      const resp = await authFetch(`${API}/integrations/tenant-config/${integrationId}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ mode: newMode }),
      });
      if (resp.ok) {
        setServicesConfig(prev => prev.map(s => s.id === integrationId ? { ...s, mode: newMode } : s));
      } else {
        const err = await resp.json().catch(() => ({}));
        alert(`Erreur: ${err.detail || `Code ${resp.status}`}`);
      }
    } catch (e) {
      console.error("Erreur toggle service:", e);
      alert("Erreur réseau lors de la modification du service");
    }
    setTogglingService(null);
  };

  const saveAiConfig = async () => {
    setSavingAi(true);
    try {
      await authFetch(`${API}/admin/ai/config`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ provider: selectedProvider, model: selectedModel, enabled: aiEnabled })
      });
      await loadData();
    } catch (e) { console.error(e); }
    setSavingAi(false);
  };

  const addUser = async () => {
    if (!newEmail.trim()) return;
    setAddingUser(true);
    try {
      await authFetch(`${API}/admin/users?email=${encodeURIComponent(newEmail)}&role=${newRole}`, { method: "POST" });
      setNewEmail("");
      await loadData();
    } catch (e) { console.error(e); }
    setAddingUser(false);
  };

  const deleteUser = async (email) => {
    if (!window.confirm(`Supprimer l'accès pour ${email} ?`)) return;
    try {
      await authFetch(`${API}/admin/users/${encodeURIComponent(email)}`, { method: "DELETE" });
      await loadData();
    } catch (e) { console.error(e); }
  };

  // === Fonctions de gestion des équipes ===
  const addTeam = async () => {
    if (!newTeamName.trim()) return;
    setLoadingTeams(true);
    try {
      const resp = await authFetch(`${API}/teams`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          name: newTeamName,
          description: newTeamDescription,
          color: newTeamColor
        })
      });
      if (resp.ok) {
        setNewTeamName("");
        setNewTeamDescription("");
        setNewTeamColor("#6B7280");
        await loadData();
      } else {
        const data = await resp.json();
        alert(data.detail || "Erreur lors de la création");
      }
    } catch (e) { console.error(e); }
    setLoadingTeams(false);
  };

  const updateTeam = async (teamId) => {
    if (!editingTeam) return;
    setLoadingTeams(true);
    try {
      await authFetch(`${API}/teams/${teamId}`, {
        method: "PATCH",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          name: editingTeam.name,
          description: editingTeam.description,
          color: editingTeam.color
        })
      });
      setEditingTeam(null);
      await loadData();
    } catch (e) { console.error(e); }
    setLoadingTeams(false);
  };

  const deleteTeam = async (teamId, teamName) => {
    if (!window.confirm(`Supprimer l'équipe "${teamName}" ? Les utilisateurs seront retirés de cette équipe.`)) return;
    try {
      await authFetch(`${API}/teams/${teamId}`, { method: "DELETE" });
      await loadData();
    } catch (e) { console.error(e); }
  };

  // Fonction pour toggler la visibilité d'une équipe sur le planning
  const toggleTeamVisibility = async (teamId, currentVisibility) => {
    try {
      await authFetch(`${API}/teams/${teamId}/visibility`, {
        method: "PATCH",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ visible: !currentVisibility })
      });
      await loadData();
    } catch (e) { console.error(e); }
  };

  // Fonction pour toggler la visibilité d'un membre sur le planning
  const toggleMemberVisibility = async (teamId, email, currentVisibility) => {
    try {
      await authFetch(`${API}/teams/${teamId}/members/${encodeURIComponent(email)}/visibility`, {
        method: "PATCH",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ visible: !currentVisibility })
      });
      // Recharger les membres pour cette équipe
      loadTeamMembersWithVisibility(teamId);
    } catch (e) { console.error(e); }
  };

  // Charger les membres d'une équipe avec leur visibilité
  const loadTeamMembersWithVisibility = async (teamId) => {
    try {
      const resp = await authFetch(`${API}/teams/${teamId}/members?include_hidden=true`);
      if (resp.ok) {
        const data = await resp.json();
        setTeamMembers(prev => ({ ...prev, [teamId]: data.members || [] }));
      }
    } catch (e) { console.error(e); }
  };

  const saveIntegration = async (id) => {
    try {
      await authFetch(`${API}/admin/integrations/update`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ integration_id: id, value: integrationValue })
      });
      setEditingIntegration(null);
      await loadData();
    } catch (e) { console.error(e); }
  };

  const savePrompt = async (id) => {
    try {
      await authFetch(`${API}/admin/prompts/update`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ prompt_id: id, value: promptValue })
      });
      setEditingPrompt(null);
      await loadData();
    } catch (e) { console.error(e); }
  };

  const saveWebhook = async (id) => {
    try {
      await authFetch(`${API}/admin/webhooks/update`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ webhook_id: id, url: webhookUrl, enabled: webhookEnabled })
      });
      setEditingWebhook(null);
      await loadData();
    } catch (e) { console.error(e); }
  };

  const clearCollection = async (name) => {
    if (!window.confirm(`⚠️ ATTENTION: Supprimer TOUTES les données de "${name}" ?`)) return;
    try {
      await authFetch(`${API}/admin/db/collection/${name}?confirm=true`, { method: "DELETE" });
      await loadData();
    } catch (e) { console.error(e); }
  };

  // === Fonctions Pôle Direction ===
  const openDirectorModal = async (director) => {
    setSelectedDirector({ ...director });
    setShowDirectorModal(true);
    setDirectorModalTab("config");
    setNewObjective("");
    setNewKpi({ name: "", target: "", unit: "" });
    setNewKnowledgeItem({ type: "information", contenu: "" });
    
    // Charger les connaissances et ressources de l'agent
    await loadAgentKnowledgeAndResources(director.director_id);
  };
  
  const loadAgentKnowledgeAndResources = async (directorId) => {
    setLoadingKnowledge(true);
    try {
      const [knowledgeResp, resourcesResp] = await Promise.all([
        authFetch(`${API}/direction/agents/${directorId}/knowledge`),
        authFetch(`${API}/direction/agents/${directorId}/resources`)
      ]);
      
      if (knowledgeResp.ok) {
        const data = await knowledgeResp.json();
        setAgentKnowledge(data.knowledge_base || []);
      }
      
      if (resourcesResp.ok) {
        const data = await resourcesResp.json();
        setAgentResources(data.resources || []);
      }
    } catch (e) {
      console.error("Erreur chargement données agent:", e);
    }
    setLoadingKnowledge(false);
  };

  const closeDirectorModal = () => {
    setShowDirectorModal(false);
    setSelectedDirector(null);
    setDirectorModalTab("config");
    setAgentKnowledge([]);
    setAgentResources([]);
    setUploadProgress(null);
  };

  const toggleDirectorStatus = async (directorId, currentStatus) => {
    const newStatus = currentStatus === "active" ? "paused" : "active";
    try {
      await authFetch(`${API}/direction/agents/${directorId}`, {
        method: "PATCH",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ status: newStatus })
      });
      await loadData();
    } catch (e) { console.error(e); }
  };

  const saveDirectorChanges = async () => {
    if (!selectedDirector) return;
    setSavingDirector(true);
    try {
      await authFetch(`${API}/direction/agents/${selectedDirector.director_id}`, {
        method: "PATCH",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          description: selectedDirector.description,
          objectives: selectedDirector.objectives,
          kpis: selectedDirector.kpis,
          weekly_report_enabled: selectedDirector.weekly_report_enabled
        })
      });
      await loadData();
      closeDirectorModal();
    } catch (e) { console.error(e); }
    setSavingDirector(false);
  };

  const addObjectiveToDirector = () => {
    if (!newObjective.trim() || !selectedDirector) return;
    setSelectedDirector({
      ...selectedDirector,
      objectives: [...(selectedDirector.objectives || []), newObjective.trim()]
    });
    setNewObjective("");
  };

  const removeObjectiveFromDirector = (index) => {
    if (!selectedDirector) return;
    const newObjectives = [...selectedDirector.objectives];
    newObjectives.splice(index, 1);
    setSelectedDirector({ ...selectedDirector, objectives: newObjectives });
  };

  const addKpiToDirector = () => {
    if (!newKpi.name.trim() || !newKpi.target || !newKpi.unit.trim() || !selectedDirector) return;
    setSelectedDirector({
      ...selectedDirector,
      kpis: [...(selectedDirector.kpis || []), { name: newKpi.name, target: parseFloat(newKpi.target), unit: newKpi.unit }]
    });
    setNewKpi({ name: "", target: "", unit: "" });
  };

  const removeKpiFromDirector = (index) => {
    if (!selectedDirector) return;
    const newKpis = [...selectedDirector.kpis];
    newKpis.splice(index, 1);
    setSelectedDirector({ ...selectedDirector, kpis: newKpis });
  };

  // === FONCTIONS ENRICHISSEMENT AGENTS IA ===
  
  const handleFileUpload = async (e, type) => {
    const file = e.target.files?.[0];
    if (!file || !selectedDirector) return;
    
    setUploadingFile(true);
    setUploadProgress({ filename: file.name, status: "uploading", message: "Upload en cours..." });
    
    const formData = new FormData();
    formData.append("file", file);
    formData.append("description", "");
    
    const endpoint = type === "audio" 
      ? `/direction/agents/${selectedDirector.director_id}/upload-audio`
      : `/direction/agents/${selectedDirector.director_id}/upload-document`;
    
    try {
      setUploadProgress({ filename: file.name, status: "processing", message: type === "audio" ? "Transcription Whisper en cours..." : "Analyse du document..." });
      
      const resp = await authFetch(`${API}${endpoint}`, {
        method: "POST",
        body: formData
      });
      
      if (resp.ok) {
        const data = await resp.json();
        setUploadProgress({ 
          filename: file.name, 
          status: "success", 
          message: data.message,
          analysis: data.analysis,
          knowledgeAdded: data.knowledge_items_added
        });
        
        // Recharger les données
        await loadAgentKnowledgeAndResources(selectedDirector.director_id);
      } else {
        const error = await resp.json();
        setUploadProgress({ filename: file.name, status: "error", message: error.detail || "Erreur lors de l'upload" });
      }
    } catch (e) {
      console.error("Erreur upload:", e);
      setUploadProgress({ filename: file.name, status: "error", message: "Erreur réseau" });
    }
    
    setUploadingFile(false);
    e.target.value = ""; // Reset input
  };
  
  const addManualKnowledge = async () => {
    if (!newKnowledgeItem.contenu.trim() || !selectedDirector) return;
    
    try {
      const resp = await authFetch(`${API}/direction/agents/${selectedDirector.director_id}/knowledge`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(newKnowledgeItem)
      });
      
      if (resp.ok) {
        setNewKnowledgeItem({ type: "information", contenu: "" });
        await loadAgentKnowledgeAndResources(selectedDirector.director_id);
      }
    } catch (e) {
      console.error("Erreur ajout connaissance:", e);
    }
  };
  
  const deleteKnowledge = async (index) => {
    if (!selectedDirector) return;
    
    try {
      const resp = await authFetch(`${API}/direction/agents/${selectedDirector.director_id}/knowledge/${index}`, {
        method: "DELETE"
      });
      
      if (resp.ok) {
        await loadAgentKnowledgeAndResources(selectedDirector.director_id);
      }
    } catch (e) {
      console.error("Erreur suppression connaissance:", e);
    }
  };
  
  const deleteResource = async (index) => {
    if (!selectedDirector) return;
    
    try {
      const resp = await authFetch(`${API}/direction/agents/${selectedDirector.director_id}/resources/${index}`, {
        method: "DELETE"
      });
      
      if (resp.ok) {
        await loadAgentKnowledgeAndResources(selectedDirector.director_id);
      }
    } catch (e) {
      console.error("Erreur suppression ressource:", e);
    }
  };
  
  const getKnowledgeTypeIcon = (type) => {
    const icons = {
      bonne_pratique: "✅",
      phrase_cle: "💬",
      fait: "📌",
      decision: "⚖️",
      preference: "⭐",
      action: "🎯",
      information: "ℹ️",
      process: "📋",
      regle: "📜",
      objectif: "🎯",
      conseil: "💡"
    };
    return icons[type] || "📝";
  };
  
  const getKnowledgeTypeLabel = (type) => {
    const labels = {
      bonne_pratique: "Bonne pratique",
      phrase_cle: "Phrase clé",
      fait: "Fait",
      decision: "Décision",
      preference: "Préférence",
      action: "Action",
      information: "Information",
      process: "Process",
      regle: "Règle",
      objectif: "Objectif",
      conseil: "Conseil"
    };
    return labels[type] || type;
  };

  // === FONCTIONS SUPERVISION PDG ===
  
  const loadPdgData = async () => {
    setLoadingPdgData(true);
    try {
      const [notifResp, convResp] = await Promise.all([
        authFetch(`${API}/pdg/notifications`),
        authFetch(`${API}/agents/conversations`)
      ]);
      
      if (notifResp.ok) {
        const data = await notifResp.json();
        setPdgNotifications(data.notifications || []);
        setPdgUnreadCount(data.unread_count || 0);
      }
      
      if (convResp.ok) {
        const data = await convResp.json();
        setAgentConversations(data.conversations || []);
      }
    } catch (e) {
      console.error("Erreur chargement données PDG:", e);
    }
    setLoadingPdgData(false);
  };
  
  const markNotificationsRead = async (notificationIds = null) => {
    try {
      const url = notificationIds 
        ? `${API}/pdg/notifications/mark-read?${notificationIds.map(id => `notification_ids=${id}`).join('&')}`
        : `${API}/pdg/notifications/mark-read`;
      
      const resp = await authFetch(url, { method: "POST" });
      if (resp.ok) {
        await loadPdgData();
      }
    } catch (e) {
      console.error("Erreur marquage notifications:", e);
    }
  };
  
  const createAgentConversation = async () => {
    if (!newConversation.initiator || !newConversation.subject || !newConversation.message || newConversation.participants.length === 0) {
      alert("Veuillez remplir tous les champs");
      return;
    }
    
    setCreatingConversation(true);
    try {
      const params = new URLSearchParams();
      params.append("initiator_id", newConversation.initiator);
      params.append("subject", newConversation.subject);
      params.append("initial_message", newConversation.message);
      newConversation.participants.forEach(p => params.append("participant_ids", p));
      
      const resp = await authFetch(`${API}/agents/conversation?${params.toString()}`, {
        method: "POST"
      });
      
      if (resp.ok) {
        const data = await resp.json();
        setShowNewConversationModal(false);
        setNewConversation({ initiator: "", participants: [], subject: "", message: "" });
        await loadPdgData();
        setSelectedConversation(data);
      } else {
        const error = await resp.json();
        alert(`Erreur: ${error.detail || "Impossible de créer la conversation"}`);
      }
    } catch (e) {
      console.error("Erreur création conversation:", e);
      alert("Erreur réseau");
    }
    setCreatingConversation(false);
  };

  // Charger les données PDG quand on accède aux sections concernées
  useEffect(() => {
    if (activeSection === "pdg-notifications" || activeSection === "agents-conversations") {
      loadPdgData();
    }
    
    // RESET scroll position when section changes
    // Fix for page scrolling issue - reset both window and container scroll
    window.scrollTo(0, 0);
    if (mainContentRef.current) {
      mainContentRef.current.scrollTop = 0;
    }
  }, [activeSection]);

  // Detecter si l'utilisateur est admin plateforme (tenant_default)
  const isPlatformAdmin = authUser?.email === "sdi@sani-adapt.fr" || authUser?.tenant_id === "tenant_default";

  const allMenuItems = [
    // ═══════════════════════════════════════════════════════════
    // 📊 DASHBOARD
    // ═══════════════════════════════════════════════════════════
    { id: "divider-dashboard", type: "divider", label: "📊 Dashboard" },
    { id: "overview", label: "Vue d'ensemble", icon: Database },

    // ═══════════════════════════════════════════════════════════
    // 🔴 ADMIN PLATEFORME (vous seul)
    // ═══════════════════════════════════════════════════════════
    { id: "divider-admin-platform", type: "divider", label: "🔴 Admin Plateforme", adminOnly: true },
    { id: "tenants", label: "Gestion Tenants (SaaS)", icon: CreditCard, adminOnly: true },
    { id: "tenant-permissions", label: "Autorisations Tenants", icon: Shield, adminOnly: true },
    { id: "logs", label: "Logs systeme", icon: Terminal, adminOnly: true },
    { id: "database", label: "Base de donnees", icon: HardDrive, adminOnly: true },
    { id: "webhooks", label: "Webhooks", icon: Webhook, adminOnly: true },
    { id: "scheduler", label: "Scheduler CRON", icon: Clock, adminOnly: true },
    { id: "costs", label: "Depenses IA & API", icon: CreditCard, adminOnly: true },
    { id: "security-dashboard", label: "Security Dashboard", icon: Shield, adminOnly: true },
    { id: "yael-console", label: "Console Yael", icon: Terminal, adminOnly: true },
    { id: "billing-dashboard", label: "Facturation SaaS", icon: CreditCard, adminOnly: true },
    { id: "diagnostic", label: "Diagnostic Distant", icon: Activity, adminOnly: true },

    // ═══════════════════════════════════════════════════════════
    // 👑 SUPERVISION & DIRECTION
    // ═══════════════════════════════════════════════════════════
    { id: "divider-supervision", type: "divider", label: "👑 Supervision & Direction" },
    { id: "direction", label: "Pole Direction SAN-IA", icon: Crown },
    { id: "clones", label: "Clones Numeriques", icon: Brain },
    { id: "pdg-notifications", label: "Notifications PDG", icon: Bell },
    { id: "agents-conversations", label: "Conversations IA", icon: MessageSquare },
    { id: "connection-history", label: "Historique Connexions", icon: Clock },
    { id: "invoices-validation", label: "Factures a valider", icon: FileText },

    // ═══════════════════════════════════════════════════════════
    // 🏠 MA SOCIETE
    // ═══════════════════════════════════════════════════════════
    { id: "divider-societe", type: "divider", label: "🏠 Ma Societe" },
    { id: "societes", label: "Gestion Societes", icon: Building2 },
    { id: "users", label: "Gestion des acces", icon: Users },
    { id: "teams", label: "Gestion des equipes", icon: Users2 },
    { id: "amo-mar", label: "Gestion AMO / MAR", icon: Building2 },
    { id: "dashboards-config", label: "Configuration Dashboards", icon: LayoutDashboard },
    { id: "tarifs-abonnement", label: "Tarifs & Abonnement", icon: CreditCard },

    // ═══════════════════════════════════════════════════════════
    // 📦 CATALOGUE & PRODUITS
    // ═══════════════════════════════════════════════════════════
    { id: "divider-catalogue", type: "divider", label: "Catalogue & Produits" },
    { id: "catalogue-produits", label: "Catalogue Produits", icon: Package },
    { id: "catalogue-devis", label: "Catalogue Devis", icon: Book },
    { id: "tarifs-reno-config", label: "Tarifs Reno Energie", icon: Calculator },
    { id: "elements-declenchement", label: "Elements de Declenchement", icon: Zap },

    // ═══════════════════════════════════════════════════════════
    // ⚙️ CONFIGURATION
    // ═══════════════════════════════════════════════════════════
    { id: "divider-config", type: "divider", label: "Configuration" },
    { id: "pipeline-config", label: "Config Pipeline", icon: ArrowUpDown },
    { id: "pipeline-workflow", label: "Workflow", icon: Zap },
    { id: "socialac-workflow", label: "Workflow SocialAC", icon: Send },
    { id: "client-fields-config", label: "Champs Fiche Client", icon: TableProperties },
    { id: "dynamic-tabs-config", label: "Selections Dynamiques", icon: Layers },
    { id: "payment-conditions-config", label: "Conditions Reglement", icon: CreditCard },
    { id: "sms-config", label: "Config SMS", icon: MessageSquare },
    { id: "telepro-config", label: "Config Telepro", icon: Phone },
    { id: "formulaires-mapping", label: "Formulaires (Mappings)", icon: GitBranch },
    { id: "appels-entrants-config", label: "Appels Entrants", icon: Phone },
    { id: "lead-sources-config", label: "Sources de Lead", icon: Database },
    { id: "statuts-qualification-config", label: "Statuts Qualification", icon: Settings },
    { id: "crm-variables", label: "Variables CRM", icon: Database },
    { id: "integrations", label: "Integrations & Cles", icon: Key },

    // ═══════════════════════════════════════════════════════════
    // 🤖 IA (SAN-IA)
    // ═══════════════════════════════════════════════════════════
    { id: "divider-ia", type: "divider", label: "IA", customIcon: "/san-ia-logo.png" },
    { id: "ai", label: "Configuration IA", icon: Bot },
    { id: "prompts", label: "Prompts IA", icon: MessageSquare },
    { id: "agent-directives", label: "Directives Agent", icon: Bookmark },
    { id: "ia-permissions", label: "Permissions IA", icon: Shield },
    { id: "sania-learning", label: "Apprentissage SAN-IA", icon: Brain },
    { id: "audit-ia", label: "Audit IA", icon: Bot },
    { id: "enrichment", label: "Enrichissement Client", icon: Inbox },

    // ═══════════════════════════════════════════════════════════
    // 📡 CONNECTEURS
    // ═══════════════════════════════════════════════════════════
    { id: "divider-connecteurs", type: "divider", label: "📡 Connecteurs" },
    { id: "connector-email", label: "Connecteur Email", icon: Mail },
    { id: "connector-sms", label: "Connecteur SMS", icon: MessageCircle },
    { id: "connector-whatsapp", label: "Connecteur WhatsApp", icon: Send },
    { id: "connector-sania", label: "Echanges SAN-IA", icon: Brain },
    { id: "connector-fournisseurs", label: "Connecteurs Fournisseurs", icon: Building2 },
    { id: "conversations-history", label: "Historique Conversations", icon: MessageSquare },
    { id: "pending-exchanges", label: "Echanges a rattacher", icon: Link2 },
    { id: "ringover", label: "Administration Ringover", icon: Phone },

    // ═══════════════════════════════════════════════════════════
    // 📁 DOCUMENTS & PROJETS
    // ═══════════════════════════════════════════════════════════
    { id: "divider-documents", type: "divider", label: "📁 Documents & Projets" },
    { id: "ged", label: "GED - Documents", icon: Folder },
    { id: "knowledge-center", label: "Centre de Connaissances", icon: Building2 },
    { id: "project-management", label: "Gestion Projet", icon: Target },

    // ═══════════════════════════════════════════════════════════
    // 🎓 FORMATIONS
    // ═══════════════════════════════════════════════════════════
    { id: "divider-formations", type: "divider", label: "🎓 Formations" },
    { id: "formations-suivi", label: "Suivi Formations", icon: Award },

    // ═══════════════════════════════════════════════════════════
    // ⚡ AUTOMATISATIONS
    // ═══════════════════════════════════════════════════════════
    { id: "divider-automations", type: "divider", label: "⚡ Automatisations" },
    { id: "automations", label: "Automatisations", icon: Zap },
  ];

  // Mapping des dividers vers les IDs de sections de permissions
  const DIVIDER_TO_SECTION = {
    "divider-supervision": "supervision",
    "divider-societe": "societe",
    "divider-catalogue": "catalogue",
    "divider-config": "configuration",
    "divider-ia": "ia",
    "divider-connecteurs": "connecteurs",
    "divider-documents": "documents",
    "divider-formations": "formations",
    "divider-automations": "automatisations",
  };

  // Filtrer les items selon le role (admin plateforme ou tenant) + permissions granulaires
  const menuItems = allMenuItems.filter(item => {
    // Les dividers adminOnly sont masques si pas admin plateforme
    if (item.type === "divider" && item.adminOnly && !isPlatformAdmin) return false;
    // Les items adminOnly sont masques si pas admin plateforme
    if (item.adminOnly && !isPlatformAdmin) return false;

    // Pour les tenants (non admin plateforme), appliquer les permissions granulaires
    if (!isPlatformAdmin && isTenantPermissionsLoaded && Object.keys(tenantPermissions).length > 0) {
      // Le dashboard est toujours visible
      if (item.id === "divider-dashboard" || item.id === "overview") return true;

      // Verifier les dividers de section
      if (item.type === "divider") {
        const sectionId = DIVIDER_TO_SECTION[item.id];
        if (sectionId && tenantPermissions[sectionId] === false) return false;
        return true;
      }

      // Verifier les items individuels
      if (tenantPermissions[item.id] === false) return false;
    }

    return true;
  });

  // Si on est sur la section Ringover, afficher AdminPage
  if (activeSection === "ringover") {
    return (
      <div className="min-h-screen bg-slate-900 text-white flex">
        {/* Sidebar */}
        <div className="w-64 bg-slate-950 border-r border-slate-800 flex flex-col">
          <div className="p-4 border-b border-slate-800">
            <div className="flex items-center gap-3">
              <div className={`w-10 h-10 rounded-lg flex items-center justify-center ${isConsoleAdmin ? 'bg-gradient-to-br from-blue-500 to-cyan-500' : 'bg-gradient-to-br from-red-500 to-orange-500'}`}>
                <Shield className="w-5 h-5 text-white" />
              </div>
              <div>
                <h1 className="font-bold">{isConsoleAdmin ? 'Console Admin' : 'Super Batard 😈'}</h1>
                <p className="text-xs text-slate-400">{isConsoleAdmin ? 'Administration de votre espace' : 'Dashboard Admin'}</p>
              </div>
            </div>
          </div>
          
          <nav className="flex-1 p-4 space-y-1 overflow-y-auto">
            {menuItems.map((item, index) => {
              if (item.type === "divider") {
                const sectionId = item.id;
                const isCollapsed = collapsedSections[sectionId];
                return (
                  <div key={index} className="pt-4 pb-2">
                    <button
                      onClick={() => setCollapsedSections(prev => ({
                        ...prev,
                        [sectionId]: !prev[sectionId]
                      }))}
                      className="w-full flex items-center justify-between text-xs text-slate-500 uppercase tracking-wider px-3 hover:text-slate-300 transition-colors"
                    >
                      <span className="flex items-center gap-2">
                        {item.customIcon ? (
                          <img src={item.customIcon} alt="" className="w-4 h-4 rounded-sm object-contain" />
                        ) : null}
                        {item.label}
                      </span>
                      {isCollapsed ? (
                        <ChevronRight className="w-3 h-3" />
                      ) : (
                        <ChevronDown className="w-3 h-3" />
                      )}
                    </button>
                  </div>
                );
              }
              
              // Trouver la section parente (le divider précédent)
              const parentDividerIndex = menuItems.slice(0, index).reverse().findIndex(m => m.type === "divider");
              const parentDivider = parentDividerIndex >= 0 ? menuItems[index - 1 - parentDividerIndex] : null;
              const isHidden = parentDivider && collapsedSections[parentDivider.id];
              
              if (isHidden) return null;
              
              return (
                <button
                  key={item.id}
                  data-testid={`sb-nav-${item.id}`}
                  onClick={() => setActiveSection(item.id)}
                  className={`w-full flex items-center gap-3 px-4 py-3 rounded-lg transition-all text-sm ${
                    activeSection === item.id 
                      ? "bg-red-500/20 text-red-400 border border-red-500/30" 
                      : "hover:bg-slate-800 text-slate-400"
                  }`}
                >
                  <item.icon className="w-4 h-4" />
                  <span>{item.label}</span>
                </button>
              );
            })}
          </nav>
          
          <div className="p-4 border-t border-slate-800">
            <button 
              onClick={onBack}
              className="w-full flex items-center justify-center gap-2 px-4 py-2 bg-slate-800 hover:bg-slate-700 rounded-lg text-sm"
            >
              <X className="w-4 h-4" />
              Retour au CRM
            </button>
          </div>
        </div>
        
        {/* Main Content - AdminPage embedded */}
        <div className="flex-1 overflow-auto">
          <AdminPage onBack={() => setActiveSection("overview")} embedded={true} />
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-slate-900 text-white flex">
      {/* Sidebar */}
      <div className="w-80 bg-slate-950 border-r border-slate-800 flex flex-col">
        <div className="p-4 border-b border-slate-800">
          <div className="flex items-center gap-3">
            <div className={`w-10 h-10 rounded-lg flex items-center justify-center ${isConsoleAdmin ? 'bg-gradient-to-br from-blue-500 to-cyan-500' : 'bg-gradient-to-br from-red-500 to-orange-500'}`}>
              <Shield className="w-5 h-5 text-white" />
            </div>
            <div>
              <h1 className="font-bold">{isConsoleAdmin ? 'Console Admin' : 'Super Batard 😈'}</h1>
              <p className="text-xs text-slate-400">{isConsoleAdmin ? 'Administration de votre espace' : 'Dashboard Admin'}</p>
            </div>
          </div>
        </div>
        
        <nav className="flex-1 p-3 space-y-0.5 overflow-y-auto">
          {menuItems.map((item, index) => {
            if (item.type === "divider") {
              const sectionId = item.id;
              const isCollapsed = collapsedSections[sectionId];
              return (
                <div key={index} className="pt-5 pb-1.5 first:pt-1">
                  <button
                    onClick={() => setCollapsedSections(prev => ({
                      ...prev,
                      [sectionId]: !prev[sectionId]
                    }))}
                    className="w-full flex items-center justify-between text-[11px] font-bold uppercase tracking-widest px-3 py-2 rounded-lg bg-slate-800/60 border-l-2 border-blue-500 text-slate-300 hover:text-white hover:bg-slate-800 transition-colors"
                  >
                    <span className="flex items-center gap-2">
                      {item.customIcon ? (
                        <img src={item.customIcon} alt="" className="w-4 h-4 rounded-sm object-contain" />
                      ) : null}
                      {item.label}
                    </span>
                    {isCollapsed ? (
                      <ChevronRight className="w-3.5 h-3.5 text-slate-500" />
                    ) : (
                      <ChevronDown className="w-3.5 h-3.5 text-slate-500" />
                    )}
                  </button>
                </div>
              );
            }
            
            // Trouver la section parente (le divider précédent)
            const parentDividerIndex = menuItems.slice(0, index).reverse().findIndex(m => m.type === "divider");
            const parentDivider = parentDividerIndex >= 0 ? menuItems[index - 1 - parentDividerIndex] : null;
            const isHidden = parentDivider && collapsedSections[parentDivider.id];
            
            if (isHidden) return null;
            
            return (
              <button
                key={item.id}
                data-testid={`sb-nav-${item.id}`}
                onClick={() => setActiveSection(item.id)}
                className={`w-full flex items-center gap-3 ml-2 px-3 py-2 rounded-lg transition-all text-sm ${
                  activeSection === item.id 
                    ? "bg-red-500/20 text-red-400 border border-red-500/30" 
                    : "hover:bg-slate-800/70 text-slate-400"
                }`}
              >
                <item.icon className="w-4 h-4 flex-shrink-0" />
                <span className="truncate">{item.label}</span>
              </button>
            );
          })}
        </nav>
        
        <div className="p-4 border-t border-slate-800">
          <button 
            onClick={onBack}
            className="w-full flex items-center justify-center gap-2 px-4 py-2 bg-slate-800 hover:bg-slate-700 rounded-lg text-sm"
          >
            <X className="w-4 h-4" />
            Retour au CRM
          </button>
        </div>
      </div>
      
      {/* Main Content */}
      <div ref={mainContentRef} className="flex-1 overflow-auto">
        <header className="bg-slate-950/50 border-b border-slate-800 px-6 py-4 sticky top-0 z-10 backdrop-blur-sm">
          <div className="flex items-center justify-between">
            <h2 className="text-xl font-semibold flex items-center gap-2">
              {menuItems.find(m => m.id === activeSection)?.icon && 
                <span className="text-red-400">{(() => { const Icon = menuItems.find(m => m.id === activeSection)?.icon; return Icon ? <Icon className="w-5 h-5" /> : null; })()}</span>
              }
              {menuItems.find(m => m.id === activeSection)?.label}
            </h2>
            <button onClick={loadData} className="flex items-center gap-2 px-4 py-2 bg-slate-800 hover:bg-slate-700 rounded-lg text-sm">
              <RefreshCw className={`w-4 h-4 ${loading ? 'animate-spin' : ''}`} />
              Rafraîchir
            </button>
          </div>
        </header>
        
        <main className="p-6">
          {loading ? (
            <div className="flex items-center justify-center py-20">
              <RefreshCw className="w-8 h-8 animate-spin text-slate-500" />
            </div>
          ) : (
            <>
              {/* VUE D'ENSEMBLE */}
              {activeSection === "overview" && stats && (
                <div className="space-y-6">
                  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                    <StatCard icon={Users} label="Utilisateurs" value={stats.users} color="blue" />
                    <StatCard icon={Phone} label="Appels Ringover" value={stats.ringover_calls} color="green" />
                    <StatCard icon={MessageSquare} label="SMS Ringover" value={stats.ringover_sms} color="purple" />
                    <StatCard icon={FileText} label="Transactions CB" value={stats.cb_transactions} color="orange" />
                    <StatCard icon={Link2} label="Liaisons Factures" value={stats.invoice_links} color="cyan" />
                    <StatCard icon={Sparkles} label="IA Active" value={stats.ai_enabled ? "Oui" : "Non"} color={stats.ai_enabled ? "emerald" : "red"} subtitle={stats.ai_model} />
                  </div>
                  
                  {/* Sync Status */}
                  {syncStatus && (
                    <div className="bg-slate-800/50 rounded-xl border border-slate-700/50 p-6">
                      <h3 className="font-semibold mb-4 flex items-center gap-2">
                        <Activity className="w-5 h-5 text-green-400" />
                        Synchronisations
                      </h3>
                      <div className="grid grid-cols-2 gap-4">
                        <div className="bg-slate-900/50 rounded-lg p-4">
                          <div className="flex items-center gap-2 mb-2">
                            <Phone className="w-4 h-4 text-blue-400" />
                            <span className="font-medium">Ringover</span>
                            <span className="ml-auto px-2 py-0.5 bg-green-500/20 text-green-400 rounded text-xs">Auto</span>
                          </div>
                          <p className="text-sm text-slate-400">Intervalle: {syncStatus.ringover?.interval}</p>
                        </div>
                      </div>
                    </div>
                  )}
                  
                  {/* Widget Transcription des appels */}
                  <TranscriptionWidget />
                </div>
              )}

              {/* GESTION DES ACCÈS */}
              {activeSection === "users" && (
                <div className="space-y-6">
                  <div className="bg-slate-800/50 rounded-xl border border-slate-700/50 p-6">
                    <h3 className="font-semibold mb-4 flex items-center gap-2">
                      <Plus className="w-5 h-5 text-green-400" />
                      Ajouter un utilisateur
                    </h3>
                    <div className="flex gap-3">
                      <input type="email" value={newEmail} onChange={(e) => setNewEmail(e.target.value)} placeholder="email@exemple.com" className="flex-1 bg-slate-900 border border-slate-700 rounded-lg px-4 py-2" />
                      <select value={newRole} onChange={(e) => setNewRole(e.target.value)} className="bg-slate-900 border border-slate-700 rounded-lg px-4 py-2">
                        <option value="user">Utilisateur</option>
                        <option value="admin">Administrateur</option>
                      </select>
                      <button onClick={addUser} disabled={addingUser || !newEmail.trim()} className="px-6 py-2 bg-green-600 hover:bg-green-700 disabled:opacity-50 rounded-lg flex items-center gap-2">
                        {addingUser ? <RefreshCw className="w-4 h-4 animate-spin" /> : <Plus className="w-4 h-4" />}
                        Ajouter
                      </button>
                    </div>
                  </div>
                  
                  {/* Légende permissions financières */}
                  <div className="bg-amber-500/10 border border-amber-500/30 rounded-xl p-4">
                    <h4 className="font-medium text-amber-400 mb-3 flex items-center gap-2">
                      <Key className="w-4 h-4" />
                      Permissions financières (cliquez sur un utilisateur pour configurer)
                    </h4>
                    <div className="grid grid-cols-2 md:grid-cols-4 gap-2 text-xs">
                      <span className="px-2 py-1 bg-slate-800 rounded">💰 Montant Devis</span>
                      <span className="px-2 py-1 bg-slate-800 rounded">💵 Montant RAC</span>
                      <span className="px-2 py-1 bg-slate-800 rounded">📥 Encaissements RAC</span>
                      <span className="px-2 py-1 bg-slate-800 rounded">🏦 Acomptes</span>
                      <span className="px-2 py-1 bg-slate-800 rounded">💎 Soldes</span>
                      <span className="px-2 py-1 bg-slate-800 rounded">🔧 Travaux Supp.</span>
                      <span className="px-2 py-1 bg-emerald-800 rounded">✅ Confirmer réception</span>
                    </div>
                  </div>
                  
                  {/* Note importante */}
                  <div className="bg-blue-500/10 border border-blue-500/30 rounded-xl p-4">
                    <p className="text-blue-300 text-sm flex items-center gap-2">
                      <svg className="w-5 h-5 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
                      <span><strong>Note :</strong> Après modification des accès, l'utilisateur doit <strong>rafraîchir sa page (F5)</strong> pour que les changements prennent effet.</span>
                    </p>
                  </div>
                  
                  <div className="bg-slate-800/50 rounded-xl border border-slate-700/50 overflow-hidden">
                    <div className="px-6 py-4 border-b border-slate-700/50">
                      <h3 className="font-semibold">Utilisateurs autorisés ({users.length})</h3>
                    </div>
                    <div className="divide-y divide-slate-700/50">
                      {users.map((user) => (
                        <UserPermissionsRow 
                          key={user.email} 
                          user={user}
                          dashboardConfig={dashboardConfig}
                          onDelete={() => deleteUser(user.email)}
                          onToggleStatus={async (newStatus) => {
                            try {
                              const resp = await authFetch(`${API}/admin/users/${encodeURIComponent(user.email)}/status?is_active=${newStatus}`, {
                                method: "PATCH",
                                credentials: "include",
                                headers: { "Content-Type": "application/json" }
                              });
                              if (resp.ok) {
                                const result = await resp.json();
                                console.log("Statut mis à jour:", result);
                              }
                              await loadData();
                            } catch (e) { console.error(e); }
                          }}
                          onUpdatePermissions={async (perms, dashAccess, planningPerms) => {
                            try {
                              const resp = await authFetch(`${API}/admin/users/${encodeURIComponent(user.email)}/permissions`, {
                                method: "PATCH",
                                credentials: "include",
                                headers: { "Content-Type": "application/json" },
                                body: JSON.stringify({
                                  finance_permissions: perms,
                                  dashboard_access: dashAccess,
                                  planning_permissions: planningPerms
                                })
                              });
                              if (resp.ok) {
                                console.log("Permissions sauvegardées:", { dashAccess, planningPerms });
                              }
                              await loadData();
                            } catch (e) { console.error(e); }
                          }}
                          onUpdateProfile={async (aliasesData, whatsappPhone, linkedAmoId) => {
                            try {
                              const resp = await authFetch(`${API}/admin/users/${encodeURIComponent(user.email)}/profile`, {
                                method: "PATCH",
                                credentials: "include",
                                headers: { "Content-Type": "application/json" },
                                body: JSON.stringify({ aliases: aliasesData, whatsapp_phone: whatsappPhone, linked_amo_id: linkedAmoId || null })
                              });
                              if (resp.ok) {
                                console.log("Profil sauvegardé:", { aliases: aliasesData, whatsapp_phone: whatsappPhone });
                              }
                              await loadData();
                            } catch (e) { console.error(e); }
                          }}
                          collaborateursConfig={collaborateursConfig}
                          onRefreshCollabs={refreshCollaborateurs}
                          imapConfigs={imapConfigs}
                        />
                      ))}
                    </div>
                  </div>
                </div>
              )}

              {/* GESTION DES ÉQUIPES */}
              {activeSection === "teams" && (
                <div className="space-y-6">
                  {/* Header */}
                  <div className="bg-gradient-to-r from-blue-500/20 via-purple-500/20 to-amber-500/20 rounded-xl border border-blue-500/30 p-6">
                    <div className="flex items-center justify-between">
                      <div className="flex items-center gap-4">
                        <div className="w-16 h-16 bg-gradient-to-br from-blue-500 to-purple-500 rounded-2xl flex items-center justify-center">
                          <Users2 className="w-8 h-8 text-white" />
                        </div>
                        <div>
                          <h2 className="text-2xl font-bold text-white">Gestion des Équipes</h2>
                          <p className="text-blue-300">
                            Créez et gérez les équipes de votre organisation
                          </p>
                        </div>
                      </div>
                      <button 
                        onClick={loadData}
                        disabled={loadingTeams}
                        className="px-4 py-2 bg-blue-600 hover:bg-blue-500 rounded-lg flex items-center gap-2"
                      >
                        <RefreshCw className={`w-4 h-4 ${loadingTeams ? 'animate-spin' : ''}`} />
                        Rafraîchir
                      </button>
                    </div>
                  </div>

                  {/* Formulaire d'ajout d'équipe */}
                  <div className="bg-slate-800/50 rounded-xl border border-slate-700/50 p-6">
                    <h3 className="font-semibold mb-4 flex items-center gap-2">
                      <Plus className="w-5 h-5 text-green-400" />
                      Créer une nouvelle équipe
                    </h3>
                    <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
                      <div>
                        <label className="block text-xs text-slate-400 mb-1">Nom de l'équipe *</label>
                        <input
                          type="text"
                          value={newTeamName}
                          onChange={(e) => setNewTeamName(e.target.value)}
                          placeholder="Ex: Commerciaux Terrain"
                          className="w-full bg-slate-900 border border-slate-700 rounded-lg px-4 py-2"
                        />
                      </div>
                      <div>
                        <label className="block text-xs text-slate-400 mb-1">Description</label>
                        <input
                          type="text"
                          value={newTeamDescription}
                          onChange={(e) => setNewTeamDescription(e.target.value)}
                          placeholder="Description de l'équipe"
                          className="w-full bg-slate-900 border border-slate-700 rounded-lg px-4 py-2"
                        />
                      </div>
                      <div>
                        <label className="block text-xs text-slate-400 mb-1">Couleur (liseré planning)</label>
                        <div className="flex gap-2">
                          <input
                            type="color"
                            value={newTeamColor}
                            onChange={(e) => setNewTeamColor(e.target.value)}
                            className="w-12 h-10 bg-slate-900 border border-slate-700 rounded-lg cursor-pointer"
                          />
                          <input
                            type="text"
                            value={newTeamColor}
                            onChange={(e) => setNewTeamColor(e.target.value)}
                            className="flex-1 bg-slate-900 border border-slate-700 rounded-lg px-3 py-2 font-mono text-sm"
                          />
                        </div>
                      </div>
                      <div className="flex items-end">
                        <button
                          onClick={addTeam}
                          disabled={loadingTeams || !newTeamName.trim()}
                          className="w-full px-6 py-2 bg-green-600 hover:bg-green-700 disabled:opacity-50 rounded-lg flex items-center justify-center gap-2"
                        >
                          {loadingTeams ? <RefreshCw className="w-4 h-4 animate-spin" /> : <Plus className="w-4 h-4" />}
                          Créer l'équipe
                        </button>
                      </div>
                    </div>
                  </div>

                  {/* Note explicative */}
                  <div className="bg-blue-500/10 border border-blue-500/30 rounded-xl p-4">
                    <div className="flex items-start gap-3">
                      <Info className="w-5 h-5 text-blue-400 mt-0.5" />
                      <div className="text-sm">
                        <p className="font-medium text-blue-400 mb-1">À propos des équipes</p>
                        <p className="text-slate-400">
                          Chaque équipe a une <strong className="text-white">couleur de liseré</strong> visible sur le planning. 
                          Les équipes apparaissent dans le <strong className="text-white">Profil Collaborateur</strong> de la gestion des accès.
                          Les équipes marquées <strong className="text-amber-400">📊 Google Sheet</strong> sont liées à une colonne du fichier de suivi.
                        </p>
                      </div>
                    </div>
                  </div>

                  {/* Liste des équipes */}
                  <div className="bg-slate-800/50 rounded-xl border border-slate-700/50 overflow-hidden">
                    <div className="px-6 py-4 border-b border-slate-700/50 flex items-center justify-between">
                      <h3 className="font-semibold flex items-center gap-2">
                        <Users2 className="w-5 h-5 text-blue-400" />
                        Équipes ({teams.length})
                      </h3>
                      <span className="text-xs text-slate-400">
                        Cliquez sur une équipe pour gérer les membres
                      </span>
                    </div>
                    <div className="divide-y divide-slate-700/50">
                      {teams.length === 0 ? (
                        <div className="px-6 py-8 text-center text-slate-400">
                          <Users2 className="w-12 h-12 mx-auto mb-3 opacity-50" />
                          <p>Aucune équipe</p>
                          <p className="text-sm">Créez votre première équipe ci-dessus</p>
                        </div>
                      ) : (
                        teams.map((team) => {
                          const isExpanded = expandedTeams[team.id];
                          const members = teamMembers[team.id] || [];
                          const isTeamVisible = team.visible_planning !== false; // Visible par défaut
                          
                          return (
                            <div key={team.id} className={`${!isTeamVisible ? 'opacity-60' : ''}`}>
                              {editingTeam?.id === team.id ? (
                                /* Mode édition */
                                <div className="px-6 py-4 flex items-center gap-4">
                                  <div
                                    className="w-4 h-12 rounded"
                                    style={{ backgroundColor: editingTeam.color }}
                                  />
                                  <div className="flex-1 grid grid-cols-4 gap-3">
                                    <input
                                      type="text"
                                      value={editingTeam.name}
                                      onChange={(e) => setEditingTeam({ ...editingTeam, name: e.target.value })}
                                      className="bg-slate-900 border border-slate-600 rounded-lg px-3 py-2"
                                    />
                                    <input
                                      type="text"
                                      value={editingTeam.description}
                                      onChange={(e) => setEditingTeam({ ...editingTeam, description: e.target.value })}
                                      className="bg-slate-900 border border-slate-600 rounded-lg px-3 py-2"
                                    />
                                    <div className="flex gap-2">
                                      <input
                                        type="color"
                                        value={editingTeam.color}
                                        onChange={(e) => setEditingTeam({ ...editingTeam, color: e.target.value })}
                                        className="w-10 h-10 bg-slate-900 border border-slate-600 rounded cursor-pointer"
                                      />
                                      <input
                                        type="text"
                                        value={editingTeam.color}
                                        onChange={(e) => setEditingTeam({ ...editingTeam, color: e.target.value })}
                                        className="flex-1 bg-slate-900 border border-slate-600 rounded-lg px-2 py-2 font-mono text-xs"
                                      />
                                    </div>
                                    <div className="flex gap-2">
                                      <button
                                        onClick={() => updateTeam(team.id)}
                                        className="flex-1 px-3 py-2 bg-green-600 hover:bg-green-500 rounded-lg flex items-center justify-center gap-1"
                                      >
                                        <Save className="w-4 h-4" />
                                        Sauver
                                      </button>
                                      <button
                                        onClick={() => setEditingTeam(null)}
                                        className="px-3 py-2 bg-slate-700 hover:bg-slate-600 rounded-lg"
                                      >
                                        <X className="w-4 h-4" />
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              ) : (
                                /* Mode affichage */
                                <>
                                  <div 
                                    className="px-6 py-4 flex items-center justify-between cursor-pointer hover:bg-slate-700/30"
                                    onClick={() => {
                                      const newExpanded = { ...expandedTeams, [team.id]: !isExpanded };
                                      setExpandedTeams(newExpanded);
                                      if (!isExpanded) {
                                        loadTeamMembersWithVisibility(team.id);
                                      }
                                    }}
                                  >
                                    <div className="flex items-center gap-4">
                                      <ChevronDown className={`w-4 h-4 text-slate-400 transition-transform ${isExpanded ? 'rotate-180' : ''}`} />
                                      <div
                                        className="w-4 h-12 rounded"
                                        style={{ backgroundColor: team.color }}
                                        title={`Couleur: ${team.color}`}
                                      />
                                      <div>
                                        <h4 className="font-medium text-white flex items-center gap-2">
                                          {team.name || team.label}
                                          {team.has_sheet_column && (
                                            <span className="px-2 py-0.5 bg-amber-500/20 text-amber-400 rounded text-xs" title="Lié à une colonne Google Sheet">
                                              📊 Google Sheet
                                            </span>
                                          )}
                                          {!isTeamVisible && (
                                            <span className="px-2 py-0.5 bg-red-500/20 text-red-400 rounded text-xs">
                                              Masqué du planning
                                            </span>
                                          )}
                                        </h4>
                                        <p className="text-sm text-slate-400">{team.description || "Aucune description"}</p>
                                      </div>
                                    </div>
                                    <div className="flex items-center gap-3" onClick={(e) => e.stopPropagation()}>
                                      {/* Toggle visibilité planning */}
                                      <button
                                        onClick={() => toggleTeamVisibility(team.id, isTeamVisible)}
                                        className={`px-3 py-1.5 rounded-lg text-xs flex items-center gap-2 transition-colors ${
                                          isTeamVisible
                                            ? 'bg-emerald-500/20 text-emerald-400 hover:bg-emerald-500/30'
                                            : 'bg-slate-700 text-slate-400 hover:bg-slate-600'
                                        }`}
                                        title={isTeamVisible ? "Visible sur le planning" : "Masqué du planning"}
                                      >
                                        {isTeamVisible ? <Eye className="w-3 h-3" /> : <EyeOff className="w-3 h-3" />}
                                        Planning
                                      </button>
                                      <span className="px-2 py-1 bg-slate-700 rounded text-xs text-slate-300 font-mono">
                                        {team.id}
                                      </span>
                                      <button
                                        onClick={() => setEditingTeam(team)}
                                        className="p-2 hover:bg-slate-700 rounded-lg text-slate-400 hover:text-white"
                                        title="Modifier"
                                      >
                                        <Edit2 className="w-4 h-4" />
                                      </button>
                                      <button
                                        onClick={() => deleteTeam(team.id, team.name || team.label)}
                                        className="p-2 hover:bg-red-600/20 rounded-lg text-slate-400 hover:text-red-400"
                                        title="Supprimer"
                                      >
                                        <Trash2 className="w-4 h-4" />
                                      </button>
                                    </div>
                                  </div>
                                  
                                  {/* Section membres (expandable) */}
                                  {isExpanded && (
                                    <div className="px-6 py-4 bg-slate-900/50 border-t border-slate-700/50">
                                      <div className="ml-8">
                                        <div className="flex items-center gap-2 mb-3">
                                          <Users className="w-4 h-4 text-slate-400" />
                                          <span className="text-sm text-slate-400">
                                            Membres ({members.length})
                                          </span>
                                          {!isTeamVisible && (
                                            <span className="text-xs text-red-400">(équipe masquée du planning)</span>
                                          )}
                                        </div>
                                        {members.length > 0 ? (
                                          <div className="space-y-2">
                                            {members.map(member => {
                                              const isMemberVisible = member.visible_planning !== false;
                                              return (
                                                <div 
                                                  key={member.email}
                                                  className={`flex items-center justify-between px-4 py-2 bg-slate-800/50 rounded-lg border border-slate-700/50 ${!isMemberVisible ? 'opacity-50' : ''}`}
                                                >
                                                  <div className="flex items-center gap-3">
                                                    <div className="w-8 h-8 bg-slate-700 rounded-full flex items-center justify-center">
                                                      <User className="w-4 h-4 text-slate-400" />
                                                    </div>
                                                    <div>
                                                      <p className="text-sm font-medium text-white">{member.alias}</p>
                                                      <p className="text-xs text-slate-500">{member.name || member.email}</p>
                                                    </div>
                                                  </div>
                                                  <button
                                                    onClick={() => toggleMemberVisibility(team.id, member.email, isMemberVisible)}
                                                    className={`px-3 py-1.5 rounded-lg text-xs flex items-center gap-2 transition-colors ${
                                                      isMemberVisible
                                                        ? 'bg-emerald-500/20 text-emerald-400 hover:bg-emerald-500/30'
                                                        : 'bg-red-500/20 text-red-400 hover:bg-red-500/30'
                                                    }`}
                                                    title={isMemberVisible ? "Visible sur le planning" : "Masqué du planning"}
                                                  >
                                                    {isMemberVisible ? <Eye className="w-3 h-3" /> : <EyeOff className="w-3 h-3" />}
                                                    {isMemberVisible ? 'Visible' : 'Masqué'}
                                                  </button>
                                                </div>
                                              );
                                            })}
                                          </div>
                                        ) : (
                                          <p className="text-sm text-slate-500 italic">
                                            Aucun membre - Affectez via le Profil Collaborateur dans "Gestion des accès"
                                          </p>
                                        )}
                                      </div>
                                    </div>
                                  )}
                                </>
                              )}
                            </div>
                          );
                        })
                      )}
                    </div>
                  </div>
                </div>
              )}

              {/* GESTION AMO / MAR */}
              {activeSection === "amo-mar" && (
                <AmoMarManager />
              )}

              {/* GESTION TENANTS (SaaS) */}
              {activeSection === "tenants" && (
                <TenantsManager />
              )}

              {/* AUTORISATIONS TENANTS */}
              {activeSection === "tenant-permissions" && (
                <TenantPermissionsManager />
              )}

              {/* GESTION SOCIETES */}
              {activeSection === "societes" && (
                <SocietesManager />
              )}

              {/* CATALOGUE PRODUITS */}
              {activeSection === "catalogue-produits" && (
                <CatalogueProduitsAdmin />
              )}

              {/* CATALOGUE DEVIS */}
              {activeSection === "catalogue-devis" && (
                <CatalogueDevisSection />
              )}

              {/* WIDGETS REGISTRY */}
              {activeSection === "widgets-registry" && (
                <WidgetRegistryManager />
              )}

              {/* HISTORIQUE DES CONNEXIONS */}
              {activeSection === "connection-history" && (
                <ConnectionHistory />
              )}

              {/* PROJECT HUB - Centre de Connaissances */}
              {activeSection === "knowledge-center" && (
                <ProjectKnowledgeCenter />
              )}

              {/* PROJECT HUB - Gestion Projet */}
              {activeSection === "project-management" && (
                <ProjectManagement />
              )}

              {/* PROJECT HUB - Audit IA */}
              {activeSection === "audit-ia" && (
                <ProjectAuditIA />
              )}

              {/* PROJECT HUB - Directives Agent */}
              {activeSection === "agent-directives" && (
                <AgentDirectives />
              )}

              {/* GED - GESTION ÉLECTRONIQUE DES DOCUMENTS */}
              {activeSection === "ged" && (
                <GedDashboard authUser={{ email: "admin@sani-adapt.fr", role: "admin" }} />
              )}

              {/* SUIVI FORMATIONS ADMIN */}
              {activeSection === "formations-suivi" && (
                <div className="space-y-6">
                  {/* Header */}
                  <div className="bg-gradient-to-r from-indigo-500/20 via-purple-500/20 to-pink-500/20 rounded-xl border border-indigo-500/30 p-6">
                    <div className="flex items-center justify-between">
                      <div className="flex items-center gap-4">
                        <div className="w-16 h-16 bg-gradient-to-br from-indigo-500 to-purple-500 rounded-2xl flex items-center justify-center">
                          <Award className="w-8 h-8 text-white" />
                        </div>
                        <div>
                          <h2 className="text-2xl font-bold text-white">Suivi des Formations</h2>
                          <p className="text-indigo-300">
                            Analyse des appels et progression des collaborateurs
                          </p>
                        </div>
                      </div>
                      <button 
                        onClick={loadFormationsData}
                        disabled={formationsLoading}
                        className="px-4 py-2 bg-indigo-600 hover:bg-indigo-500 rounded-lg flex items-center gap-2"
                      >
                        <RefreshCw className={`w-4 h-4 ${formationsLoading ? 'animate-spin' : ''}`} />
                        Rafraîchir
                      </button>
                    </div>
                  </div>

                  {/* Stats globales */}
                  {formationsStats && (
                    <div className="grid grid-cols-4 gap-4">
                      <div className="bg-slate-800/50 border border-slate-700/50 rounded-xl p-4">
                        <div className="flex items-center gap-3 mb-2">
                          <Users className="w-5 h-5 text-blue-400" />
                          <span className="text-slate-400">Utilisateurs</span>
                        </div>
                        <p className="text-2xl font-bold">{formationsStats.total_users}</p>
                      </div>
                      <div className="bg-slate-800/50 border border-slate-700/50 rounded-xl p-4">
                        <div className="flex items-center gap-3 mb-2">
                          <Phone className="w-5 h-5 text-green-400" />
                          <span className="text-slate-400">Avec alias Ringover</span>
                        </div>
                        <p className="text-2xl font-bold">{formationsStats.users_with_ringover}</p>
                      </div>
                      <div className="bg-slate-800/50 border border-slate-700/50 rounded-xl p-4">
                        <div className="flex items-center gap-3 mb-2">
                          <Brain className="w-5 h-5 text-purple-400" />
                          <span className="text-slate-400">Analyses réalisées</span>
                        </div>
                        <p className="text-2xl font-bold">{formationsStats.total_analyses}</p>
                      </div>
                      <div className="bg-slate-800/50 border border-slate-700/50 rounded-xl p-4">
                        <div className="flex items-center gap-3 mb-2">
                          <MessageSquare className="w-5 h-5 text-amber-400" />
                          <span className="text-slate-400">Appels transcrits</span>
                        </div>
                        <p className="text-2xl font-bold">{formationsStats.total_calls_transcribed}</p>
                      </div>
                    </div>
                  )}

                  {/* Info importante */}
                  <div className="bg-amber-500/10 border border-amber-500/30 rounded-xl p-4">
                    <div className="flex items-start gap-3">
                      <Info className="w-5 h-5 text-amber-400 mt-0.5" />
                      <div className="text-sm">
                        <p className="font-medium text-amber-400 mb-1">Configuration requise</p>
                        <p className="text-slate-400">
                          Pour que l'analyse des appels fonctionne, chaque utilisateur doit avoir son <strong className="text-white">Identifiant Ringover</strong> configuré dans la <strong className="text-white">Gestion des accès</strong>. 
                          Cet identifiant permet d'associer les appels Ringover à chaque collaborateur.
                        </p>
                      </div>
                    </div>
                  </div>

                  {/* Modal d'analyse */}
                  {selectedCollaboratorAnalysis && (
                    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
                      <div className="bg-slate-900 border border-slate-700 rounded-xl max-w-3xl w-full max-h-[80vh] overflow-hidden">
                        <div className="p-4 border-b border-slate-700 flex items-center justify-between">
                          <div>
                            <h3 className="font-semibold text-lg">
                              {selectedCollaboratorAnalysis.analyses ? "Historique des analyses" : "Analyse des appels"}
                            </h3>
                            <p className="text-sm text-slate-400">
                              {selectedCollaboratorAnalysis.user_name || selectedCollaboratorAnalysis.collaborator || selectedCollaboratorAnalysis.email}
                              {selectedCollaboratorAnalysis.ringover_name && (
                                <span className="ml-2 text-indigo-400">({selectedCollaboratorAnalysis.ringover_name})</span>
                              )}
                            </p>
                          </div>
                          <button 
                            onClick={() => setSelectedCollaboratorAnalysis(null)}
                            className="p-2 hover:bg-slate-700 rounded-lg"
                          >
                            <X className="w-5 h-5" />
                          </button>
                        </div>
                        <div className="p-4 overflow-y-auto max-h-[60vh]">
                          {selectedCollaboratorAnalysis.analyses ? (
                            // Historique des analyses
                            <div className="space-y-4">
                              {selectedCollaboratorAnalysis.analyses.length === 0 ? (
                                <p className="text-slate-400 text-center py-8">Aucune analyse disponible</p>
                              ) : (
                                selectedCollaboratorAnalysis.analyses.map((analysis, idx) => (
                                  <div key={idx} className="bg-slate-800/50 rounded-lg p-4">
                                    <div className="flex items-center justify-between mb-2">
                                      <span className="text-sm text-slate-400">
                                        {analysis.created_at ? new Date(analysis.created_at).toLocaleString('fr-FR') : 'Date inconnue'}
                                      </span>
                                      <span className="text-xs bg-indigo-500/20 text-indigo-400 px-2 py-1 rounded">
                                        {analysis.calls_analyzed} appels analysés
                                      </span>
                                    </div>
                                    <div className="prose prose-invert prose-sm max-w-none">
                                      <div className="whitespace-pre-wrap text-slate-300">{analysis.analysis}</div>
                                    </div>
                                  </div>
                                ))
                              )}
                            </div>
                          ) : (
                            // Résultat d'une nouvelle analyse
                            <div className="space-y-4">
                              <div className="flex items-center gap-2 text-emerald-400">
                                <CheckCircle className="w-5 h-5" />
                                <span>{selectedCollaboratorAnalysis.calls_analyzed} appels analysés</span>
                              </div>
                              <div className="prose prose-invert prose-sm max-w-none bg-slate-800/50 rounded-lg p-4">
                                <div className="whitespace-pre-wrap text-slate-300">{selectedCollaboratorAnalysis.analysis}</div>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  )}

                  {/* Liste des collaborateurs */}
                  <div className="bg-slate-800/50 border border-slate-700/50 rounded-xl overflow-hidden">
                    <div className="px-6 py-4 border-b border-slate-700/50">
                      <h3 className="font-semibold">Collaborateurs ({formationsCollaborators.length})</h3>
                    </div>
                    
                    {formationsLoading ? (
                      <div className="p-8 flex items-center justify-center">
                        <RefreshCw className="w-6 h-6 animate-spin text-slate-500" />
                      </div>
                    ) : (
                      <div className="divide-y divide-slate-700/50">
                        {formationsCollaborators.map((collab) => (
                          <div key={collab.email} className="p-4 hover:bg-slate-800/30 transition-colors">
                            <div className="flex items-center justify-between">
                              <div className="flex items-center gap-4">
                                <div className={`w-10 h-10 rounded-full flex items-center justify-center ${
                                  collab.has_ringover_alias ? 'bg-emerald-500/20' : 'bg-slate-700'
                                }`}>
                                  <User className={`w-5 h-5 ${collab.has_ringover_alias ? 'text-emerald-400' : 'text-slate-400'}`} />
                                </div>
                                <div>
                                  <p className="font-medium">{collab.name}</p>
                                  <p className="text-sm text-slate-400">{collab.email}</p>
                                </div>
                              </div>
                              
                              <div className="flex items-center gap-6">
                                {/* Identifiant Ringover */}
                                <div className="text-center">
                                  <p className={`text-sm font-medium ${collab.has_ringover_alias ? 'text-emerald-400' : 'text-amber-400'}`}>
                                    {collab.ringover_name || "Non configuré"}
                                  </p>
                                  <p className="text-xs text-slate-500">Ringover</p>
                                </div>
                                
                                {/* Appels transcrits */}
                                <div className="text-center min-w-[80px]">
                                  <p className="text-lg font-bold text-blue-400">{collab.calls_transcribed}</p>
                                  <p className="text-xs text-slate-500">Appels</p>
                                </div>
                                
                                {/* Dernière analyse */}
                                <div className="text-center min-w-[100px]">
                                  {collab.last_analysis ? (
                                    <>
                                      <p className="text-sm text-purple-400">
                                        {new Date(collab.last_analysis.date).toLocaleDateString('fr-FR')}
                                      </p>
                                      <p className="text-xs text-slate-500">{collab.last_analysis.calls_analyzed} appels</p>
                                    </>
                                  ) : (
                                    <p className="text-sm text-slate-500">Jamais</p>
                                  )}
                                </div>
                                
                                {/* Actions */}
                                <div className="flex gap-2">
                                  <button
                                    onClick={() => viewCollaboratorAnalyses(collab.email)}
                                    className="px-3 py-1.5 bg-slate-700 hover:bg-slate-600 rounded-lg text-sm flex items-center gap-1"
                                    title="Voir l'historique"
                                  >
                                    <History className="w-4 h-4" />
                                  </button>
                                  <button
                                    onClick={() => analyzeCollaborator(collab.email)}
                                    disabled={analyzingCollaborator === collab.email || collab.calls_transcribed === 0}
                                    className={`px-3 py-1.5 rounded-lg text-sm flex items-center gap-1 ${
                                      collab.calls_transcribed === 0 
                                        ? 'bg-slate-700 text-slate-500 cursor-not-allowed' 
                                        : 'bg-indigo-600 hover:bg-indigo-500'
                                    }`}
                                    title={collab.calls_transcribed === 0 ? "Aucun appel transcrit" : "Lancer une analyse"}
                                  >
                                    {analyzingCollaborator === collab.email ? (
                                      <RefreshCw className="w-4 h-4 animate-spin" />
                                    ) : (
                                      <Brain className="w-4 h-4" />
                                    )}
                                    Analyser
                                  </button>
                                </div>
                              </div>
                            </div>
                            
                            {/* Aperçu dernière analyse */}
                            {collab.last_analysis?.preview && (
                              <div className="mt-3 ml-14 p-3 bg-slate-900/50 rounded-lg">
                                <p className="text-xs text-slate-400 mb-1">Dernière analyse :</p>
                                <p className="text-sm text-slate-300">{collab.last_analysis.preview}</p>
                              </div>
                            )}
                          </div>
                        ))}
                        
                        {formationsCollaborators.length === 0 && !formationsLoading && (
                          <div className="p-8 text-center text-slate-500">
                            Aucun collaborateur trouvé
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              )}

              {/* PERMISSIONS DES DIRECTEURS IA */}
              {activeSection === "ia-permissions" && (
                <IAPermissionsDashboard />
              )}

              {/* CLONES NUMERIQUES */}
              {activeSection === "clones" && (
                <CloneSpace />
              )}

              {/* PÔLE DIRECTION SAN-IA */}
              {activeSection === "direction" && (
                <div className="space-y-6">
                  {/* Header avec stats */}
                  <div className="bg-gradient-to-r from-amber-500/20 via-orange-500/20 to-red-500/20 rounded-xl border border-amber-500/30 p-6">
                    <div className="flex items-center justify-between">
                      <div className="flex items-center gap-4">
                        <div className="w-16 h-16 bg-gradient-to-br from-amber-500 to-orange-500 rounded-2xl flex items-center justify-center">
                          <Crown className="w-8 h-8 text-white" />
                        </div>
                        <div>
                          <h2 className="text-2xl font-bold text-white">Pôle Direction SAN-IA</h2>
                          <p className="text-amber-300">
                            {directionSummary ? `${directionSummary.total_agents} Responsables IA • ${directionSummary.active_agents} actifs` : 'Chargement...'}
                          </p>
                        </div>
                      </div>
                      {directionSummary && (
                        <div className="flex gap-4">
                          <div className="text-center">
                            <p className="text-2xl font-bold text-emerald-400">{directionSummary.total_kpis}</p>
                            <p className="text-xs text-slate-400">KPIs définis</p>
                          </div>
                          <div className="text-center">
                            <p className="text-2xl font-bold text-blue-400">{directionSummary.total_objectives}</p>
                            <p className="text-xs text-slate-400">Objectifs</p>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>

                  {/* Missions du Pôle Direction */}
                  <div className="bg-slate-800/50 rounded-xl border border-slate-700/50 p-5">
                    <h3 className="font-semibold mb-4 flex items-center gap-2">
                      <Target className="w-5 h-5 text-amber-400" />
                      Missions des Responsables IA
                    </h3>
                    <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
                      <div className="bg-slate-900/50 rounded-lg p-3 text-center">
                        <Activity className="w-6 h-6 text-blue-400 mx-auto mb-2" />
                        <p className="text-sm text-slate-300">Surveiller l'activité</p>
                      </div>
                      <div className="bg-slate-900/50 rounded-lg p-3 text-center">
                        <Calendar className="w-6 h-6 text-green-400 mx-auto mb-2" />
                        <p className="text-sm text-slate-300">Bilans hebdomadaires</p>
                      </div>
                      <div className="bg-slate-900/50 rounded-lg p-3 text-center">
                        <TrendingUp className="w-6 h-6 text-purple-400 mx-auto mb-2" />
                        <p className="text-sm text-slate-300">Monter en compétences</p>
                      </div>
                      <div className="bg-slate-900/50 rounded-lg p-3 text-center">
                        <Award className="w-6 h-6 text-amber-400 mx-auto mb-2" />
                        <p className="text-sm text-slate-300">Définir les objectifs</p>
                      </div>
                    </div>
                  </div>

                  {/* Grille des Responsables IA */}
                  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                    {iaDirectors.map(director => {
                      const colorClasses = {
                        blue: "from-blue-500/20 to-blue-600/10 border-blue-500/30",
                        yellow: "from-yellow-500/20 to-yellow-600/10 border-yellow-500/30",
                        purple: "from-purple-500/20 to-purple-600/10 border-purple-500/30",
                        indigo: "from-indigo-500/20 to-indigo-600/10 border-indigo-500/30",
                        orange: "from-orange-500/20 to-orange-600/10 border-orange-500/30",
                        emerald: "from-emerald-500/20 to-emerald-600/10 border-emerald-500/30",
                        pink: "from-pink-500/20 to-pink-600/10 border-pink-500/30",
                        cyan: "from-cyan-500/20 to-cyan-600/10 border-cyan-500/30",
                        red: "from-red-500/20 to-red-600/10 border-red-500/30",
                      };
                      
                      const isComingSoon = director.status === 'coming_soon';
                      const isPaused = director.status === 'paused';
                      
                      return (
                        <div 
                          key={director.director_id} 
                          className={`bg-gradient-to-br ${colorClasses[director.color] || colorClasses.blue} border rounded-xl p-5 relative ${isComingSoon ? 'opacity-60' : ''} ${isPaused ? 'opacity-75' : ''}`}
                        >
                          {/* Badge de statut */}
                          <div className="absolute top-3 right-3 flex gap-1">
                            {isComingSoon && (
                              <span className="px-2 py-0.5 bg-slate-700 text-slate-400 rounded text-xs">Bientôt</span>
                            )}
                            {isPaused && (
                              <span className="px-2 py-0.5 bg-amber-500/20 text-amber-400 rounded text-xs flex items-center gap-1">
                                <Pause className="w-3 h-3" /> En pause
                              </span>
                            )}
                            {director.status === 'active' && (
                              <span className="px-2 py-0.5 bg-emerald-500/20 text-emerald-400 rounded text-xs flex items-center gap-1">
                                <Play className="w-3 h-3" /> Actif
                              </span>
                            )}
                          </div>

                          <div className="flex items-start gap-4 mb-4">
                            <div className="text-4xl">{director.avatar}</div>
                            <div>
                              <h4 className="font-bold text-white">{director.name}</h4>
                              <p className="text-sm text-slate-400">{director.pole}</p>
                            </div>
                          </div>
                          <p className="text-sm text-slate-300 mb-4">{director.description}</p>
                          
                          {/* KPIs */}
                          {director.kpis && director.kpis.length > 0 && (
                            <div className="mb-3 space-y-1">
                              <p className="text-xs text-slate-500 uppercase tracking-wider flex items-center gap-1">
                                <BarChart3 className="w-3 h-3" /> KPIs
                              </p>
                              {director.kpis.slice(0, 2).map((kpi, i) => (
                                <div key={i} className="flex items-center justify-between text-xs bg-slate-900/30 rounded px-2 py-1">
                                  <span className="text-slate-400">{kpi.name}</span>
                                  <span className="text-emerald-400 font-medium">{kpi.target} {kpi.unit}</span>
                                </div>
                              ))}
                              {director.kpis.length > 2 && (
                                <p className="text-xs text-slate-500">+{director.kpis.length - 2} autres KPIs</p>
                              )}
                            </div>
                          )}

                          {/* Objectifs */}
                          <div className="space-y-2">
                            <p className="text-xs text-slate-500 uppercase tracking-wider">Objectifs clés</p>
                            {(director.objectives || []).slice(0, 3).map((obj, i) => (
                              <div key={i} className="flex items-start gap-2 text-xs text-slate-400">
                                <Check className="w-3 h-3 text-green-400 mt-0.5 flex-shrink-0" />
                                <span>{obj}</span>
                              </div>
                            ))}
                          </div>

                          {/* Boutons d'action */}
                          {!isComingSoon && (
                            <div className="mt-4 flex gap-2">
                              <button 
                                onClick={() => openDirectorModal(director)}
                                className="flex-1 px-3 py-2 bg-slate-800/80 hover:bg-slate-700/80 rounded-lg text-sm flex items-center justify-center gap-2 transition-colors"
                              >
                                <Brain className="w-4 h-4" />
                                Configurer
                              </button>
                              <button 
                                onClick={() => toggleDirectorStatus(director.director_id, director.status)}
                                className={`px-3 py-2 rounded-lg text-sm transition-colors ${
                                  director.status === 'active' 
                                    ? 'bg-amber-500/20 hover:bg-amber-500/30 text-amber-400' 
                                    : 'bg-emerald-500/20 hover:bg-emerald-500/30 text-emerald-400'
                                }`}
                                title={director.status === 'active' ? 'Mettre en pause' : 'Activer'}
                              >
                                {director.status === 'active' ? <Pause className="w-4 h-4" /> : <Play className="w-4 h-4" />}
                              </button>
                            </div>
                          )}
                        </div>
                      );
                    })}
                  </div>

                  {/* Info */}
                  <div className="bg-amber-500/10 border border-amber-500/30 rounded-xl p-4">
                    <div className="flex items-start gap-3">
                      <Sparkles className="w-5 h-5 text-amber-400 mt-0.5" />
                      <div className="text-sm">
                        <p className="font-medium text-amber-400 mb-1">Configuration des agents IA</p>
                        <p className="text-slate-400">
                          Cliquez sur "Configurer" pour définir les objectifs, KPIs et seuils d'alerte de chaque agent.
                          Les agents actifs surveillent leur pôle et génèrent des alertes automatiquement.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {/* MODAL CONFIGURATION AGENT IA - ENRICHI */}
              {showDirectorModal && selectedDirector && (
                <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 backdrop-blur-sm">
                  <div className="bg-slate-900 border border-slate-700 rounded-2xl w-full max-w-4xl max-h-[90vh] overflow-hidden flex flex-col">
                    {/* Header */}
                    <div className="p-6 border-b border-slate-700">
                      <div className="flex items-center justify-between mb-4">
                        <div className="flex items-center gap-4">
                          <span className="text-4xl">{selectedDirector.avatar}</span>
                          <div>
                            <h3 className="text-xl font-bold">{selectedDirector.name}</h3>
                            <p className="text-sm text-slate-400">{selectedDirector.pole}</p>
                          </div>
                        </div>
                        <button onClick={closeDirectorModal} className="p-2 hover:bg-slate-800 rounded-lg">
                          <X className="w-5 h-5" />
                        </button>
                      </div>
                      
                      {/* Onglets */}
                      <div className="flex gap-2">
                        <button
                          onClick={() => setDirectorModalTab("config")}
                          className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
                            directorModalTab === "config" 
                              ? "bg-emerald-600 text-white" 
                              : "bg-slate-800 text-slate-400 hover:bg-slate-700"
                          }`}
                        >
                          <Settings className="w-4 h-4 inline mr-2" />
                          Configuration
                        </button>
                        <button
                          onClick={() => setDirectorModalTab("knowledge")}
                          className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
                            directorModalTab === "knowledge" 
                              ? "bg-purple-600 text-white" 
                              : "bg-slate-800 text-slate-400 hover:bg-slate-700"
                          }`}
                        >
                          <Brain className="w-4 h-4 inline mr-2" />
                          Base de Connaissances ({agentKnowledge.length})
                        </button>
                        <button
                          onClick={() => setDirectorModalTab("resources")}
                          className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
                            directorModalTab === "resources" 
                              ? "bg-blue-600 text-white" 
                              : "bg-slate-800 text-slate-400 hover:bg-slate-700"
                          }`}
                        >
                          <FileText className="w-4 h-4 inline mr-2" />
                          Ressources ({agentResources.length})
                        </button>
                        {/* Onglet Expertise Comptable - uniquement pour Rachel */}
                        {selectedDirector.director_id === "compta" && (
                          <button
                            onClick={() => setDirectorModalTab("accounting")}
                            className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
                              directorModalTab === "accounting" 
                                ? "bg-emerald-600 text-white" 
                                : "bg-slate-800 text-slate-400 hover:bg-slate-700"
                            }`}
                          >
                            <Calculator className="w-4 h-4 inline mr-2" />
                            Expertise Comptable
                          </button>
                        )}
                        {/* Onglet Configuration Christelle - uniquement pour Christelle */}
                        {selectedDirector.director_id === "ged_emails" && (
                          <button
                            onClick={() => setDirectorModalTab("christelle")}
                            className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
                              directorModalTab === "christelle" 
                                ? "bg-pink-600 text-white" 
                                : "bg-slate-800 text-slate-400 hover:bg-slate-700"
                            }`}
                          >
                            <Mic className="w-4 h-4 inline mr-2" />
                            Recherche & Planification
                          </button>
                        )}
                      </div>
                    </div>

                    {/* Content - Onglet Configuration */}
                    {directorModalTab === "config" && (
                      <div className="flex-1 overflow-y-auto p-6 space-y-6">
                        {/* Description */}
                        <div>
                          <label className="block text-sm font-medium text-slate-400 mb-2">Description</label>
                          <textarea
                            value={selectedDirector.description}
                            onChange={(e) => setSelectedDirector({ ...selectedDirector, description: e.target.value })}
                            className="w-full bg-slate-800 border border-slate-700 rounded-lg px-4 py-3 text-sm"
                            rows={2}
                          />
                        </div>

                        {/* Objectifs */}
                        <div>
                          <label className="block text-sm font-medium text-slate-400 mb-2">
                            Objectifs ({(selectedDirector.objectives || []).length})
                          </label>
                          <div className="space-y-2 mb-3">
                            {(selectedDirector.objectives || []).map((obj, i) => (
                              <div key={i} className="flex items-center gap-2 bg-slate-800 rounded-lg px-3 py-2">
                                <Check className="w-4 h-4 text-green-400" />
                                <span className="flex-1 text-sm">{obj}</span>
                                <button onClick={() => removeObjectiveFromDirector(i)} className="p-1 hover:bg-red-500/20 rounded text-red-400">
                                  <Trash2 className="w-4 h-4" />
                                </button>
                              </div>
                            ))}
                          </div>
                          <div className="flex gap-2">
                            <input
                              type="text"
                              value={newObjective}
                              onChange={(e) => setNewObjective(e.target.value)}
                              placeholder="Nouvel objectif..."
                              className="flex-1 bg-slate-800 border border-slate-700 rounded-lg px-3 py-2 text-sm"
                              onKeyPress={(e) => e.key === 'Enter' && addObjectiveToDirector()}
                            />
                            <button onClick={addObjectiveToDirector} className="px-4 py-2 bg-emerald-600 hover:bg-emerald-700 rounded-lg text-sm flex items-center gap-2">
                              <Plus className="w-4 h-4" /> Ajouter
                            </button>
                          </div>
                        </div>

                        {/* KPIs */}
                        <div>
                          <label className="block text-sm font-medium text-slate-400 mb-2">
                            KPIs ({(selectedDirector.kpis || []).length})
                          </label>
                          <div className="space-y-2 mb-3">
                            {(selectedDirector.kpis || []).map((kpi, i) => (
                              <div key={i} className="flex items-center gap-3 bg-slate-800 rounded-lg px-3 py-2">
                                <BarChart3 className="w-4 h-4 text-blue-400" />
                                <span className="flex-1 text-sm">{kpi.name}</span>
                                <span className="text-emerald-400 font-medium text-sm">{kpi.target} {kpi.unit}</span>
                                <button onClick={() => removeKpiFromDirector(i)} className="p-1 hover:bg-red-500/20 rounded text-red-400">
                                  <Trash2 className="w-4 h-4" />
                                </button>
                              </div>
                            ))}
                          </div>
                          <div className="flex gap-2">
                            <input
                              type="text"
                              value={newKpi.name}
                              onChange={(e) => setNewKpi({ ...newKpi, name: e.target.value })}
                              placeholder="Nom du KPI"
                              className="flex-1 bg-slate-800 border border-slate-700 rounded-lg px-3 py-2 text-sm"
                            />
                            <input
                              type="number"
                              value={newKpi.target}
                              onChange={(e) => setNewKpi({ ...newKpi, target: e.target.value })}
                              placeholder="Cible"
                              className="w-24 bg-slate-800 border border-slate-700 rounded-lg px-3 py-2 text-sm"
                            />
                            <input
                              type="text"
                              value={newKpi.unit}
                              onChange={(e) => setNewKpi({ ...newKpi, unit: e.target.value })}
                              placeholder="Unité"
                              className="w-24 bg-slate-800 border border-slate-700 rounded-lg px-3 py-2 text-sm"
                            />
                            <button onClick={addKpiToDirector} className="px-4 py-2 bg-blue-600 hover:bg-blue-700 rounded-lg text-sm">
                              <Plus className="w-4 h-4" />
                            </button>
                          </div>
                        </div>

                        {/* Options */}
                        <div className="bg-slate-800/50 rounded-lg p-4">
                          <label className="flex items-center justify-between cursor-pointer">
                            <div>
                              <p className="font-medium">Rapports hebdomadaires</p>
                              <p className="text-sm text-slate-400">Génère un rapport automatique chaque semaine</p>
                            </div>
                            <div className="relative">
                              <input
                                type="checkbox"
                                checked={selectedDirector.weekly_report_enabled}
                                onChange={(e) => setSelectedDirector({ ...selectedDirector, weekly_report_enabled: e.target.checked })}
                                className="sr-only peer"
                              />
                              <div className="w-11 h-6 bg-slate-700 rounded-full peer peer-checked:bg-emerald-600 after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:after:translate-x-full"></div>
                            </div>
                          </label>
                        </div>
                      </div>
                    )}

                    {/* Content - Onglet Base de Connaissances */}
                    {directorModalTab === "knowledge" && (
                      <div className="flex-1 overflow-y-auto p-6 space-y-6">
                        {loadingKnowledge ? (
                          <div className="flex items-center justify-center py-12">
                            <RefreshCw className="w-8 h-8 animate-spin text-purple-400" />
                          </div>
                        ) : (
                          <>
                            {/* Ajouter manuellement */}
                            <div className="bg-purple-500/10 border border-purple-500/30 rounded-xl p-4">
                              <h4 className="font-semibold text-purple-400 mb-3 flex items-center gap-2">
                                <Plus className="w-4 h-4" /> Ajouter une connaissance
                              </h4>
                              <div className="flex gap-3">
                                <select
                                  value={newKnowledgeItem.type}
                                  onChange={(e) => setNewKnowledgeItem({ ...newKnowledgeItem, type: e.target.value })}
                                  className="bg-slate-800 border border-slate-700 rounded-lg px-3 py-2 text-sm"
                                >
                                  <option value="information">ℹ️ Information</option>
                                  <option value="fait">📌 Fait</option>
                                  <option value="process">📋 Process</option>
                                  <option value="regle">📜 Règle</option>
                                  <option value="objectif">🎯 Objectif</option>
                                  <option value="conseil">💡 Conseil</option>
                                  <option value="bonne_pratique">✅ Bonne pratique</option>
                                  <option value="phrase_cle">💬 Phrase clé</option>
                                </select>
                                <input
                                  type="text"
                                  value={newKnowledgeItem.contenu}
                                  onChange={(e) => setNewKnowledgeItem({ ...newKnowledgeItem, contenu: e.target.value })}
                                  placeholder="Contenu de la connaissance..."
                                  className="flex-1 bg-slate-800 border border-slate-700 rounded-lg px-3 py-2 text-sm"
                                  onKeyPress={(e) => e.key === 'Enter' && addManualKnowledge()}
                                />
                                <button 
                                  onClick={addManualKnowledge}
                                  className="px-4 py-2 bg-purple-600 hover:bg-purple-700 rounded-lg text-sm"
                                >
                                  Ajouter
                                </button>
                              </div>
                            </div>

                            {/* Liste des connaissances */}
                            <div>
                              <h4 className="font-semibold text-slate-300 mb-3">
                                Connaissances apprises ({agentKnowledge.length})
                              </h4>
                              {agentKnowledge.length === 0 ? (
                                <div className="text-center py-8 text-slate-500">
                                  <Brain className="w-12 h-12 mx-auto mb-3 opacity-30" />
                                  <p>Aucune connaissance enregistrée</p>
                                  <p className="text-sm">Ajoutez des connaissances manuellement ou uploadez des fichiers</p>
                                </div>
                              ) : (
                                <div className="space-y-2 max-h-[400px] overflow-y-auto">
                                  {agentKnowledge.map((item, i) => (
                                    <div 
                                      key={i} 
                                      className="flex items-start gap-3 bg-slate-800/50 rounded-lg p-3 group hover:bg-slate-800"
                                    >
                                      <span className="text-lg">{getKnowledgeTypeIcon(item.type)}</span>
                                      <div className="flex-1 min-w-0">
                                        <div className="flex items-center gap-2 mb-1">
                                          <span className="text-xs px-2 py-0.5 bg-slate-700 rounded text-slate-400">
                                            {getKnowledgeTypeLabel(item.type)}
                                          </span>
                                          <span className="text-xs text-slate-500">{item.date}</span>
                                          {item.source && (
                                            <span className="text-xs text-blue-400/70">📎 {item.source}</span>
                                          )}
                                        </div>
                                        <p className="text-sm text-slate-300">{item.contenu}</p>
                                      </div>
                                      <button 
                                        onClick={() => deleteKnowledge(i)}
                                        className="p-1 opacity-0 group-hover:opacity-100 hover:bg-red-500/20 rounded text-red-400 transition-opacity"
                                      >
                                        <Trash2 className="w-4 h-4" />
                                      </button>
                                    </div>
                                  ))}
                                </div>
                              )}
                            </div>
                          </>
                        )}
                      </div>
                    )}

                    {/* Content - Onglet Ressources (Upload) */}
                    {directorModalTab === "resources" && (
                      <div className="flex-1 overflow-y-auto p-6 space-y-6">
                        {/* Zone d'upload */}
                        <div className="grid grid-cols-2 gap-4">
                          {/* Upload Audio */}
                          <div className="bg-gradient-to-br from-orange-500/10 to-red-500/10 border border-orange-500/30 rounded-xl p-5">
                            <div className="flex items-center gap-3 mb-4">
                              <div className="w-10 h-10 bg-orange-500/20 rounded-lg flex items-center justify-center">
                                🎤
                              </div>
                              <div>
                                <h4 className="font-semibold text-orange-400">Fichiers Audio</h4>
                                <p className="text-xs text-slate-400">Appels téléphoniques à analyser</p>
                              </div>
                            </div>
                            <p className="text-xs text-slate-500 mb-3">
                              MP3, WAV, M4A, OGG, FLAC (max 25 MB)
                            </p>
                            <label className="block">
                              <input
                                type="file"
                                accept=".mp3,.wav,.m4a,.ogg,.flac,.webm,.mp4,.mpeg,.mpga"
                                onChange={(e) => handleFileUpload(e, "audio")}
                                disabled={uploadingFile}
                                className="hidden"
                              />
                              <span className={`block w-full py-3 px-4 border-2 border-dashed border-orange-500/50 rounded-lg text-center cursor-pointer hover:bg-orange-500/10 transition-colors ${uploadingFile ? 'opacity-50 cursor-not-allowed' : ''}`}>
                                {uploadingFile ? (
                                  <span className="flex items-center justify-center gap-2">
                                    <RefreshCw className="w-4 h-4 animate-spin" />
                                    Analyse en cours...
                                  </span>
                                ) : (
                                  <span className="text-orange-400">
                                    <Plus className="w-4 h-4 inline mr-1" />
                                    Uploader un audio
                                  </span>
                                )}
                              </span>
                            </label>
                          </div>

                          {/* Upload Document */}
                          <div className="bg-gradient-to-br from-blue-500/10 to-cyan-500/10 border border-blue-500/30 rounded-xl p-5">
                            <div className="flex items-center gap-3 mb-4">
                              <div className="w-10 h-10 bg-blue-500/20 rounded-lg flex items-center justify-center">
                                📄
                              </div>
                              <div>
                                <h4 className="font-semibold text-blue-400">Documents</h4>
                                <p className="text-xs text-slate-400">Process, fiches, guides</p>
                              </div>
                            </div>
                            <p className="text-xs text-slate-500 mb-3">
                              TXT, PDF, MD, CSV, JSON (max 10 MB)
                            </p>
                            <label className="block">
                              <input
                                type="file"
                                accept=".txt,.pdf,.md,.csv,.json"
                                onChange={(e) => handleFileUpload(e, "document")}
                                disabled={uploadingFile}
                                className="hidden"
                              />
                              <span className={`block w-full py-3 px-4 border-2 border-dashed border-blue-500/50 rounded-lg text-center cursor-pointer hover:bg-blue-500/10 transition-colors ${uploadingFile ? 'opacity-50 cursor-not-allowed' : ''}`}>
                                {uploadingFile ? (
                                  <span className="flex items-center justify-center gap-2">
                                    <RefreshCw className="w-4 h-4 animate-spin" />
                                    Analyse en cours...
                                  </span>
                                ) : (
                                  <span className="text-blue-400">
                                    <Plus className="w-4 h-4 inline mr-1" />
                                    Uploader un document
                                  </span>
                                )}
                              </span>
                            </label>
                          </div>
                        </div>

                        {/* Progression/Résultat upload */}
                        {uploadProgress && (
                          <div className={`rounded-xl p-4 ${
                            uploadProgress.status === 'success' ? 'bg-emerald-500/10 border border-emerald-500/30' :
                            uploadProgress.status === 'error' ? 'bg-red-500/10 border border-red-500/30' :
                            'bg-blue-500/10 border border-blue-500/30'
                          }`}>
                            <div className="flex items-center gap-3 mb-2">
                              {uploadProgress.status === 'uploading' && <RefreshCw className="w-5 h-5 animate-spin text-blue-400" />}
                              {uploadProgress.status === 'processing' && <Brain className="w-5 h-5 animate-pulse text-purple-400" />}
                              {uploadProgress.status === 'success' && <Check className="w-5 h-5 text-emerald-400" />}
                              {uploadProgress.status === 'error' && <AlertTriangle className="w-5 h-5 text-red-400" />}
                              <span className="font-medium">{uploadProgress.filename}</span>
                            </div>
                            <p className="text-sm text-slate-300">{uploadProgress.message}</p>
                            
                            {uploadProgress.analysis && uploadProgress.status === 'success' && (
                              <div className="mt-3 pt-3 border-t border-slate-700 space-y-4">
                                {/* Résumé et note */}
                                <div className="flex items-center justify-between">
                                  <p className="text-sm font-medium text-emerald-400">
                                    ✅ {uploadProgress.knowledgeAdded} éléments ajoutés
                                  </p>
                                  {uploadProgress.analysis.note_qualite && (
                                    <div className="flex items-center gap-2">
                                      <span className="text-xs text-slate-400">Note qualité:</span>
                                      <span className={`px-2 py-0.5 rounded text-sm font-bold ${
                                        uploadProgress.analysis.note_qualite >= 8 ? 'bg-emerald-500/20 text-emerald-400' :
                                        uploadProgress.analysis.note_qualite >= 5 ? 'bg-yellow-500/20 text-yellow-400' :
                                        'bg-red-500/20 text-red-400'
                                      }`}>
                                        {uploadProgress.analysis.note_qualite}/10
                                      </span>
                                      {uploadProgress.analysis.rdv_obtenu !== null && (
                                        <span className={`px-2 py-0.5 rounded text-xs ${
                                          uploadProgress.analysis.rdv_obtenu ? 'bg-emerald-500/20 text-emerald-400' : 'bg-red-500/20 text-red-400'
                                        }`}>
                                          {uploadProgress.analysis.rdv_obtenu ? '✅ RDV obtenu' : '❌ Pas de RDV'}
                                        </span>
                                      )}
                                    </div>
                                  )}
                                </div>

                                {/* Résumé de l'appel */}
                                {uploadProgress.analysis.resume && (
                                  <div className="bg-slate-800/50 rounded-lg p-3">
                                    <p className="text-xs font-medium text-slate-400 mb-1">📋 Résumé de l'appel</p>
                                    <p className="text-sm text-slate-300">{uploadProgress.analysis.resume}</p>
                                  </div>
                                )}

                                {/* Bonnes pratiques */}
                                {uploadProgress.analysis.bonnes_pratiques && uploadProgress.analysis.bonnes_pratiques.length > 0 && (
                                  <div className="bg-emerald-500/5 border border-emerald-500/20 rounded-lg p-3">
                                    <p className="text-xs font-medium text-emerald-400 mb-2">✅ Bonnes pratiques identifiées ({uploadProgress.analysis.bonnes_pratiques.length})</p>
                                    <ul className="space-y-1">
                                      {uploadProgress.analysis.bonnes_pratiques.map((pratique, idx) => (
                                        <li key={idx} className="text-sm text-slate-300 flex items-start gap-2">
                                          <span className="text-emerald-400 mt-0.5">•</span>
                                          <span>{pratique}</span>
                                        </li>
                                      ))}
                                    </ul>
                                  </div>
                                )}

                                {/* Phrases clés */}
                                {uploadProgress.analysis.phrases_cles && uploadProgress.analysis.phrases_cles.length > 0 && (
                                  <div className="bg-blue-500/5 border border-blue-500/20 rounded-lg p-3">
                                    <p className="text-xs font-medium text-blue-400 mb-2">💬 Phrases clés réutilisables ({uploadProgress.analysis.phrases_cles.length})</p>
                                    <ul className="space-y-1">
                                      {uploadProgress.analysis.phrases_cles.map((phrase, idx) => (
                                        <li key={idx} className="text-sm text-slate-300 flex items-start gap-2">
                                          <span className="text-blue-400 mt-0.5">"</span>
                                          <span className="italic">{phrase}</span>
                                        </li>
                                      ))}
                                    </ul>
                                  </div>
                                )}

                                {/* Points d'amélioration */}
                                {uploadProgress.analysis.points_amelioration && uploadProgress.analysis.points_amelioration.length > 0 && (
                                  <div className="bg-orange-500/5 border border-orange-500/20 rounded-lg p-3">
                                    <p className="text-xs font-medium text-orange-400 mb-2">⚠️ Points d'amélioration ({uploadProgress.analysis.points_amelioration.length})</p>
                                    <ul className="space-y-1">
                                      {uploadProgress.analysis.points_amelioration.map((point, idx) => (
                                        <li key={idx} className="text-sm text-slate-300 flex items-start gap-2">
                                          <span className="text-orange-400 mt-0.5">•</span>
                                          <span>{point}</span>
                                        </li>
                                      ))}
                                    </ul>
                                  </div>
                                )}

                                {/* Connaissances extraites (pour documents) */}
                                {uploadProgress.analysis.connaissances && uploadProgress.analysis.connaissances.length > 0 && (
                                  <div className="bg-purple-500/5 border border-purple-500/20 rounded-lg p-3">
                                    <p className="text-xs font-medium text-purple-400 mb-2">🧠 Connaissances extraites ({uploadProgress.analysis.connaissances.length})</p>
                                    <ul className="space-y-1">
                                      {uploadProgress.analysis.connaissances.map((item, idx) => (
                                        <li key={idx} className="text-sm text-slate-300 flex items-start gap-2">
                                          <span className="px-1.5 py-0.5 bg-slate-700 rounded text-xs text-slate-400">{item.type}</span>
                                          <span>{item.contenu}</span>
                                        </li>
                                      ))}
                                    </ul>
                                  </div>
                                )}
                              </div>
                            )}
                          </div>
                        )}

                        {/* Liste des ressources */}
                        <div>
                          <h4 className="font-semibold text-slate-300 mb-3">
                            Ressources uploadées ({agentResources.length})
                          </h4>
                          {loadingKnowledge ? (
                            <div className="flex items-center justify-center py-8">
                              <RefreshCw className="w-6 h-6 animate-spin text-slate-500" />
                            </div>
                          ) : agentResources.length === 0 ? (
                            <div className="text-center py-8 text-slate-500">
                              <FileText className="w-12 h-12 mx-auto mb-3 opacity-30" />
                              <p>Aucune ressource uploadée</p>
                              <p className="text-sm">Uploadez des fichiers audio ou documents pour enrichir l'agent</p>
                            </div>
                          ) : (
                            <div className="space-y-2">
                              {agentResources.map((resource, i) => (
                                <div 
                                  key={i}
                                  className="flex items-center gap-3 bg-slate-800/50 rounded-lg p-3 group hover:bg-slate-800"
                                >
                                  <span className="text-2xl">
                                    {resource.type === 'audio' ? '🎤' : '📄'}
                                  </span>
                                  <div className="flex-1 min-w-0">
                                    <p className="font-medium text-sm truncate">{resource.filename}</p>
                                    <div className="flex items-center gap-2 text-xs text-slate-500">
                                      <span>{resource.file_size_mb} MB</span>
                                      <span>•</span>
                                      <span>{new Date(resource.uploaded_at).toLocaleDateString('fr-FR')}</span>
                                      {resource.analysis?.note_qualite && (
                                        <>
                                          <span>•</span>
                                          <span className="text-emerald-400">Note: {resource.analysis.note_qualite}/10</span>
                                        </>
                                      )}
                                    </div>
                                  </div>
                                  <button 
                                    onClick={() => deleteResource(i)}
                                    className="p-2 opacity-0 group-hover:opacity-100 hover:bg-red-500/20 rounded text-red-400 transition-opacity"
                                  >
                                    <Trash2 className="w-4 h-4" />
                                  </button>
                                </div>
                              ))}
                            </div>
                          )}
                        </div>
                      </div>
                    )}

                    {/* Content - Onglet Expertise Comptable (Rachel uniquement) */}
                    {directorModalTab === "accounting" && selectedDirector.director_id === "compta" && (
                      <div className="flex-1 overflow-y-auto p-6">
                        <RachelAccountingPanel />
                      </div>
                    )}

                    {/* Content - Onglet Recherche & Planification (Christelle uniquement) */}
                    {directorModalTab === "christelle" && selectedDirector.director_id === "ged_emails" && (
                      <div className="flex-1 overflow-y-auto p-6">
                        <ChristelleConfigPanel />
                      </div>
                    )}

                    {/* Footer */}
                    <div className="p-6 border-t border-slate-700 flex justify-end gap-3">
                      <button onClick={closeDirectorModal} className="px-6 py-2 bg-slate-700 hover:bg-slate-600 rounded-lg">
                        Fermer
                      </button>
                      {directorModalTab === "config" && (
                        <button 
                          onClick={saveDirectorChanges} 
                          disabled={savingDirector}
                          className="px-6 py-2 bg-emerald-600 hover:bg-emerald-700 disabled:opacity-50 rounded-lg flex items-center gap-2"
                        >
                          {savingDirector ? <RefreshCw className="w-4 h-4 animate-spin" /> : <Save className="w-4 h-4" />}
                          Sauvegarder
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              )}

              {/* APPRENTISSAGE SAN-IA */}
              {activeSection === "sania-learning" && (
                <SaniaLearningSection />
              )}

              {/* NOTIFICATIONS PDG */}
              {activeSection === "pdg-notifications" && (
                <div className="space-y-6">
                  {/* Header */}
                  <div className="bg-gradient-to-br from-amber-500/10 to-orange-500/10 border border-amber-500/30 rounded-xl p-6">
                    <div className="flex items-center justify-between">
                      <div className="flex items-center gap-4">
                        <div className="w-14 h-14 bg-gradient-to-br from-amber-500 to-orange-500 rounded-xl flex items-center justify-center">
                          <Bell className="w-7 h-7 text-white" />
                        </div>
                        <div>
                          <h2 className="text-xl font-bold">Notifications PDG</h2>
                          <p className="text-slate-400">Restez informé des activités de vos directeurs IA</p>
                        </div>
                      </div>
                      <div className="flex items-center gap-3">
                        {pdgUnreadCount > 0 && (
                          <button
                            onClick={() => markNotificationsRead()}
                            className="px-4 py-2 bg-amber-600 hover:bg-amber-700 rounded-lg text-sm flex items-center gap-2"
                          >
                            <CheckCircle className="w-4 h-4" />
                            Tout marquer comme lu
                          </button>
                        )}
                        <button onClick={loadPdgData} className="p-2 bg-slate-800 hover:bg-slate-700 rounded-lg">
                          <RefreshCw className={`w-5 h-5 ${loadingPdgData ? 'animate-spin' : ''}`} />
                        </button>
                      </div>
                    </div>
                    
                    {/* Stats */}
                    <div className="grid grid-cols-3 gap-4 mt-4">
                      <div className="bg-slate-800/50 rounded-lg p-3 text-center">
                        <p className="text-2xl font-bold text-amber-400">{pdgUnreadCount}</p>
                        <p className="text-xs text-slate-400">Non lues</p>
                      </div>
                      <div className="bg-slate-800/50 rounded-lg p-3 text-center">
                        <p className="text-2xl font-bold text-blue-400">{pdgNotifications.filter(n => n.type === 'agent_conversation').length}</p>
                        <p className="text-xs text-slate-400">Conversations</p>
                      </div>
                      <div className="bg-slate-800/50 rounded-lg p-3 text-center">
                        <p className="text-2xl font-bold text-purple-400">{pdgNotifications.filter(n => n.type === 'inter_agent_request').length}</p>
                        <p className="text-xs text-slate-400">Demandes</p>
                      </div>
                    </div>
                  </div>
                  
                  {/* Liste des notifications */}
                  {loadingPdgData ? (
                    <div className="flex items-center justify-center py-12">
                      <RefreshCw className="w-8 h-8 animate-spin text-amber-400" />
                    </div>
                  ) : pdgNotifications.length === 0 ? (
                    <div className="text-center py-12 text-slate-500">
                      <Bell className="w-16 h-16 mx-auto mb-4 opacity-30" />
                      <p className="text-lg">Aucune notification</p>
                      <p className="text-sm">Les activités de vos directeurs IA apparaîtront ici</p>
                    </div>
                  ) : (
                    <div className="space-y-3">
                      {pdgNotifications.map((notif, i) => (
                        <div
                          key={i}
                          className={`bg-slate-800/50 border rounded-xl p-4 ${
                            notif.read ? 'border-slate-700/50' : 'border-amber-500/50 bg-amber-500/5'
                          }`}
                        >
                          <div className="flex items-start gap-4">
                            <div className={`w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0 ${
                              notif.type === 'agent_conversation' 
                                ? 'bg-blue-500/20' 
                                : 'bg-purple-500/20'
                            }`}>
                              {notif.type === 'agent_conversation' 
                                ? <MessageSquare className="w-5 h-5 text-blue-400" />
                                : <FileText className="w-5 h-5 text-purple-400" />
                              }
                            </div>
                            <div className="flex-1 min-w-0">
                              <div className="flex items-center gap-2 mb-1">
                                <h4 className="font-semibold">{notif.title}</h4>
                                {!notif.read && (
                                  <span className="px-2 py-0.5 bg-amber-500/20 text-amber-400 text-xs rounded">Nouveau</span>
                                )}
                              </div>
                              <p className="text-sm text-slate-400">{notif.message}</p>
                              {notif.summary && (
                                <div className="mt-2 p-3 bg-slate-900/50 rounded-lg">
                                  <p className="text-xs text-slate-500 mb-1">Résumé :</p>
                                  <p className="text-sm text-slate-300">{notif.summary}</p>
                                </div>
                              )}
                              <p className="text-xs text-slate-500 mt-2">
                                {notif.created_at ? new Date(notif.created_at).toLocaleString('fr-FR') : ''}
                              </p>
                            </div>
                            {notif.conversation_id && (
                              <button
                                onClick={() => {
                                  const conv = agentConversations.find(c => c.conversation_id === notif.conversation_id);
                                  if (conv) {
                                    setSelectedConversation(conv);
                                    setActiveSection("agents-conversations");
                                  }
                                }}
                                className="px-3 py-1 bg-blue-600 hover:bg-blue-700 rounded-lg text-sm"
                              >
                                Voir
                              </button>
                            )}
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              )}

              {/* CONVERSATIONS INTER-AGENTS */}
              {activeSection === "agents-conversations" && (
                <div className="space-y-6">
                  {/* Header */}
                  <div className="bg-gradient-to-br from-blue-500/10 to-cyan-500/10 border border-blue-500/30 rounded-xl p-6">
                    <div className="flex items-center justify-between">
                      <div className="flex items-center gap-4">
                        <div className="w-14 h-14 bg-gradient-to-br from-blue-500 to-cyan-500 rounded-xl flex items-center justify-center">
                          <MessageSquare className="w-7 h-7 text-white" />
                        </div>
                        <div>
                          <h2 className="text-xl font-bold">Conversations Inter-Agents</h2>
                          <p className="text-slate-400">Historique des échanges entre vos directeurs IA</p>
                        </div>
                      </div>
                      <div className="flex items-center gap-3">
                        <button
                          onClick={() => setShowNewConversationModal(true)}
                          className="px-4 py-2 bg-blue-600 hover:bg-blue-700 rounded-lg text-sm flex items-center gap-2"
                        >
                          <Plus className="w-4 h-4" />
                          Nouvelle discussion
                        </button>
                        <button onClick={loadPdgData} className="p-2 bg-slate-800 hover:bg-slate-700 rounded-lg">
                          <RefreshCw className={`w-5 h-5 ${loadingPdgData ? 'animate-spin' : ''}`} />
                        </button>
                      </div>
                    </div>
                  </div>
                  
                  <div className="grid grid-cols-3 gap-6">
                    {/* Liste des conversations */}
                    <div className="col-span-1 space-y-3">
                      <h3 className="font-semibold text-slate-400 text-sm px-2">
                        Conversations ({agentConversations.length})
                      </h3>
                      {loadingPdgData ? (
                        <div className="flex items-center justify-center py-8">
                          <RefreshCw className="w-6 h-6 animate-spin text-blue-400" />
                        </div>
                      ) : agentConversations.length === 0 ? (
                        <div className="text-center py-8 text-slate-500">
                          <MessageSquare className="w-12 h-12 mx-auto mb-3 opacity-30" />
                          <p className="text-sm">Aucune conversation</p>
                        </div>
                      ) : (
                        agentConversations.map((conv, i) => (
                          <button
                            key={i}
                            onClick={() => setSelectedConversation(conv)}
                            className={`w-full text-left p-4 rounded-xl transition-colors ${
                              selectedConversation?.conversation_id === conv.conversation_id
                                ? 'bg-blue-500/20 border border-blue-500/50'
                                : 'bg-slate-800/50 border border-slate-700/50 hover:bg-slate-800'
                            }`}
                          >
                            <h4 className="font-medium truncate">{conv.subject}</h4>
                            <p className="text-xs text-slate-400 mt-1">
                              {conv.participants?.map(p => p.name).join(', ')}
                            </p>
                            <p className="text-xs text-slate-500 mt-2">
                              {conv.created_at ? new Date(conv.created_at).toLocaleDateString('fr-FR') : ''}
                            </p>
                          </button>
                        ))
                      )}
                    </div>
                    
                    {/* Détail de la conversation */}
                    <div className="col-span-2 bg-slate-800/50 border border-slate-700/50 rounded-xl">
                      {selectedConversation ? (
                        <div className="flex flex-col h-[600px]">
                          {/* Header conversation */}
                          <div className="p-4 border-b border-slate-700/50">
                            <h3 className="font-bold text-lg">{selectedConversation.subject}</h3>
                            <div className="flex items-center gap-2 mt-2">
                              {selectedConversation.participants?.map((p, j) => (
                                <span key={j} className="flex items-center gap-1 px-2 py-1 bg-slate-700/50 rounded text-xs">
                                  <span>{p.avatar}</span>
                                  <span>{p.name}</span>
                                </span>
                              ))}
                            </div>
                            {selectedConversation.summary && (
                              <div className="mt-3 p-3 bg-blue-500/10 border border-blue-500/30 rounded-lg">
                                <p className="text-xs text-blue-400 mb-1">📋 Résumé de la discussion :</p>
                                <p className="text-sm text-slate-300">{selectedConversation.summary}</p>
                              </div>
                            )}
                          </div>
                          
                          {/* Messages */}
                          <div className="flex-1 overflow-y-auto p-4 space-y-4">
                            {selectedConversation.messages?.map((msg, k) => {
                              const participant = selectedConversation.participants?.find(p => p.id === msg.agent_id);
                              return (
                                <div key={k} className="flex items-start gap-3">
                                  <div className="w-10 h-10 bg-slate-700 rounded-lg flex items-center justify-center flex-shrink-0">
                                    <span className="text-lg">{participant?.avatar || '🤖'}</span>
                                  </div>
                                  <div className="flex-1 min-w-0">
                                    <div className="flex items-center gap-2 mb-1">
                                      <span className="font-medium text-sm">{msg.agent_name}</span>
                                      <span className="text-xs text-slate-500">
                                        {msg.timestamp ? new Date(msg.timestamp).toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' }) : ''}
                                      </span>
                                    </div>
                                    <p className="text-sm text-slate-300 bg-slate-900/50 rounded-lg p-3">
                                      {msg.content}
                                    </p>
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      ) : (
                        <div className="flex flex-col items-center justify-center h-[600px] text-slate-500">
                          <MessageSquare className="w-16 h-16 mb-4 opacity-30" />
                          <p>Sélectionnez une conversation</p>
                          <p className="text-sm">ou créez-en une nouvelle</p>
                        </div>
                      )}
                    </div>
                  </div>
                  
                  {/* Modal nouvelle conversation */}
                  {showNewConversationModal && (
                    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 backdrop-blur-sm">
                      <div className="bg-slate-900 border border-slate-700 rounded-2xl w-full max-w-2xl p-6">
                        <div className="flex items-center justify-between mb-6">
                          <h3 className="text-xl font-bold">Nouvelle discussion entre agents</h3>
                          <button onClick={() => setShowNewConversationModal(false)} className="p-2 hover:bg-slate-800 rounded-lg">
                            <X className="w-5 h-5" />
                          </button>
                        </div>
                        
                        <div className="space-y-4">
                          {/* Initiateur */}
                          <div>
                            <label className="block text-sm font-medium text-slate-400 mb-2">Agent initiateur</label>
                            <select
                              value={newConversation.initiator}
                              onChange={(e) => setNewConversation({ ...newConversation, initiator: e.target.value })}
                              className="w-full bg-slate-800 border border-slate-700 rounded-lg px-4 py-3"
                            >
                              <option value="">Sélectionner...</option>
                              {iaDirectors.map((d, i) => (
                                <option key={i} value={d.director_id}>{d.avatar} {d.name}</option>
                              ))}
                            </select>
                          </div>
                          
                          {/* Participants */}
                          <div>
                            <label className="block text-sm font-medium text-slate-400 mb-2">Participants (autres agents)</label>
                            <div className="grid grid-cols-3 gap-2">
                              {iaDirectors.filter(d => d.director_id !== newConversation.initiator).map((d, i) => (
                                <label 
                                  key={i} 
                                  className={`flex items-center gap-2 p-2 rounded-lg cursor-pointer ${
                                    newConversation.participants.includes(d.director_id)
                                      ? 'bg-blue-500/20 border border-blue-500/50'
                                      : 'bg-slate-800 border border-slate-700 hover:bg-slate-700'
                                  }`}
                                >
                                  <input
                                    type="checkbox"
                                    checked={newConversation.participants.includes(d.director_id)}
                                    onChange={(e) => {
                                      if (e.target.checked) {
                                        setNewConversation({ ...newConversation, participants: [...newConversation.participants, d.director_id] });
                                      } else {
                                        setNewConversation({ ...newConversation, participants: newConversation.participants.filter(p => p !== d.director_id) });
                                      }
                                    }}
                                    className="sr-only"
                                  />
                                  <span>{d.avatar}</span>
                                  <span className="text-sm truncate">{d.name.split(' ')[0]}</span>
                                </label>
                              ))}
                            </div>
                          </div>
                          
                          {/* Sujet */}
                          <div>
                            <label className="block text-sm font-medium text-slate-400 mb-2">Sujet de la discussion</label>
                            <input
                              type="text"
                              value={newConversation.subject}
                              onChange={(e) => setNewConversation({ ...newConversation, subject: e.target.value })}
                              placeholder="Ex: Coordination pour le nouveau télépro"
                              className="w-full bg-slate-800 border border-slate-700 rounded-lg px-4 py-3"
                            />
                          </div>
                          
                          {/* Message initial */}
                          <div>
                            <label className="block text-sm font-medium text-slate-400 mb-2">Message initial de l'initiateur</label>
                            <textarea
                              value={newConversation.message}
                              onChange={(e) => setNewConversation({ ...newConversation, message: e.target.value })}
                              placeholder="Ex: Je voudrais discuter de la formation du nouveau télépro qui arrive demain..."
                              rows={3}
                              className="w-full bg-slate-800 border border-slate-700 rounded-lg px-4 py-3"
                            />
                          </div>
                        </div>
                        
                        <div className="flex justify-end gap-3 mt-6">
                          <button
                            onClick={() => setShowNewConversationModal(false)}
                            className="px-6 py-2 bg-slate-700 hover:bg-slate-600 rounded-lg"
                          >
                            Annuler
                          </button>
                          <button
                            onClick={createAgentConversation}
                            disabled={creatingConversation}
                            className="px-6 py-2 bg-blue-600 hover:bg-blue-700 disabled:opacity-50 rounded-lg flex items-center gap-2"
                          >
                            {creatingConversation ? (
                              <>
                                <RefreshCw className="w-4 h-4 animate-spin" />
                                Création...
                              </>
                            ) : (
                              <>
                                <MessageSquare className="w-4 h-4" />
                                Lancer la discussion
                              </>
                            )}
                          </button>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              )}

              {/* ENRICHISSEMENT CLIENT SAN-IA - Sources uniquement */}
              {activeSection === "enrichment" && (
                <div className="space-y-6">
                  {/* Header avec stats */}
                  <div className="bg-gradient-to-br from-indigo-500/10 to-purple-500/10 border border-indigo-500/30 rounded-xl p-6">
                    <div className="flex items-center justify-between mb-4">
                      <div className="flex items-center gap-4">
                        <div className="w-14 h-14 bg-gradient-to-br from-indigo-500 to-purple-500 rounded-xl flex items-center justify-center">
                          <Inbox className="w-7 h-7 text-white" />
                        </div>
                        <div>
                          <h2 className="text-xl font-bold">Sources d'enrichissement</h2>
                          <p className="text-slate-400">Sélectionnez les sources de données pour enrichir les fiches clients</p>
                        </div>
                      </div>
                      <button onClick={loadData} className="p-2 bg-slate-800 hover:bg-slate-700 rounded-lg">
                        <RefreshCw className={`w-5 h-5 ${loading ? 'animate-spin' : ''}`} />
                      </button>
                    </div>
                    
                    {/* Stats rapides */}
                    {enrichmentStats && (
                      <div className="grid grid-cols-4 gap-4 mt-4">
                        <div className="bg-slate-800/50 rounded-lg p-3 text-center">
                          <p className="text-2xl font-bold text-indigo-400">{enrichmentStats.total_enrichments || 0}</p>
                          <p className="text-xs text-slate-400">Total enrichissements</p>
                        </div>
                        <div className="bg-slate-800/50 rounded-lg p-3 text-center">
                          <p className="text-2xl font-bold text-emerald-400">{enrichmentStats.last_24h || 0}</p>
                          <p className="text-xs text-slate-400">Dernières 24h</p>
                        </div>
                        <div className="bg-slate-800/50 rounded-lg p-3 text-center">
                          <p className="text-2xl font-bold text-blue-400">{enrichmentStats.unique_clients || 0}</p>
                          <p className="text-xs text-slate-400">Clients enrichis</p>
                        </div>
                        <div className="bg-slate-800/50 rounded-lg p-3 text-center">
                          <p className="text-2xl font-bold text-amber-400">
                            {enrichmentConfig?.ai_summarize ? 'ON' : 'OFF'}
                          </p>
                          <p className="text-xs text-slate-400">Résumé IA auto</p>
                        </div>
                      </div>
                    )}
                  </div>

                  {/* Sources Email */}
                  <div className="bg-slate-800/50 border border-slate-700/50 rounded-xl overflow-hidden">
                    <div className="p-4 border-b border-slate-700/50 flex items-center justify-between">
                      <div className="flex items-center gap-3">
                        <Mail className="w-5 h-5 text-blue-400" />
                        <h3 className="font-semibold">Sources Email</h3>
                      </div>
                      <span className="text-xs text-slate-500">Activez les adresses à surveiller</span>
                    </div>
                    <div className="p-4 space-y-3">
                      {enrichmentConfig?.email_sources?.map((source, idx) => (
                        <div key={idx} className="flex items-center justify-between bg-slate-900/50 rounded-lg p-3">
                          <div className="flex items-center gap-3">
                            <input
                              type="checkbox"
                              checked={source.enabled}
                              onChange={async () => {
                                await authFetch(`${API}/enrichment/email-sources/${encodeURIComponent(source.address)}/toggle?enabled=${!source.enabled}`, { method: 'PUT' });
                                loadData();
                              }}
                              className="w-5 h-5 rounded bg-slate-700 border-slate-600 text-indigo-500"
                            />
                            <div>
                              <p className="font-medium">{source.address}</p>
                              <p className="text-xs text-slate-500">{source.label}</p>
                            </div>
                          </div>
                          <button
                            onClick={async () => {
                              if (window.confirm(`Supprimer ${source.address} ?`)) {
                                await authFetch(`${API}/enrichment/email-sources/${encodeURIComponent(source.address)}`, { method: 'DELETE' });
                                loadData();
                              }
                            }}
                            className="p-1.5 text-red-400 hover:bg-red-500/20 rounded"
                          >
                            <Trash2 className="w-4 h-4" />
                          </button>
                        </div>
                      ))}
                    </div>
                  </div>

                  {/* Sources SMS */}
                  <div className="bg-slate-800/50 border border-slate-700/50 rounded-xl overflow-hidden">
                    <div className="p-4 border-b border-slate-700/50 flex items-center gap-3">
                      <MessageCircle className="w-5 h-5 text-green-400" />
                      <h3 className="font-semibold">Sources SMS</h3>
                    </div>
                    <div className="p-4 space-y-3">
                      <label className="flex items-center gap-3 bg-slate-900/50 rounded-lg p-3 cursor-pointer">
                        <input
                          type="checkbox"
                          checked={enrichmentConfig?.sms_config?.enabled || false}
                          onChange={async (e) => {
                            const formData = new FormData();
                            formData.append('enabled', e.target.checked);
                            await authFetch(`${API}/enrichment/sms-config`, { method: 'PUT', body: formData });
                            loadData();
                          }}
                          className="w-5 h-5 rounded bg-slate-700 border-slate-600 text-green-500"
                        />
                        <div>
                          <p className="font-medium">SMS Ringover</p>
                          <p className="text-xs text-slate-500">SMS reçus/envoyés via Ringover</p>
                        </div>
                      </label>
                    </div>
                  </div>

                  {/* Sources Appels */}
                  <div className="bg-slate-800/50 border border-slate-700/50 rounded-xl overflow-hidden">
                    <div className="p-4 border-b border-slate-700/50 flex items-center gap-3">
                      <Phone className="w-5 h-5 text-orange-400" />
                      <h3 className="font-semibold">Sources Appels</h3>
                    </div>
                    <div className="p-4 space-y-3">
                      <label className="flex items-center gap-3 bg-slate-900/50 rounded-lg p-3 cursor-pointer">
                        <input
                          type="checkbox"
                          checked={enrichmentConfig?.ringover_calls?.enabled || false}
                          className="w-5 h-5 rounded bg-slate-700 border-slate-600 text-orange-500"
                          readOnly
                        />
                        <div>
                          <p className="font-medium">Appels Ringover</p>
                          <p className="text-xs text-slate-500">Journaux d'appels entrants/sortants</p>
                        </div>
                      </label>
                    </div>
                  </div>

                  {/* Sources Chat SAN-IA */}
                  <div className="bg-slate-800/50 border border-slate-700/50 rounded-xl overflow-hidden">
                    <div className="p-4 border-b border-slate-700/50 flex items-center gap-3">
                      <Brain className="w-5 h-5 text-purple-400" />
                      <h3 className="font-semibold">Sources Chat SAN-IA</h3>
                    </div>
                    <div className="p-4">
                      <p className="text-sm text-slate-400 mb-3">
                        Pôles dont les échanges enrichissent les fiches clients :
                      </p>
                      <div className="flex flex-wrap gap-2">
                        {enrichmentConfig?.chat_enrichment?.sources?.map((source, idx) => (
                          <span key={idx} className="px-3 py-1 bg-purple-500/20 text-purple-400 rounded-full text-xs flex items-center gap-2">
                            <CheckCircle className="w-3 h-3" />
                            {source}
                          </span>
                        ))}
                      </div>
                    </div>
                  </div>

                  {/* Historique récent */}
                  <div className="bg-slate-800/50 border border-slate-700/50 rounded-xl overflow-hidden">
                    <div className="p-4 border-b border-slate-700/50 flex items-center justify-between">
                      <div className="flex items-center gap-3">
                        <History className="w-5 h-5 text-amber-400" />
                        <h3 className="font-semibold">Enrichissements récents</h3>
                      </div>
                      <span className="text-xs text-slate-500">20 derniers</span>
                    </div>
                    <div className="divide-y divide-slate-700/50 max-h-64 overflow-y-auto">
                      {enrichmentHistory.length === 0 ? (
                        <div className="p-6 text-center text-slate-500">
                          <Inbox className="w-8 h-8 mx-auto mb-2 opacity-50" />
                          <p className="text-sm">Aucun enrichissement enregistré</p>
                        </div>
                      ) : enrichmentHistory.map((entry, idx) => (
                        <div key={idx} className="p-3 hover:bg-slate-800/50">
                          <div className="flex items-start gap-3">
                            <div className={`w-8 h-8 rounded-lg flex items-center justify-center ${
                              entry.source_type === 'email' ? 'bg-blue-500/20' :
                              entry.source_type === 'call' ? 'bg-orange-500/20' :
                              entry.source_type === 'sms' ? 'bg-green-500/20' : 'bg-purple-500/20'
                            }`}>
                              {entry.source_type === 'email' ? <Mail className="w-4 h-4 text-blue-400" /> :
                               entry.source_type === 'call' ? <Phone className="w-4 h-4 text-orange-400" /> :
                               entry.source_type === 'sms' ? <MessageCircle className="w-4 h-4 text-green-400" /> :
                               <Brain className="w-4 h-4 text-purple-400" />}
                            </div>
                            <div className="flex-1 min-w-0">
                              <div className="flex items-center gap-2">
                                <p className="font-medium text-sm truncate">{entry.client_name || entry.client_id}</p>
                                <span className="text-xs text-slate-500">{entry.source_type}</span>
                              </div>
                              <p className="text-xs text-slate-400 truncate">{entry.summary}</p>
                              <p className="text-xs text-slate-600 mt-1">
                                {new Date(entry.timestamp).toLocaleString('fr-FR')}
                              </p>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              )}

              {/* FACTURES À VALIDER (Espace Compta Julia) */}
              {activeSection === "invoices-validation" && (
                <div className="space-y-6">
                  {/* Header */}
                  <div className="bg-gradient-to-br from-amber-500/10 to-yellow-500/10 border border-amber-500/30 rounded-xl p-6">
                    <div className="flex items-center justify-between">
                      <div className="flex items-center gap-4">
                        <div className="w-14 h-14 bg-gradient-to-br from-amber-500 to-yellow-500 rounded-xl flex items-center justify-center">
                          <FileText className="w-7 h-7 text-white" />
                        </div>
                        <div>
                          <h2 className="text-xl font-bold">Factures à valider</h2>
                          <p className="text-slate-400">Validez les factures détectées par l'IA (Comptabilité ou Autre)</p>
                        </div>
                      </div>
                      <div className="flex items-center gap-4">
                        <div className="text-center px-4">
                          <p className="text-2xl font-bold text-amber-400">{pendingInvoices.length}</p>
                          <p className="text-xs text-slate-400">En attente</p>
                        </div>
                        <div className="text-center px-4">
                          <p className="text-2xl font-bold text-emerald-400">{validatedInvoices.length}</p>
                          <p className="text-xs text-slate-400">Validées</p>
                        </div>
                        <button onClick={loadData} className="p-2 bg-slate-800 hover:bg-slate-700 rounded-lg">
                          <RefreshCw className={`w-5 h-5 ${loading ? 'animate-spin' : ''}`} />
                        </button>
                      </div>
                    </div>
                  </div>

                  {/* Légende */}
                  <div className="bg-blue-500/10 border border-blue-500/30 rounded-xl p-4">
                    <p className="text-sm text-blue-400 mb-2 font-medium">💡 Comment valider ?</p>
                    <ul className="text-sm text-slate-400 space-y-1">
                      <li>• <span className="text-amber-400 font-medium">Comptabilité</span> : Factures fournisseurs à envoyer vers Pennylane + stocker dans la fiche client</li>
                      <li>• <span className="text-purple-400 font-medium">Autre</span> : Documents ou factures non comptables à stocker uniquement dans la fiche client</li>
                    </ul>
                  </div>

                  {/* Factures en attente */}
                  <div className="bg-slate-800/50 border border-slate-700/50 rounded-xl overflow-hidden">
                    <div className="p-4 border-b border-slate-700/50 flex items-center justify-between">
                      <h3 className="font-semibold flex items-center gap-2">
                        <Clock className="w-5 h-5 text-amber-400" />
                        Factures en attente de validation ({pendingInvoices.length})
                      </h3>
                    </div>
                    <div className="divide-y divide-slate-700/50">
                      {pendingInvoices.length === 0 ? (
                        <div className="p-8 text-center text-slate-500">
                          <CheckCircle className="w-12 h-12 mx-auto mb-3 opacity-50" />
                          <p className="text-lg font-medium">Aucune facture en attente</p>
                          <p className="text-sm mt-1">Toutes les factures ont été validées 🎉</p>
                        </div>
                      ) : pendingInvoices.map((invoice, idx) => (
                        <div key={idx} className="p-4">
                          <div className="flex items-start gap-4">
                            <div className="w-12 h-12 bg-amber-500/20 rounded-lg flex items-center justify-center flex-shrink-0">
                              <FileText className="w-6 h-6 text-amber-400" />
                            </div>
                            <div className="flex-1 min-w-0">
                              <div className="flex items-center gap-2 mb-1">
                                <p className="font-medium">{invoice.attachment?.filename || 'Document sans nom'}</p>
                                {invoice.ai_classification?.is_invoice && (
                                  <span className="px-2 py-0.5 bg-blue-500/20 text-blue-400 rounded text-xs">
                                    Facture détectée ({Math.round((invoice.ai_classification.confidence || 0) * 100)}%)
                                  </span>
                                )}
                              </div>
                              <p className="text-sm text-slate-400">
                                De: {invoice.email_data?.from}
                              </p>
                              <p className="text-sm text-slate-500">
                                Objet: {invoice.email_data?.subject}
                              </p>
                              {invoice.ai_classification?.extracted_data?.vendor_name && (
                                <p className="text-sm text-purple-400 mt-1">
                                  🏢 Fournisseur: {invoice.ai_classification.extracted_data.vendor_name}
                                </p>
                              )}
                              {invoice.ai_classification?.extracted_data?.amount && (
                                <p className="text-sm text-emerald-400">
                                  💰 Montant: {invoice.ai_classification.extracted_data.amount} €
                                </p>
                              )}
                              {invoice.client_match?.client_name && (
                                <p className="text-sm text-cyan-400 mt-1">
                                  👤 Client suggéré: {invoice.client_match.client_name}
                                </p>
                              )}
                              <p className="text-xs text-slate-600 mt-2">
                                Reçu le {new Date(invoice.created_at).toLocaleString('fr-FR')}
                              </p>
                            </div>
                            <div className="flex flex-col gap-2">
                              <button
                                onClick={async () => {
                                  setValidatingInvoice(invoice._id);
                                  const formData = new FormData();
                                  formData.append('final_type', 'comptabilite');
                                  formData.append('validated_by', 'julia@sani-adapt.fr');
                                  try {
                                    await authFetch(`${API}/invoices/${invoice._id}/validate`, { method: 'POST', body: formData });
                                    loadData();
                                  } catch (e) { console.error(e); }
                                  setValidatingInvoice(null);
                                }}
                                disabled={validatingInvoice === invoice._id}
                                className="px-4 py-2 bg-amber-600 hover:bg-amber-700 rounded-lg text-sm font-medium flex items-center gap-2 disabled:opacity-50"
                              >
                                {validatingInvoice === invoice._id ? <RefreshCw className="w-4 h-4 animate-spin" /> : <Check className="w-4 h-4" />}
                                Comptabilité
                              </button>
                              <button
                                onClick={async () => {
                                  setValidatingInvoice(invoice._id);
                                  const formData = new FormData();
                                  formData.append('final_type', 'autre');
                                  formData.append('validated_by', 'julia@sani-adapt.fr');
                                  try {
                                    await authFetch(`${API}/invoices/${invoice._id}/validate`, { method: 'POST', body: formData });
                                    loadData();
                                  } catch (e) { console.error(e); }
                                  setValidatingInvoice(null);
                                }}
                                disabled={validatingInvoice === invoice._id}
                                className="px-4 py-2 bg-purple-600 hover:bg-purple-700 rounded-lg text-sm font-medium flex items-center gap-2 disabled:opacity-50"
                              >
                                {validatingInvoice === invoice._id ? <RefreshCw className="w-4 h-4 animate-spin" /> : <FileText className="w-4 h-4" />}
                                Autre
                              </button>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>

                  {/* Factures validées récemment */}
                  <div className="bg-slate-800/50 border border-slate-700/50 rounded-xl overflow-hidden">
                    <div className="p-4 border-b border-slate-700/50 flex items-center justify-between">
                      <h3 className="font-semibold flex items-center gap-2">
                        <CheckCircle className="w-5 h-5 text-emerald-400" />
                        Factures validées récemment ({validatedInvoices.length})
                      </h3>
                    </div>
                    <div className="divide-y divide-slate-700/50 max-h-64 overflow-y-auto">
                      {validatedInvoices.length === 0 ? (
                        <div className="p-6 text-center text-slate-500">
                          <FileText className="w-8 h-8 mx-auto mb-2 opacity-50" />
                          <p className="text-sm">Aucune facture validée</p>
                        </div>
                      ) : validatedInvoices.map((invoice, idx) => (
                        <div key={idx} className="p-3 hover:bg-slate-800/50">
                          <div className="flex items-center gap-3">
                            <div className={`w-10 h-10 rounded-lg flex items-center justify-center ${
                              invoice.final_type === 'comptabilite' ? 'bg-amber-500/20' : 'bg-purple-500/20'
                            }`}>
                              <FileText className={`w-5 h-5 ${
                                invoice.final_type === 'comptabilite' ? 'text-amber-400' : 'text-purple-400'
                              }`} />
                            </div>
                            <div className="flex-1 min-w-0">
                              <div className="flex items-center gap-2">
                                <p className="font-medium text-sm truncate">{invoice.attachment?.filename}</p>
                                <span className={`px-2 py-0.5 rounded text-xs ${
                                  invoice.final_type === 'comptabilite' 
                                    ? 'bg-amber-500/20 text-amber-400' 
                                    : 'bg-purple-500/20 text-purple-400'
                                }`}>
                                  {invoice.final_type === 'comptabilite' ? 'Comptabilité' : 'Autre'}
                                </span>
                              </div>
                              <p className="text-xs text-slate-500">
                                Validé par {invoice.validated_by} le {new Date(invoice.validated_at).toLocaleString('fr-FR')}
                              </p>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              )}

              {/* ÉCHANGES À RATTACHER */}
              {activeSection === "pending-exchanges" && (
                <div className="space-y-6">
                  {/* Header */}
                  <div className="bg-gradient-to-br from-orange-500/10 to-amber-500/10 border border-orange-500/30 rounded-xl p-6">
                    <div className="flex items-center justify-between">
                      <div className="flex items-center gap-4">
                        <div className="w-14 h-14 bg-gradient-to-br from-orange-500 to-amber-500 rounded-xl flex items-center justify-center">
                          <Link2 className="w-7 h-7 text-white" />
                        </div>
                        <div>
                          <h2 className="text-xl font-bold">Échanges à rattacher</h2>
                          <p className="text-slate-400">Rattachez les échanges aux fiches clients pour enrichir leur historique</p>
                        </div>
                      </div>
                      <div className="flex items-center gap-4">
                        <div className="text-center px-4">
                          <p className="text-2xl font-bold text-orange-400">{pendingExchanges.length}</p>
                          <p className="text-xs text-slate-400">En attente</p>
                        </div>
                        <button onClick={loadData} className="p-2 bg-slate-800 hover:bg-slate-700 rounded-lg">
                          <RefreshCw className={`w-5 h-5 ${loading ? 'animate-spin' : ''}`} />
                        </button>
                      </div>
                    </div>
                  </div>

                  {/* Info box */}
                  <div className="bg-blue-500/10 border border-blue-500/30 rounded-xl p-4">
                    <p className="text-sm text-blue-400 font-medium mb-2">💡 Comment ça marche ?</p>
                    <ul className="text-sm text-slate-400 space-y-1">
                      <li>• Ces échanges n'ont pas pu être rattachés automatiquement à un client</li>
                      <li>• Cliquez sur "Rattacher" pour associer l'échange à un client</li>
                      <li>• L'email de l'expéditeur sera automatiquement enregistré dans la fiche client</li>
                      <li>• Les futures communications de cette adresse seront automatiquement rattachées</li>
                    </ul>
                  </div>

                  {/* Liste des échanges à rattacher */}
                  <div className="bg-slate-800/50 border border-slate-700/50 rounded-xl overflow-hidden">
                    <div className="p-4 border-b border-slate-700/50 flex items-center justify-between">
                      <h3 className="font-semibold flex items-center gap-2">
                        <Clock className="w-5 h-5 text-orange-400" />
                        Échanges en attente de rattachement ({pendingExchanges.length})
                      </h3>
                    </div>
                    <div className="divide-y divide-slate-700/50 max-h-[500px] overflow-y-auto">
                      {pendingExchanges.length === 0 ? (
                        <div className="p-8 text-center text-slate-500">
                          <CheckCircle className="w-12 h-12 mx-auto mb-3 opacity-50" />
                          <p className="text-lg font-medium">Aucun échange en attente</p>
                          <p className="text-sm mt-1">Tous les échanges ont été rattachés à des clients 🎉</p>
                        </div>
                      ) : pendingExchanges.map((exchange, idx) => (
                        <div key={idx} className="p-4 hover:bg-slate-800/50">
                          <div className="flex items-start gap-4">
                            <div className="w-12 h-12 bg-orange-500/20 rounded-lg flex items-center justify-center flex-shrink-0">
                              {exchange.type === 'email' ? (
                                <Mail className="w-6 h-6 text-orange-400" />
                              ) : exchange.type === 'sms' ? (
                                <MessageCircle className="w-6 h-6 text-green-400" />
                              ) : (
                                <Phone className="w-6 h-6 text-blue-400" />
                              )}
                            </div>
                            <div className="flex-1 min-w-0">
                              <div className="flex items-center gap-2 mb-1">
                                <p className="font-medium truncate">{exchange.subject || '(Sans objet)'}</p>
                                <span className="px-2 py-0.5 bg-orange-500/20 text-orange-400 rounded text-xs">
                                  {exchange.type === 'email' ? 'Email' : exchange.type === 'sms' ? 'SMS' : 'Appel'}
                                </span>
                              </div>
                              <p className="text-sm text-slate-400 truncate">De: {exchange.from}</p>
                              {exchange.summary && (
                                <p className="text-sm text-blue-400 mt-1 italic truncate">📝 {exchange.summary}</p>
                              )}
                              {exchange.extracted_info && (
                                <div className="mt-2 text-xs text-slate-500">
                                  {exchange.extracted_info.nom && <span className="mr-2">Nom suggéré: {exchange.extracted_info.nom}</span>}
                                  {exchange.extracted_info.prenom && <span className="mr-2">Prénom: {exchange.extracted_info.prenom}</span>}
                                  {exchange.extracted_info.telephone && <span>Tél: {exchange.extracted_info.telephone}</span>}
                                </div>
                              )}
                              <div className="flex items-center gap-2 mt-2">
                                <span className="text-xs text-slate-600">
                                  {exchange.created_at && new Date(exchange.created_at).toLocaleString('fr-FR')}
                                </span>
                                {exchange.attachments_count > 0 && (
                                  <span className="text-xs text-purple-400">
                                    📎 {exchange.attachments_count} pièce(s) jointe(s)
                                  </span>
                                )}
                                {exchange.has_potential_invoices && (
                                  <span className="text-xs text-amber-400">🧾 Factures potentielles</span>
                                )}
                              </div>
                            </div>
                            <button
                              onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                setSelectedExchange(exchange);
                                setShowLinkModal(true);
                                setClientSearchTerm("");
                                setClientSearchResults([]);
                              }}
                              disabled={linkingExchange === exchange._id}
                              className="px-4 py-2 bg-orange-600 hover:bg-orange-700 rounded-lg text-sm font-medium flex items-center gap-2 disabled:opacity-50"
                            >
                              {linkingExchange === exchange._id ? (
                                <RefreshCw className="w-4 h-4 animate-spin" />
                              ) : (
                                <Link2 className="w-4 h-4" />
                              )}
                              Rattacher
                            </button>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              )}

              {/* CONNECTEUR EMAIL */}
              {activeSection === "connector-email" && (
                <div className="space-y-6">
                  <div className="bg-gradient-to-br from-blue-500/10 to-cyan-500/10 border border-blue-500/30 rounded-xl p-6">
                    <div className="flex items-center justify-between">
                      <div className="flex items-center gap-4">
                        <div className="w-14 h-14 bg-gradient-to-br from-blue-500 to-cyan-500 rounded-xl flex items-center justify-center">
                          <Mail className="w-7 h-7 text-white" />
                        </div>
                        <div>
                          <h2 className="text-xl font-bold">Connecteur Email IMAP</h2>
                          <p className="text-slate-400">Connectez vos boîtes mail pour récupérer automatiquement les échanges</p>
                        </div>
                      </div>
                      <div className="flex items-center gap-3">
                        <button
                          onClick={async () => {
                            setSyncingEmails(true);
                            try {
                              await authFetch(`${API}/imap/sync-all`, { method: 'POST' });
                              loadData();
                            } catch (e) { console.error(e); }
                            setSyncingEmails(false);
                          }}
                          disabled={syncingEmails || imapConfigs.length === 0}
                          className="px-4 py-2 bg-slate-700 hover:bg-slate-600 rounded-lg flex items-center gap-2 disabled:opacity-50"
                        >
                          <RefreshCw className={`w-4 h-4 ${syncingEmails ? 'animate-spin' : ''}`} />
                          Synchroniser tout
                        </button>
                        <button
                          onClick={() => {
                            setImapForm({ email_address: "", server: "", port: 993, password: "", use_ssl: true, label: "" });
                            setImapTestResult(null);
                            setShowImapModal(true);
                          }}
                          className="px-4 py-2 bg-blue-600 hover:bg-blue-700 rounded-lg flex items-center gap-2"
                        >
                          <Plus className="w-4 h-4" /> Configurer une boîte mail
                        </button>
                      </div>
                    </div>
                  </div>

                  {/* Boîtes mail connectées */}
                  <div className="bg-slate-800/50 border border-slate-700/50 rounded-xl overflow-hidden">
                    <div className="p-4 border-b border-slate-700/50 flex items-center justify-between">
                      <h3 className="font-semibold">Boîtes mail connectées ({imapConfigs.length})</h3>
                    </div>
                    <div className="p-4 space-y-3">
                      {imapConfigs.length === 0 ? (
                        <div className="text-center py-8 text-slate-500">
                          <Mail className="w-10 h-10 mx-auto mb-3 opacity-50" />
                          <p>Aucune boîte mail configurée</p>
                          <p className="text-xs mt-1">Cliquez sur "Configurer une boîte mail" pour commencer</p>
                        </div>
                      ) : imapConfigs.map((config, idx) => (
                        <div key={idx} className="flex items-center justify-between bg-slate-900/50 rounded-lg p-4">
                          <div className="flex items-center gap-4">
                            <div className={`w-12 h-12 rounded-lg flex items-center justify-center ${
                              config.email_type === 'factures' ? 'bg-amber-500/20' : 
                              config.email_type === 'both' ? 'bg-purple-500/20' : 'bg-emerald-500/20'
                            }`}>
                              <Mail className={`w-6 h-6 ${
                                config.email_type === 'factures' ? 'text-amber-400' : 
                                config.email_type === 'both' ? 'text-purple-400' : 'text-emerald-400'
                              }`} />
                            </div>
                            <div>
                              <p className="font-medium">{config.email_address}</p>
                              <div className="flex items-center gap-3 text-xs text-slate-500 mt-1">
                                <span>{config.server}:{config.port}</span>
                                <span>•</span>
                                <span>{config.last_sync ? `Sync: ${new Date(config.last_sync).toLocaleString('fr-FR')}` : 'Jamais sync'}</span>
                              </div>
                            </div>
                          </div>
                          <div className="flex items-center gap-2">
                            {/* Type selector */}
                            <select
                              value={config.email_type || 'clients'}
                              onChange={async (e) => {
                                try {
                                  await authFetch(`${API}/imap/config/${encodeURIComponent(config.email_address)}/type?email_type=${e.target.value}`, { method: 'PATCH' });
                                  loadData();
                                } catch (err) { console.error(err); }
                              }}
                              className={`px-2 py-1 rounded text-xs border-0 cursor-pointer ${
                                config.email_type === 'factures' ? 'bg-amber-500/20 text-amber-400' : 
                                config.email_type === 'both' ? 'bg-purple-500/20 text-purple-400' : 'bg-emerald-500/20 text-emerald-400'
                              }`}
                            >
                              <option value="clients" className="bg-slate-800 text-white">📧 Clients</option>
                              <option value="factures" className="bg-slate-800 text-white">🧾 Factures</option>
                              <option value="both" className="bg-slate-800 text-white">📧🧾 Les deux</option>
                            </select>
                            <button
                              onClick={() => {
                                setSelectedEmailConfig(config);
                                setShowEmailUsersModal(true);
                              }}
                              className={`px-2 py-1 rounded text-xs flex items-center gap-1 ${
                                (config.assigned_users || []).length > 0 
                                  ? 'bg-blue-500/20 text-blue-400' 
                                  : 'bg-slate-700 text-slate-400'
                              }`}
                              title="Attribuer à des utilisateurs"
                            >
                              <Users className="w-3 h-3" />
                              {(config.assigned_users || []).length > 0 
                                ? `${(config.assigned_users || []).length} user(s)` 
                                : 'Non attribué'}
                            </button>
                            <span className="px-3 py-1 bg-emerald-500/20 text-emerald-400 rounded text-xs flex items-center gap-1">
                              <CheckCircle className="w-3 h-3" /> Connecté
                            </span>
                            <button
                              onClick={async () => {
                                setSyncingEmails(true);
                                try {
                                  await authFetch(`${API}/imap/fetch-emails/${encodeURIComponent(config.email_address)}`, { method: 'POST' });
                                  loadData();
                                } catch (e) { console.error(e); }
                                setSyncingEmails(false);
                              }}
                              className="p-2 text-blue-400 hover:bg-blue-500/20 rounded-lg"
                              title="Synchroniser"
                            >
                              <RefreshCw className="w-4 h-4" />
                            </button>
                            <button
                              onClick={async () => {
                                if (window.confirm(`Supprimer la configuration pour ${config.email_address} ?`)) {
                                  await authFetch(`${API}/imap/configs/${encodeURIComponent(config.email_address)}`, { method: 'DELETE' });
                                  loadData();
                                }
                              }}
                              className="p-2 text-red-400 hover:bg-red-500/20 rounded-lg"
                            >
                              <Trash2 className="w-4 h-4" />
                            </button>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>

                  {/* Modal d'attribution des utilisateurs */}
                  {showEmailUsersModal && selectedEmailConfig && (
                    <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-50 p-4">
                      <div className="bg-slate-900 rounded-xl border border-slate-700 w-full max-w-lg">
                        <div className="p-4 border-b border-slate-700 flex items-center justify-between">
                          <div className="flex items-center gap-3">
                            <div className="w-10 h-10 bg-blue-500/20 rounded-lg flex items-center justify-center">
                              <Users className="w-5 h-5 text-blue-400" />
                            </div>
                            <div>
                              <h3 className="font-semibold">Utilisateurs autorisés</h3>
                              <p className="text-xs text-slate-400">{selectedEmailConfig.email_address}</p>
                            </div>
                          </div>
                          <button 
                            onClick={() => { setShowEmailUsersModal(false); setSelectedEmailConfig(null); }}
                            className="p-2 hover:bg-slate-800 rounded-lg"
                          >
                            <X className="w-5 h-5" />
                          </button>
                        </div>
                        <div className="p-4 space-y-4">
                          <p className="text-sm text-slate-400">
                            Sélectionnez les collaborateurs qui peuvent accéder à cette boîte mail dans "Mon Espace".
                            <br />
                            <span className="text-amber-400">Les utilisateurs non sélectionnés ne verront pas cette boîte.</span>
                          </p>
                          
                          <div className="max-h-64 overflow-y-auto space-y-2">
                            {users.map(user => {
                              const isAssigned = (selectedEmailConfig.assigned_users || []).includes(user.email.toLowerCase());
                              return (
                                <div 
                                  key={user.email}
                                  className={`flex items-center justify-between p-3 rounded-lg border cursor-pointer transition-colors ${
                                    isAssigned 
                                      ? 'bg-blue-500/20 border-blue-500/50' 
                                      : 'bg-slate-800/50 border-slate-700 hover:border-slate-600'
                                  }`}
                                  onClick={() => {
                                    const currentUsers = selectedEmailConfig.assigned_users || [];
                                    let newUsers;
                                    if (isAssigned) {
                                      newUsers = currentUsers.filter(u => u.toLowerCase() !== user.email.toLowerCase());
                                    } else {
                                      newUsers = [...currentUsers, user.email.toLowerCase()];
                                    }
                                    setSelectedEmailConfig({
                                      ...selectedEmailConfig,
                                      assigned_users: newUsers
                                    });
                                  }}
                                >
                                  <div className="flex items-center gap-3">
                                    <div className={`w-8 h-8 rounded-full flex items-center justify-center text-sm font-medium ${
                                      isAssigned ? 'bg-blue-500 text-white' : 'bg-slate-700 text-slate-300'
                                    }`}>
                                      {(user.name || user.email)[0].toUpperCase()}
                                    </div>
                                    <div>
                                      <p className="font-medium text-sm">{user.name || user.email}</p>
                                      <p className="text-xs text-slate-500">{user.email}</p>
                                    </div>
                                  </div>
                                  {isAssigned && <Check className="w-5 h-5 text-blue-400" />}
                                </div>
                              );
                            })}
                          </div>

                          <div className="flex items-center justify-between pt-2 border-t border-slate-700">
                            <span className="text-sm text-slate-400">
                              {(selectedEmailConfig.assigned_users || []).length} utilisateur(s) sélectionné(s)
                            </span>
                            <button
                              onClick={async () => {
                                try {
                                  const resp = await authFetch(
                                    `${API}/imap/config/${encodeURIComponent(selectedEmailConfig.email_address)}/users`,
                                    {
                                      method: 'PATCH',
                                      headers: { 'Content-Type': 'application/json' },
                                      body: JSON.stringify({ assigned_users: selectedEmailConfig.assigned_users || [] })
                                    }
                                  );
                                  if (resp.ok) {
                                    loadData();
                                    setShowEmailUsersModal(false);
                                    setSelectedEmailConfig(null);
                                  }
                                } catch (e) {
                                  console.error(e);
                                }
                              }}
                              className="px-4 py-2 bg-blue-600 hover:bg-blue-700 rounded-lg flex items-center gap-2"
                            >
                              <Save className="w-4 h-4" /> Enregistrer
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}

                  {/* Adresses à surveiller (pour future config) */}
                  <div className="bg-slate-800/50 border border-slate-700/50 rounded-xl overflow-hidden">
                    <div className="p-4 border-b border-slate-700/50">
                      <h3 className="font-semibold">Adresses dans l'enrichissement</h3>
                    </div>
                    <div className="p-4 space-y-2">
                      {enrichmentConfig?.email_sources?.map((source, idx) => {
                        const hasImap = imapConfigs.some(c => c.email_address === source.address);
                        return (
                          <div key={idx} className="flex items-center justify-between bg-slate-900/30 rounded-lg p-3">
                            <div className="flex items-center gap-3">
                              <Mail className="w-4 h-4 text-slate-400" />
                              <span className="text-sm">{source.address}</span>
                              <span className="text-xs text-slate-500">({source.label})</span>
                            </div>
                            {hasImap ? (
                              <span className="text-xs text-emerald-400">✓ IMAP configuré</span>
                            ) : (
                              <button
                                onClick={() => {
                                  setImapForm({ ...imapForm, email_address: source.address, label: source.label });
                                  setShowImapModal(true);
                                }}
                                className="text-xs text-blue-400 hover:text-blue-300"
                              >
                                Configurer IMAP
                              </button>
                            )}
                          </div>
                        );
                      })}
                    </div>
                  </div>

                  {/* Traitement IA des emails */}
                  <div className="bg-gradient-to-br from-purple-500/10 to-indigo-500/10 border border-purple-500/30 rounded-xl overflow-hidden">
                    <div className="p-4 border-b border-purple-500/30 flex items-center justify-between">
                      <div className="flex items-center gap-3">
                        <Brain className="w-5 h-5 text-purple-400" />
                        <h3 className="font-semibold">Traitement IA des emails</h3>
                      </div>
                      <div className="flex items-center gap-4">
                        <div className="flex items-center gap-2 text-sm">
                          <span className="text-amber-400 font-medium">{emailStats.pending}</span>
                          <span className="text-slate-500">en attente</span>
                          <span className="text-slate-600">•</span>
                          <span className="text-emerald-400 font-medium">{emailStats.processed}</span>
                          <span className="text-slate-500">traités</span>
                        </div>
                        <button
                          onClick={async () => {
                            setProcessingEmails(true);
                            try {
                              const resp = await authFetch(`${API}/emails/process-batch?limit=20`, { method: 'POST' });
                              if (resp.ok) {
                                const result = await resp.json();
                                alert(`✅ ${result.success}/${result.total_processed} emails traités avec succès`);
                                loadData();
                              }
                            } catch (e) { console.error(e); }
                            setProcessingEmails(false);
                          }}
                          disabled={processingEmails || emailStats.pending === 0}
                          className="px-4 py-2 bg-purple-600 hover:bg-purple-700 rounded-lg flex items-center gap-2 disabled:opacity-50"
                        >
                          {processingEmails ? <RefreshCw className="w-4 h-4 animate-spin" /> : <Sparkles className="w-4 h-4" />}
                          Traiter avec IA
                        </button>
                      </div>
                    </div>
                    <div className="p-4 text-sm text-slate-400">
                      <p>Le traitement IA analyse chaque email pour :</p>
                      <ul className="mt-2 space-y-1 ml-4">
                        <li>• Générer un résumé automatique</li>
                        <li>• Identifier le client correspondant</li>
                        <li>• Détecter les factures et documents</li>
                        <li>• Enrichir la fiche client avec les informations extraites</li>
                      </ul>
                    </div>
                  </div>

                  {/* Historique des emails avec statut */}
                  <div className="bg-slate-800/50 border border-slate-700/50 rounded-xl overflow-hidden">
                    <div className="p-4 border-b border-slate-700/50 flex items-center justify-between">
                      <h3 className="font-semibold">Historique des emails ({emailStats.total})</h3>
                      <div className="flex items-center gap-2 text-xs">
                        <span className="text-emerald-400">{emailStats.identified || 0} identifiés</span>
                        <span className="text-slate-600">•</span>
                        <span className="text-orange-400">{emailStats.pending_link || 0} à rattacher</span>
                        <span className="text-slate-600">•</span>
                        <span className="text-amber-400">{emailStats.pending || 0} en attente</span>
                      </div>
                    </div>
                    <div className="divide-y divide-slate-700/50 max-h-[600px] overflow-y-auto">
                      {emailHistory.length === 0 ? (
                        <div className="p-6 text-center text-slate-500">
                          <Inbox className="w-8 h-8 mx-auto mb-2 opacity-50" />
                          <p className="text-sm">Aucun email récupéré</p>
                          <p className="text-xs mt-1">Configurez une boîte mail et synchronisez</p>
                        </div>
                      ) : emailHistory.map((email, idx) => (
                        <div key={idx} className="p-4 hover:bg-slate-800/50">
                          <div className="flex items-start gap-3">
                            <div className={`w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0 ${
                              email.client_identified ? 'bg-emerald-500/20' : 
                              email.processed ? 'bg-orange-500/20' : 'bg-amber-500/20'
                            }`}>
                              {email.client_identified ? (
                                <CheckCircle className="w-5 h-5 text-emerald-400" />
                              ) : email.processed ? (
                                <Link2 className="w-5 h-5 text-orange-400" />
                              ) : (
                                <Clock className="w-5 h-5 text-amber-400" />
                              )}
                            </div>
                            <div className="flex-1 min-w-0">
                              <div className="flex items-center gap-2 mb-1">
                                <p className="font-medium text-sm truncate flex-1">{email.subject || '(Sans sujet)'}</p>
                                {email.client_identified && (
                                  <span className="px-2 py-0.5 bg-emerald-500/20 text-emerald-400 rounded text-xs flex-shrink-0">✓ Identifié</span>
                                )}
                                {email.processed && !email.client_identified && (
                                  <span className="px-2 py-0.5 bg-orange-500/20 text-orange-400 rounded text-xs flex-shrink-0">À rattacher</span>
                                )}
                                {!email.processed && (
                                  <span className="px-2 py-0.5 bg-amber-500/20 text-amber-400 rounded text-xs flex-shrink-0">En attente</span>
                                )}
                              </div>
                              <p className="text-sm text-blue-400 font-medium">De: {email.from}</p>
                              {email.body_preview && (
                                <p className="text-xs text-slate-400 mt-1 line-clamp-2">{email.body_preview}</p>
                              )}
                              {email.summary && (
                                <p className="text-xs text-purple-400 mt-2 italic">📝 {email.summary}</p>
                              )}
                              {email.client_match && email.client_match.client_name && (
                                <p className="text-xs text-emerald-400 mt-1">👤 Client: {email.client_match.client_name}</p>
                              )}
                              <div className="flex items-center gap-3 mt-2 text-xs text-slate-500">
                                <span>📅 {email.date ? new Date(email.date).toLocaleString('fr-FR') : 'Date inconnue'}</span>
                                <span>📬 {email.source_mailbox || 'Boîte inconnue'}</span>
                              </div>
                            </div>
                            <div className="flex flex-col gap-2">
                              {!email.processed && (
                                <button
                                  onClick={async (e) => {
                                    e.stopPropagation();
                                    try {
                                      const resp = await authFetch(`${API}/emails/process/${email.id}`, { method: 'POST' });
                                      if (resp.ok) {
                                        const result = await resp.json();
                                        if (result.client_identified) {
                                          alert(`✅ Client identifié: ${result.client_match?.client_name || 'Inconnu'}`);
                                        } else {
                                          alert(`❓ Client non identifié. L'échange a été ajouté dans "Échanges à rattacher".`);
                                        }
                                        loadData();
                                      }
                                    } catch (err) { console.error(err); }
                                  }}
                                  className="px-3 py-1.5 bg-purple-600 hover:bg-purple-700 rounded text-xs font-medium flex items-center gap-1"
                                >
                                  <Sparkles className="w-3 h-3" />
                                  Traiter
                                </button>
                              )}
                              {email.processed && !email.client_identified && (
                                <button
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    setActiveSection('pending-exchanges');
                                  }}
                                  className="px-3 py-1.5 bg-orange-600 hover:bg-orange-700 rounded text-xs font-medium flex items-center gap-1"
                                >
                                  <Link2 className="w-3 h-3" />
                                  Rattacher
                                </button>
                              )}
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              )}

              {/* Modal Configuration IMAP */}
              {showImapModal && (
                <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 backdrop-blur-sm">
                  <div className="bg-slate-900 border border-slate-700 rounded-2xl w-full max-w-lg">
                    <div className="p-6 border-b border-slate-700 flex items-center justify-between">
                      <h3 className="text-xl font-bold flex items-center gap-2">
                        <Mail className="w-6 h-6 text-blue-400" />
                        Configuration IMAP
                      </h3>
                      <button onClick={() => setShowImapModal(false)} className="p-2 hover:bg-slate-800 rounded-lg">
                        <X className="w-5 h-5" />
                      </button>
                    </div>
                    <div className="p-6 space-y-4">
                      <div>
                        <label className="block text-sm font-medium text-slate-400 mb-2">Adresse email *</label>
                        <input
                          type="email"
                          value={imapForm.email_address}
                          onChange={e => setImapForm({...imapForm, email_address: e.target.value})}
                          placeholder="contact@sani-adapt.fr"
                          className="w-full bg-slate-800 border border-slate-700 rounded-lg px-4 py-2"
                        />
                      </div>
                      <div className="grid grid-cols-2 gap-4">
                        <div>
                          <label className="block text-sm font-medium text-slate-400 mb-2">Serveur IMAP *</label>
                          <input
                            type="text"
                            value={imapForm.server}
                            onChange={e => setImapForm({...imapForm, server: e.target.value})}
                            placeholder="imap.gmail.com"
                            className="w-full bg-slate-800 border border-slate-700 rounded-lg px-4 py-2"
                          />
                        </div>
                        <div>
                          <label className="block text-sm font-medium text-slate-400 mb-2">Port</label>
                          <input
                            type="number"
                            value={imapForm.port}
                            onChange={e => setImapForm({...imapForm, port: parseInt(e.target.value)})}
                            className="w-full bg-slate-800 border border-slate-700 rounded-lg px-4 py-2"
                          />
                        </div>
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-slate-400 mb-2">Mot de passe d'application *</label>
                        <input
                          type="password"
                          value={imapForm.password}
                          onChange={e => setImapForm({...imapForm, password: e.target.value})}
                          placeholder="••••••••••••••••"
                          className="w-full bg-slate-800 border border-slate-700 rounded-lg px-4 py-2"
                        />
                        <p className="text-xs text-slate-500 mt-1">
                          Pour Gmail, utilisez un "mot de passe d'application" (pas votre mot de passe habituel)
                        </p>
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-slate-400 mb-2">Label (optionnel)</label>
                        <input
                          type="text"
                          value={imapForm.label}
                          onChange={e => setImapForm({...imapForm, label: e.target.value})}
                          placeholder="Administratif"
                          className="w-full bg-slate-800 border border-slate-700 rounded-lg px-4 py-2"
                        />
                      </div>
                      <label className="flex items-center gap-3 cursor-pointer">
                        <input
                          type="checkbox"
                          checked={imapForm.use_ssl}
                          onChange={e => setImapForm({...imapForm, use_ssl: e.target.checked})}
                          className="w-5 h-5 rounded bg-slate-700 border-slate-600"
                        />
                        <span className="text-sm">Utiliser SSL (recommandé)</span>
                      </label>

                      {/* Résultat du test */}
                      {imapTestResult && (
                        <div className={`p-3 rounded-lg ${imapTestResult.success ? 'bg-emerald-500/20 text-emerald-400' : 'bg-red-500/20 text-red-400'}`}>
                          <p className="text-sm flex items-center gap-2">
                            {imapTestResult.success ? <CheckCircle className="w-4 h-4" /> : <AlertTriangle className="w-4 h-4" />}
                            {imapTestResult.message}
                          </p>
                        </div>
                      )}
                    </div>
                    <div className="p-6 border-t border-slate-700 flex justify-between">
                      <button
                        onClick={async () => {
                          setTestingImap(true);
                          setImapTestResult(null);
                          try {
                            const formData = new FormData();
                            formData.append('server', imapForm.server);
                            formData.append('port', imapForm.port.toString());
                            formData.append('email_address', imapForm.email_address);
                            formData.append('password', imapForm.password);
                            formData.append('use_ssl', imapForm.use_ssl.toString());
                            const resp = await authFetch(`${API}/imap/test-connection`, { method: 'POST', body: formData });
                            const result = await resp.json();
                            setImapTestResult(result);
                          } catch (e) {
                            setImapTestResult({ success: false, message: 'Erreur de connexion' });
                          }
                          setTestingImap(false);
                        }}
                        disabled={testingImap || !imapForm.server || !imapForm.email_address || !imapForm.password}
                        className="px-4 py-2 bg-slate-700 hover:bg-slate-600 rounded-lg flex items-center gap-2 disabled:opacity-50"
                      >
                        {testingImap ? <RefreshCw className="w-4 h-4 animate-spin" /> : <Zap className="w-4 h-4" />}
                        Tester la connexion
                      </button>
                      <div className="flex gap-3">
                        <button onClick={() => setShowImapModal(false)} className="px-6 py-2 bg-slate-700 hover:bg-slate-600 rounded-lg">
                          Annuler
                        </button>
                        <button
                          onClick={async () => {
                            try {
                              const formData = new FormData();
                              Object.entries(imapForm).forEach(([k, v]) => formData.append(k, v.toString()));
                              const resp = await authFetch(`${API}/imap/save-config`, { method: 'POST', body: formData });
                              if (resp.ok) {
                                setShowImapModal(false);
                                loadData();
                              } else {
                                const err = await resp.json();
                                alert(err.detail || 'Erreur de sauvegarde');
                              }
                            } catch (e) {
                              alert('Erreur de sauvegarde');
                            }
                          }}
                          disabled={!imapForm.server || !imapForm.email_address || !imapForm.password}
                          className="px-6 py-2 bg-blue-600 hover:bg-blue-700 rounded-lg flex items-center gap-2 disabled:opacity-50"
                        >
                          <Save className="w-4 h-4" /> Sauvegarder
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {/* CONNECTEUR SMS */}
              {activeSection === "connector-sms" && (
                <div className="space-y-6">
                  <div className="bg-gradient-to-br from-green-500/10 to-emerald-500/10 border border-green-500/30 rounded-xl p-6">
                    <div className="flex items-center gap-4">
                      <div className="w-14 h-14 bg-gradient-to-br from-green-500 to-emerald-500 rounded-xl flex items-center justify-center">
                        <MessageCircle className="w-7 h-7 text-white" />
                      </div>
                      <div>
                        <h2 className="text-xl font-bold">Connecteur SMS</h2>
                        <p className="text-slate-400">Configurez les providers SMS pour envoi/réception</p>
                      </div>
                    </div>
                  </div>

                  {/* Provider actuel - Ringover */}
                  <div className="bg-slate-800/50 border border-slate-700/50 rounded-xl overflow-hidden">
                    <div className="p-4 border-b border-slate-700/50">
                      <h3 className="font-semibold">Provider actuel</h3>
                    </div>
                    <div className="p-4">
                      <div className="flex items-center justify-between bg-emerald-500/10 border border-emerald-500/30 rounded-lg p-4">
                        <div className="flex items-center gap-3">
                          <div className="w-10 h-10 bg-orange-500/20 rounded-lg flex items-center justify-center">
                            <Phone className="w-5 h-5 text-orange-400" />
                          </div>
                          <div>
                            <p className="font-semibold">Ringover SMS</p>
                            <p className="text-xs text-slate-400">Via votre compte Ringover existant</p>
                          </div>
                        </div>
                        <span className="px-3 py-1 bg-emerald-500/20 text-emerald-400 rounded text-xs flex items-center gap-1">
                          <CheckCircle className="w-3 h-3" /> Connecté
                        </span>
                      </div>
                    </div>
                  </div>

                  {/* Ajouter un provider */}
                  <div className="bg-slate-800/50 border border-slate-700/50 rounded-xl overflow-hidden">
                    <div className="p-4 border-b border-slate-700/50">
                      <h3 className="font-semibold">Ajouter un provider SMS</h3>
                    </div>
                    <div className="p-4 grid grid-cols-3 gap-4">
                      <div className="bg-slate-900/50 border border-dashed border-slate-600 rounded-lg p-4 text-center cursor-pointer hover:border-green-500/50 transition-colors">
                        <div className="w-12 h-12 bg-red-500/20 rounded-lg flex items-center justify-center mx-auto mb-3">
                          <span className="text-2xl">📱</span>
                        </div>
                        <p className="font-medium">Twilio</p>
                        <p className="text-xs text-slate-500 mt-1">SMS & WhatsApp</p>
                        <span className="inline-block mt-2 px-2 py-1 bg-slate-700 rounded text-xs">🔜 Bientôt</span>
                      </div>
                      <div className="bg-slate-900/50 border border-dashed border-slate-600 rounded-lg p-4 text-center cursor-pointer hover:border-green-500/50 transition-colors">
                        <div className="w-12 h-12 bg-blue-500/20 rounded-lg flex items-center justify-center mx-auto mb-3">
                          <span className="text-2xl">📨</span>
                        </div>
                        <p className="font-medium">OVH SMS</p>
                        <p className="text-xs text-slate-500 mt-1">SMS Pro</p>
                        <span className="inline-block mt-2 px-2 py-1 bg-slate-700 rounded text-xs">🔜 Bientôt</span>
                      </div>
                      <div className="bg-slate-900/50 border border-dashed border-slate-600 rounded-lg p-4 text-center cursor-pointer hover:border-green-500/50 transition-colors">
                        <div className="w-12 h-12 bg-purple-500/20 rounded-lg flex items-center justify-center mx-auto mb-3">
                          <span className="text-2xl">✉️</span>
                        </div>
                        <p className="font-medium">SendinBlue</p>
                        <p className="text-xs text-slate-500 mt-1">SMS Marketing</p>
                        <span className="inline-block mt-2 px-2 py-1 bg-slate-700 rounded text-xs">🔜 Bientôt</span>
                      </div>
                    </div>
                  </div>

                  {/* Historique SMS Ringover */}
                  <div className="bg-slate-800/50 border border-slate-700/50 rounded-xl overflow-hidden">
                    <div className="p-4 border-b border-slate-700/50 flex items-center justify-between">
                      <h3 className="font-semibold flex items-center gap-2">
                        <History className="w-5 h-5 text-green-400" />
                        Historique SMS ({smsStats.total})
                      </h3>
                      <div className="flex items-center gap-2 text-xs">
                        <span className="text-blue-400">{smsStats.inbound} entrants</span>
                        <span className="text-slate-600">•</span>
                        <span className="text-emerald-400">{smsStats.outbound} sortants</span>
                      </div>
                    </div>
                    <div className="divide-y divide-slate-700/50 max-h-64 overflow-y-auto">
                      {smsHistory.length === 0 ? (
                        <div className="p-6 text-center text-slate-500">
                          <MessageCircle className="w-8 h-8 mx-auto mb-2 opacity-50" />
                          <p className="text-sm">Aucun SMS dans l'historique</p>
                        </div>
                      ) : smsHistory.map((sms, idx) => (
                        <div key={idx} className="p-3 hover:bg-slate-800/50">
                          <div className="flex items-start gap-3">
                            <div className={`w-8 h-8 rounded-lg flex items-center justify-center flex-shrink-0 ${
                              sms.direction === 'inbound' ? 'bg-blue-500/20' : 'bg-emerald-500/20'
                            }`}>
                              {sms.direction === 'inbound' ? (
                                <MessageCircle className="w-4 h-4 text-blue-400" />
                              ) : (
                                <Send className="w-4 h-4 text-emerald-400" />
                              )}
                            </div>
                            <div className="flex-1 min-w-0">
                              <div className="flex items-center gap-2">
                                <p className="font-medium text-sm">{sms.contact_name || sms.from_number}</p>
                                <span className={`px-2 py-0.5 rounded text-xs ${
                                  sms.direction === 'inbound' ? 'bg-blue-500/20 text-blue-400' : 'bg-emerald-500/20 text-emerald-400'
                                }`}>
                                  {sms.direction === 'inbound' ? 'Reçu' : 'Envoyé'}
                                </span>
                              </div>
                              <p className="text-xs text-slate-400 truncate mt-1">{sms.content}</p>
                              <p className="text-xs text-slate-600 mt-1">
                                {sms.timestamp && new Date(sms.timestamp).toLocaleString('fr-FR')}
                                {sms.user_name && <span> • {sms.user_name}</span>}
                              </p>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              )}

              {/* CONNECTEUR WHATSAPP */}
              {activeSection === "connector-whatsapp" && (
                <div className="space-y-6">
                  <div className="bg-gradient-to-br from-green-500/10 to-lime-500/10 border border-green-500/30 rounded-xl p-6">
                    <div className="flex items-center gap-4">
                      <div className="w-14 h-14 bg-gradient-to-br from-green-500 to-lime-500 rounded-xl flex items-center justify-center">
                        <Send className="w-7 h-7 text-white" />
                      </div>
                      <div>
                        <h2 className="text-xl font-bold">Connecteur WhatsApp</h2>
                        <p className="text-slate-400">Envoyez des messages WhatsApp à vos collaborateurs</p>
                      </div>
                    </div>
                  </div>

                  <WhatsAppManager />
                </div>
              )}

              {/* HISTORIQUE DES CONVERSATIONS */}
              {activeSection === "conversations-history" && (
                <div className="space-y-6">
                  <ConversationsHistory />
                </div>
              )}

              {/* SCHEDULER CRON */}
              {activeSection === "scheduler" && (
                <div className="space-y-6">
                  <SchedulerManager />
                </div>
              )}

              {/* DÉPENSES IA & API */}
              {activeSection === "costs" && (
                <div className="space-y-6">
                  <div className="bg-gradient-to-br from-amber-500/10 to-orange-500/10 border border-amber-500/30 rounded-xl p-6">
                    <div className="flex items-center justify-between">
                      <div className="flex items-center gap-4">
                        <div className="w-14 h-14 bg-gradient-to-br from-amber-500 to-orange-500 rounded-xl flex items-center justify-center">
                          <CreditCard className="w-7 h-7 text-white" />
                        </div>
                        <div>
                          <h2 className="text-xl font-bold" data-testid="costs-title">Dépenses IA & API</h2>
                          <p className="text-sm text-slate-400">Suivi des coûts de traitement IA et volumes API</p>
                        </div>
                      </div>
                      <div className="flex items-center gap-2">
                        <select
                          value={costPeriod}
                          onChange={(e) => setCostPeriod(Number(e.target.value))}
                          className="bg-slate-800 border border-slate-700 rounded-lg px-3 py-2 text-sm"
                          data-testid="costs-period-select"
                        >
                          <option value={7}>7 derniers jours</option>
                          <option value={30}>30 derniers jours</option>
                          <option value={90}>3 mois</option>
                          <option value={365}>1 an</option>
                        </select>
                        <button
                          onClick={loadCostData}
                          className="p-2 text-amber-400 hover:bg-amber-500/20 rounded-lg"
                          data-testid="costs-refresh-btn"
                        >
                          <RefreshCw className={`w-4 h-4 ${loadingCosts ? 'animate-spin' : ''}`} />
                        </button>
                      </div>
                    </div>
                  </div>

                  {/* ═══ Gestion des services IA & API ═══ */}
                  {servicesConfig.length > 0 && (
                    <div className="bg-slate-800/50 border border-slate-700 rounded-xl p-6" data-testid="services-toggle-panel">
                      <h3 className="font-semibold mb-1 flex items-center gap-2">
                        <Power className="w-5 h-5 text-amber-400" />
                        Gestion des services
                      </h3>
                      <p className="text-xs text-slate-500 mb-4">Activez ou désactivez chaque service IA & API. Un service désactivé ne sera plus appelé.</p>
                      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-3">
                        {servicesConfig.filter(s => !s.manage_webhooks).map((svc) => {
                          const isEnabled = svc.mode !== "disabled";
                          const isToggling = togglingService === svc.id;
                          const costMatch = costData?.by_service?.find(c => {
                            const svcLower = (c.service || "").toLowerCase();
                            const idLower = svc.id.toLowerCase().replace(/_/g, "");
                            return svcLower.includes(idLower) || idLower.includes(svcLower.replace(/_/g, ""));
                          });
                          return (
                            <div
                              key={svc.id}
                              data-testid={`service-toggle-${svc.id}`}
                              className={`relative flex items-center gap-3 p-3.5 rounded-xl border transition-all ${
                                isEnabled
                                  ? "bg-slate-900/40 border-slate-600/50 hover:border-slate-500/60"
                                  : "bg-slate-900/20 border-slate-700/30 opacity-60"
                              }`}
                            >
                              <div
                                className="w-9 h-9 rounded-lg flex items-center justify-center shrink-0"
                                style={{ backgroundColor: `${svc.color}20`, color: svc.color }}
                              >
                                {svc.icon === "brain" && <Brain className="w-4 h-4" />}
                                {svc.icon === "phone" && <Phone className="w-4 h-4" />}
                                {svc.icon === "smartphone" && <Phone className="w-4 h-4" />}
                                {svc.icon === "message-square" && <MessageSquare className="w-4 h-4" />}
                                {svc.icon === "message-circle" && <MessageCircle className="w-4 h-4" />}
                                {svc.icon === "table" && <TableProperties className="w-4 h-4" />}
                                {svc.icon === "hard-drive" && <HardDrive className="w-4 h-4" />}
                                {svc.icon === "mail" && <Mail className="w-4 h-4" />}
                                {svc.icon === "palette" && <Sparkles className="w-4 h-4" />}
                                {svc.icon === "receipt" && <FileText className="w-4 h-4" />}
                                {svc.icon === "credit-card" && <CreditCard className="w-4 h-4" />}
                                {svc.icon === "send" && <Send className="w-4 h-4" />}
                                {svc.icon === "globe" && <Globe className="w-4 h-4" />}
                                {svc.icon === "audio-lines" && <Mic className="w-4 h-4" />}
                                {svc.icon === "mic" && <Mic className="w-4 h-4" />}
                                {svc.icon === "video" && <Play className="w-4 h-4" />}
                                {svc.icon === "trending-up" && <TrendingUp className="w-4 h-4" />}
                                {!["brain","phone","smartphone","message-square","message-circle","table","hard-drive","mail","palette","receipt","credit-card","send","globe","audio-lines","mic","video","trending-up"].includes(svc.icon) && <Zap className="w-4 h-4" />}
                              </div>
                              <div className="flex-1 min-w-0">
                                <div className="flex items-center gap-2">
                                  <span className="text-sm font-medium text-slate-200 truncate">{svc.name}</span>
                                  {svc.mode === "own_key" && (
                                    <span className="text-[10px] px-1.5 py-0.5 rounded bg-blue-500/20 text-blue-400 border border-blue-500/30">Clé propre</span>
                                  )}
                                </div>
                                <p className="text-[11px] text-slate-500 truncate mt-0.5">{svc.description}</p>
                                {costMatch && (
                                  <p className="text-[11px] text-green-400 mt-0.5">{costMatch.calls} appels · {costMatch.cost_eur.toFixed(3)} EUR</p>
                                )}
                              </div>
                              <button
                                data-testid={`toggle-btn-${svc.id}`}
                                onClick={() => toggleServiceEnabled(svc.id, svc.mode)}
                                disabled={isToggling || svc.platform_only}
                                className={`shrink-0 w-11 h-6 rounded-full relative transition-colors duration-200 ${
                                  svc.platform_only
                                    ? "bg-slate-700 cursor-not-allowed"
                                    : isEnabled
                                      ? "bg-emerald-500 hover:bg-emerald-400"
                                      : "bg-slate-600 hover:bg-slate-500"
                                }`}
                                title={svc.platform_only ? "Infrastructure plateforme" : isEnabled ? "Désactiver" : "Activer"}
                              >
                                <div className={`absolute top-0.5 w-5 h-5 rounded-full bg-white shadow transition-transform duration-200 ${
                                  isEnabled ? "translate-x-[22px]" : "translate-x-0.5"
                                }`}>
                                  {isToggling && (
                                    <RefreshCw className="w-3 h-3 animate-spin text-slate-500 absolute top-1 left-1" />
                                  )}
                                </div>
                              </button>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  )}

                  {loadingCosts ? (
                    <div className="flex items-center justify-center py-12">
                      <RefreshCw className="w-8 h-8 animate-spin text-amber-400" />
                    </div>
                  ) : costError ? (
                    <div className="flex flex-col items-center justify-center py-8 gap-3">
                      <AlertTriangle className="w-8 h-8 text-red-400" />
                      <p className="text-center text-red-400 text-sm">{costError}</p>
                      <button onClick={loadCostData} className="px-4 py-2 bg-amber-500/20 hover:bg-amber-500/30 text-amber-400 rounded-lg text-sm transition-colors">
                        Réessayer
                      </button>
                    </div>
                  ) : costData ? (
                    <>
                      {/* Cartes résumé */}
                      <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
                        <div className="bg-slate-800/50 border border-slate-700 rounded-xl p-5" data-testid="costs-total-calls">
                          <p className="text-xs text-slate-400 uppercase tracking-wide">Appels IA</p>
                          <p className="text-2xl font-bold mt-1 text-amber-400">{costData.totals?.total_calls || 0}</p>
                          <p className="text-xs text-slate-500 mt-1">sur {costPeriod} jours</p>
                        </div>
                        <div className="bg-slate-800/50 border border-slate-700 rounded-xl p-5" data-testid="costs-total-cost">
                          <p className="text-xs text-slate-400 uppercase tracking-wide">Coût estimé</p>
                          <p className="text-2xl font-bold mt-1 text-green-400">{(costData.totals?.total_cost_eur || 0).toFixed(2)} EUR</p>
                          <p className="text-xs text-slate-500 mt-1">sur {costPeriod} jours</p>
                        </div>
                        <div className="bg-slate-800/50 border border-slate-700 rounded-xl p-5" data-testid="costs-pending">
                          <p className="text-xs text-slate-400 uppercase tracking-wide">Emails en attente IA</p>
                          <p className="text-2xl font-bold mt-1 text-orange-400">{costData.estimates?.pending_email_processing?.pending_count || 0}</p>
                          <p className="text-xs text-slate-500 mt-1">Coût estimé : {costData.estimates?.pending_email_processing?.estimated_cost_eur || 0} EUR</p>
                        </div>
                        <div className="bg-slate-800/50 border border-slate-700 rounded-xl p-5" data-testid="costs-tokens">
                          <p className="text-xs text-slate-400 uppercase tracking-wide">Tokens consommés</p>
                          <p className="text-2xl font-bold mt-1 text-blue-400">{(costData.totals?.total_tokens || 0).toLocaleString()}</p>
                          <p className="text-xs text-slate-500 mt-1">input + output</p>
                        </div>
                      </div>

                      {/* Détail par service */}
                      <div className="bg-slate-800/50 border border-slate-700 rounded-xl p-6" data-testid="costs-by-service">
                        <h3 className="font-semibold mb-4 flex items-center gap-2">
                          <Bot className="w-5 h-5 text-amber-400" />
                          Dépenses par service
                        </h3>
                        {costData.by_service?.length > 0 ? (
                          <div className="space-y-3">
                            {costData.by_service.map((svc, idx) => {
                              const maxCalls = Math.max(...costData.by_service.map(s => s.calls));
                              const barWidth = maxCalls > 0 ? (svc.calls / maxCalls) * 100 : 0;
                              return (
                                <div key={idx} className="space-y-1">
                                  <div className="flex items-center justify-between text-sm">
                                    <span className="font-medium capitalize">{svc.service.replace(/_/g, ' ')}</span>
                                    <div className="flex items-center gap-4 text-slate-400">
                                      <span>{svc.calls} appels</span>
                                      <span className="text-green-400 font-medium">{svc.cost_eur.toFixed(3)} EUR</span>
                                    </div>
                                  </div>
                                  <div className="w-full bg-slate-700 rounded-full h-2">
                                    <div
                                      className="bg-gradient-to-r from-amber-500 to-orange-500 h-2 rounded-full transition-all"
                                      style={{ width: `${barWidth}%` }}
                                    />
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        ) : (
                          <p className="text-slate-500 text-center py-4">Aucune dépense enregistrée sur cette période</p>
                        )}
                      </div>

                      {/* Évolution quotidienne */}
                      {costData.daily?.length > 0 && (
                        <div className="bg-slate-800/50 border border-slate-700 rounded-xl p-6" data-testid="costs-daily">
                          <h3 className="font-semibold mb-4 flex items-center gap-2">
                            <Clock className="w-5 h-5 text-amber-400" />
                            Évolution (7 derniers jours)
                          </h3>
                          <div className="space-y-2">
                            {costData.daily.map((day, idx) => {
                              const maxDailyCost = Math.max(...costData.daily.map(d => d.cost_eur));
                              const barW = maxDailyCost > 0 ? (day.cost_eur / maxDailyCost) * 100 : 0;
                              return (
                                <div key={idx} className="flex items-center gap-3">
                                  <span className="text-xs text-slate-400 w-20 shrink-0">{day.date.slice(5)}</span>
                                  <div className="flex-1 bg-slate-700 rounded-full h-3">
                                    <div
                                      className="bg-gradient-to-r from-green-500 to-emerald-400 h-3 rounded-full transition-all"
                                      style={{ width: `${Math.max(barW, 2)}%` }}
                                    />
                                  </div>
                                  <div className="flex items-center gap-3 w-40 justify-end shrink-0">
                                    <span className="text-xs text-slate-400">{day.calls} appels</span>
                                    <span className="text-xs text-green-400 font-medium">{day.cost_eur.toFixed(3)} EUR</span>
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      )}

                      {/* Volumes API */}
                      <div className="bg-slate-800/50 border border-slate-700 rounded-xl p-6" data-testid="costs-volumes">
                        <h3 className="font-semibold mb-4 flex items-center gap-2">
                          <Database className="w-5 h-5 text-blue-400" />
                          Volumes de données (total)
                        </h3>
                        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                          <div className="text-center p-3 bg-slate-900/50 rounded-lg">
                            <Mail className="w-5 h-5 text-purple-400 mx-auto mb-1" />
                            <p className="text-lg font-bold">{(costData.volumes?.imap_emails_total || 0).toLocaleString()}</p>
                            <p className="text-xs text-slate-400">Emails synchronisés</p>
                          </div>
                          <div className="text-center p-3 bg-slate-900/50 rounded-lg">
                            <Bot className="w-5 h-5 text-green-400 mx-auto mb-1" />
                            <p className="text-lg font-bold">{costData.volumes?.imap_emails_processed || 0}</p>
                            <p className="text-xs text-slate-400">Traités par IA</p>
                          </div>
                          <div className="text-center p-3 bg-slate-900/50 rounded-lg">
                            <Phone className="w-5 h-5 text-blue-400 mx-auto mb-1" />
                            <p className="text-lg font-bold">{(costData.volumes?.ringover_calls || 0).toLocaleString()}</p>
                            <p className="text-xs text-slate-400">Appels Ringover</p>
                          </div>
                          <div className="text-center p-3 bg-slate-900/50 rounded-lg">
                            <MessageSquare className="w-5 h-5 text-teal-400 mx-auto mb-1" />
                            <p className="text-lg font-bold">{costData.volumes?.ringover_sms || 0}</p>
                            <p className="text-xs text-slate-400">SMS Ringover</p>
                          </div>
                        </div>
                      </div>

                      {/* Grille de tarifs */}
                      <div className="bg-slate-800/50 border border-slate-700 rounded-xl p-6" data-testid="costs-rates">
                        <h3 className="font-semibold mb-4 flex items-center gap-2">
                          <Settings className="w-5 h-5 text-slate-400" />
                          Grille tarifaire (coût estimé par appel)
                        </h3>
                        <div className="grid grid-cols-2 md:grid-cols-3 gap-2">
                          {costData.rates && Object.entries(costData.rates).map(([key, rate]) => (
                            <div key={key} className="flex items-center justify-between p-2 bg-slate-900/50 rounded-lg text-xs">
                              <span className="text-slate-400 capitalize">{key.replace(/_/g, ' ')}</span>
                              <span className="text-green-400 font-mono">{rate.toFixed(3)} EUR</span>
                            </div>
                          ))}
                        </div>
                      </div>
                    </>
                  ) : (
                    <p className="text-center text-slate-500 py-8">Aucune donnée de coût disponible</p>
                  )}
                </div>
              )}

              {/* GESTIONNAIRE DES DASHBOARDS */}
              {activeSection === "dashboards-manager" && (
                <DashboardManager />
              )}

              {/* TARIFS & ABONNEMENT (tenant admin) */}
              {activeSection === "tarifs-abonnement" && (
                <div data-testid="tarifs-abonnement-section" className="space-y-6">
                  <div className="bg-gradient-to-br from-amber-500/10 to-orange-500/10 border border-amber-500/30 rounded-xl p-6">
                    <div className="flex items-center gap-4">
                      <div className="w-14 h-14 bg-gradient-to-br from-amber-500 to-orange-500 rounded-xl flex items-center justify-center">
                        <CreditCard className="w-7 h-7 text-white" />
                      </div>
                      <div>
                        <h2 className="text-xl font-bold">Tarifs & Abonnement</h2>
                        <p className="text-slate-400 text-sm">Consultez la grille tarifaire et estimez vos couts</p>
                      </div>
                    </div>
                  </div>

                  <div className="bg-slate-800/60 border border-slate-700/50 rounded-xl p-6 space-y-4">
                    <p className="text-slate-300 text-sm">
                      Retrouvez le detail complet de notre offre Premium : tarifs par siege, modules complementaires, frais de mise en service et un estimateur de cout interactif.
                    </p>
                    <a
                      href="/pricing"
                      target="_blank"
                      rel="noopener noreferrer"
                      data-testid="tarifs-view-pricing-link"
                      className="inline-flex items-center gap-2 px-5 py-3 bg-gradient-to-r from-amber-500 to-orange-500 hover:from-amber-600 hover:to-orange-600 text-white font-semibold rounded-xl transition-all duration-200 shadow-lg hover:shadow-xl text-sm"
                    >
                      <ExternalLink className="w-4 h-4" />
                      Voir la grille tarifaire complete
                    </a>
                  </div>
                </div>
              )}

              {/* CONNECTEUR ÉCHANGES SAN-IA */}
              {activeSection === "connector-sania" && (
                <div className="space-y-6">
                  <div className="bg-gradient-to-br from-purple-500/10 to-pink-500/10 border border-purple-500/30 rounded-xl p-6">
                    <div className="flex items-center gap-4">
                      <div className="w-14 h-14 bg-gradient-to-br from-purple-500 to-pink-500 rounded-xl flex items-center justify-center">
                        <Brain className="w-7 h-7 text-white" />
                      </div>
                      <div>
                        <h2 className="text-xl font-bold">Échanges SAN-IA</h2>
                        <p className="text-slate-400">Les conversations avec les agents IA enrichissent automatiquement les fiches</p>
                      </div>
                    </div>
                  </div>

                  {/* Pôles connectés */}
                  <div className="bg-slate-800/50 border border-slate-700/50 rounded-xl overflow-hidden">
                    <div className="p-4 border-b border-slate-700/50">
                      <h3 className="font-semibold">Pôles connectés à l'enrichissement</h3>
                    </div>
                    <div className="p-4 space-y-3">
                      {['telepro', 'amo', 'admin', 'compta', 'r1', 'r2', 'marketing_com'].map((pole, idx) => (
                        <div key={idx} className="flex items-center justify-between bg-slate-900/50 rounded-lg p-3">
                          <div className="flex items-center gap-3">
                            <div className="w-10 h-10 bg-purple-500/20 rounded-lg flex items-center justify-center">
                              <Brain className="w-5 h-5 text-purple-400" />
                            </div>
                            <div>
                              <p className="font-medium capitalize">SAN-IA {pole.replace('_', ' ')}</p>
                              <p className="text-xs text-slate-500">Chat avec collaborateurs</p>
                            </div>
                          </div>
                          <span className="px-3 py-1 bg-emerald-500/20 text-emerald-400 rounded text-xs flex items-center gap-1">
                            <CheckCircle className="w-3 h-3" /> Actif
                          </span>
                        </div>
                      ))}
                    </div>
                  </div>

                  {/* Configuration */}
                  <div className="bg-slate-800/50 border border-slate-700/50 rounded-xl overflow-hidden">
                    <div className="p-4 border-b border-slate-700/50">
                      <h3 className="font-semibold">Configuration</h3>
                    </div>
                    <div className="p-4 space-y-3">
                      <label className="flex items-center justify-between bg-slate-900/50 rounded-lg p-3 cursor-pointer">
                        <div>
                          <p className="font-medium text-sm">Résumé IA automatique</p>
                          <p className="text-xs text-slate-500">SAN-IA résume les échanges avant enrichissement</p>
                        </div>
                        <div className={`w-3 h-3 rounded-full ${enrichmentConfig?.ai_summarize ? 'bg-emerald-500' : 'bg-slate-500'}`} />
                      </label>
                      <label className="flex items-center justify-between bg-slate-900/50 rounded-lg p-3 cursor-pointer">
                        <div>
                          <p className="font-medium text-sm">Extraction d'informations clés</p>
                          <p className="text-xs text-slate-500">Détecte automatiquement dates, montants, noms...</p>
                        </div>
                        <div className={`w-3 h-3 rounded-full ${enrichmentConfig?.enrichment_rules?.extract_key_info ? 'bg-emerald-500' : 'bg-slate-500'}`} />
                      </label>
                    </div>
                  </div>
                </div>
              )}

              {/* CONNECTEURS FOURNISSEURS */}
              {activeSection === "connector-fournisseurs" && (
                <ConnecteursFournisseursSection />
              )}

              {/* AUTOMATISATIONS */}
              {activeSection === "automations" && (
                <div className="space-y-6">
                  <div className="bg-gradient-to-br from-amber-500/10 to-orange-500/10 border border-amber-500/30 rounded-xl p-6">
                    <div className="flex items-center gap-4">
                      <div className="w-14 h-14 bg-gradient-to-br from-amber-500 to-orange-500 rounded-xl flex items-center justify-center">
                        <Zap className="w-7 h-7 text-white" />
                      </div>
                      <div>
                        <h2 className="text-xl font-bold">Automatisations</h2>
                        <p className="text-slate-400">Configurez les actions automatiques (SMS, notifications, etc.)</p>
                      </div>
                    </div>
                  </div>

                  {/* Automatisations SMS */}
                  <div className="bg-slate-800/50 border border-slate-700/50 rounded-xl overflow-hidden">
                    <div className="p-4 border-b border-slate-700/50 flex items-center gap-3">
                      <MessageCircle className="w-5 h-5 text-green-400" />
                      <h3 className="font-semibold">Automatisations SMS</h3>
                    </div>
                    <div className="p-4 space-y-4">
                      <label className="flex items-center justify-between bg-slate-900/50 rounded-lg p-4 cursor-pointer hover:bg-slate-900/70 transition-colors">
                        <div className="flex items-center gap-4">
                          <div className="w-10 h-10 bg-blue-500/20 rounded-lg flex items-center justify-center">
                            <Calendar className="w-5 h-5 text-blue-400" />
                          </div>
                          <div>
                            <p className="font-medium">Confirmation de RDV</p>
                            <p className="text-xs text-slate-500">Envoyer un SMS automatique après prise de RDV</p>
                          </div>
                        </div>
                        <input
                          type="checkbox"
                          checked={enrichmentConfig?.sms_config?.auto_confirm_rdv || false}
                          onChange={async (e) => {
                            const formData = new FormData();
                            formData.append('auto_confirm_rdv', e.target.checked);
                            formData.append('enabled', 'true');
                            await authFetch(`${API}/enrichment/sms-config`, { method: 'PUT', body: formData });
                            loadData();
                          }}
                          className="w-6 h-6 rounded bg-slate-700 border-slate-600 text-amber-500"
                        />
                      </label>
                      
                      <label className="flex items-center justify-between bg-slate-900/50 rounded-lg p-4 cursor-pointer hover:bg-slate-900/70 transition-colors">
                        <div className="flex items-center gap-4">
                          <div className="w-10 h-10 bg-emerald-500/20 rounded-lg flex items-center justify-center">
                            <Users className="w-5 h-5 text-emerald-400" />
                          </div>
                          <div>
                            <p className="font-medium">Bienvenue nouveau lead</p>
                            <p className="text-xs text-slate-500">Envoyer un SMS d'accueil dès qu'un lead arrive</p>
                          </div>
                        </div>
                        <input
                          type="checkbox"
                          checked={enrichmentConfig?.sms_config?.auto_welcome_lead || false}
                          onChange={async (e) => {
                            const formData = new FormData();
                            formData.append('auto_welcome_lead', e.target.checked);
                            formData.append('enabled', 'true');
                            await authFetch(`${API}/enrichment/sms-config`, { method: 'PUT', body: formData });
                            loadData();
                          }}
                          className="w-6 h-6 rounded bg-slate-700 border-slate-600 text-amber-500"
                        />
                      </label>
                      
                      <label className="flex items-center justify-between bg-slate-900/50 rounded-lg p-4 cursor-pointer hover:bg-slate-900/70 transition-colors opacity-50">
                        <div className="flex items-center gap-4">
                          <div className="w-10 h-10 bg-orange-500/20 rounded-lg flex items-center justify-center">
                            <Clock className="w-5 h-5 text-orange-400" />
                          </div>
                          <div>
                            <p className="font-medium">Rappel de RDV (J-1)</p>
                            <p className="text-xs text-slate-500">Rappel automatique la veille du rendez-vous</p>
                          </div>
                        </div>
                        <span className="px-2 py-1 bg-slate-700 rounded text-xs">🔜 Bientôt</span>
                      </label>
                      
                      <label className="flex items-center justify-between bg-slate-900/50 rounded-lg p-4 cursor-pointer hover:bg-slate-900/70 transition-colors opacity-50">
                        <div className="flex items-center gap-4">
                          <div className="w-10 h-10 bg-purple-500/20 rounded-lg flex items-center justify-center">
                            <FileText className="w-5 h-5 text-purple-400" />
                          </div>
                          <div>
                            <p className="font-medium">Mise à jour dossier</p>
                            <p className="text-xs text-slate-500">Notifier le client quand son dossier avance</p>
                          </div>
                        </div>
                        <span className="px-2 py-1 bg-slate-700 rounded text-xs">🔜 Bientôt</span>
                      </label>
                    </div>
                  </div>

                  {/* Templates SMS */}
                  <div className="bg-slate-800/50 border border-slate-700/50 rounded-xl overflow-hidden">
                    <div className="p-4 border-b border-slate-700/50 flex items-center gap-3">
                      <FileText className="w-5 h-5 text-cyan-400" />
                      <h3 className="font-semibold">Templates SMS</h3>
                    </div>
                    <div className="p-4 space-y-4">
                      <div className="bg-slate-900/50 rounded-lg p-4">
                        <div className="flex items-center justify-between mb-2">
                          <p className="font-medium text-sm">Confirmation RDV</p>
                          <button className="text-xs text-blue-400 hover:text-blue-300">Modifier</button>
                        </div>
                        <p className="text-xs text-slate-400 bg-slate-800 rounded p-2">
                          {enrichmentConfig?.sms_config?.templates?.confirm_rdv || "Bonjour {prenom}, votre RDV du {date} à {heure} est confirmé. SANI ADAPT"}
                        </p>
                      </div>
                      <div className="bg-slate-900/50 rounded-lg p-4">
                        <div className="flex items-center justify-between mb-2">
                          <p className="font-medium text-sm">Bienvenue lead</p>
                          <button className="text-xs text-blue-400 hover:text-blue-300">Modifier</button>
                        </div>
                        <p className="text-xs text-slate-400 bg-slate-800 rounded p-2">
                          {enrichmentConfig?.sms_config?.templates?.welcome_lead || "Bonjour {prenom}, merci pour votre intérêt. Un conseiller vous contactera rapidement. SANI ADAPT"}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {/* ÉLÉMENTS DE DÉCLENCHEMENT */}
              {activeSection === "elements-declenchement" && (
                <ElementsDeclenchement />
              )}

              {/* CONFIGURATION PIPELINE */}
              {activeSection === "pipeline-config" && (
                <PipelineConfigPanel />
              )}

              {/* PIPELINE WORKFLOW */}
              {activeSection === "pipeline-workflow" && (
                <PipelineWorkflow />
              )}

              {/* SOCIALAC WORKFLOW */}
              {activeSection === "socialac-workflow" && (
                <SocialACWorkflow />
              )}

              {/* MAPPINGS FORMULAIRES */}
              {activeSection === "formulaires-mapping" && (
                <FormulairesMapping />
              )}

              {/* CONFIGURATION APPELS ENTRANTS */}
              {activeSection === "appels-entrants-config" && (
                <AppelsEntrantsConfigPanel />
              )}

              {/* CONFIGURATION SMS */}
              {activeSection === "sms-config" && (
                <SMSConfigPanel />
              )}

              {/* CONFIGURATION GLOBALE DES DASHBOARDS */}
              {activeSection === "dashboard-config" && (
                <div className="space-y-6">
                  {/* Header */}
                  <div className="bg-gradient-to-r from-purple-500/10 to-blue-500/10 border border-purple-500/30 rounded-xl p-4">
                    <div className="flex items-center gap-3">
                      <div className="w-10 h-10 rounded-xl bg-purple-500/20 flex items-center justify-center">
                        <Settings className="w-5 h-5 text-purple-400" />
                      </div>
                      <div>
                        <h2 className="font-bold text-white">Configuration Globale des Dashboards</h2>
                        <p className="text-sm text-slate-400">Personnalisez les messages, alertes et comportements de l'application</p>
                      </div>
                    </div>
                  </div>

                  {/* Onglets */}
                  <div className="flex gap-2 bg-slate-800/50 p-1 rounded-xl">
                    {[
                      { id: "marche", label: "📊 Marché & Objectifs", color: "blue" },
                      { id: "dashboards", label: "📋 Visibilité Dashboards", color: "green" },
                      { id: "widgets", label: "🧩 Widgets & Colonnes", color: "cyan" }
                    ].map(tab => (
                      <button
                        key={tab.id}
                        onClick={() => setGlobalConfigTab(tab.id)}
                        className={`flex-1 px-4 py-2 rounded-lg text-sm font-medium transition-all ${
                          globalConfigTab === tab.id 
                            ? `bg-${tab.color}-500/20 text-${tab.color}-400 border border-${tab.color}-500/30`
                            : 'text-slate-400 hover:text-white hover:bg-slate-700/50'
                        }`}
                      >
                        {tab.label}
                      </button>
                    ))}
                  </div>

                  {globalConfigLoading ? (
                    <div className="flex items-center justify-center py-12">
                      <RefreshCw className="w-8 h-8 animate-spin text-purple-400" />
                    </div>
                  ) : (
                    <>
                      {/* Onglet Marché */}
                      {globalConfigTab === "marche" && globalConfig && (
                        <div className="space-y-4">
                          <div className="bg-slate-800/50 rounded-xl border border-slate-700/50 p-6 space-y-4">
                            <h3 className="font-semibold text-blue-400 flex items-center gap-2">
                              <TrendingUp className="w-5 h-5" />
                              Informations Marché
                            </h3>
                            
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                              <div>
                                <label className="block text-sm text-slate-400 mb-1">Nom du Programme</label>
                                <input
                                  type="text"
                                  value={globalConfig.marche?.nom_programme || ""}
                                  onChange={(e) => setGlobalConfig({
                                    ...globalConfig,
                                    marche: { ...globalConfig.marche, nom_programme: e.target.value }
                                  })}
                                  className="w-full bg-slate-900 border border-slate-700 rounded-lg px-3 py-2 text-white"
                                />
                              </div>
                              <div>
                                <label className="block text-sm text-slate-400 mb-1">Infos Secteur</label>
                                <input
                                  type="text"
                                  value={globalConfig.marche?.infos_secteur || ""}
                                  onChange={(e) => setGlobalConfig({
                                    ...globalConfig,
                                    marche: { ...globalConfig.marche, infos_secteur: e.target.value }
                                  })}
                                  className="w-full bg-slate-900 border border-slate-700 rounded-lg px-3 py-2 text-white"
                                />
                              </div>
                            </div>
                            
                            <div>
                              <label className="block text-sm text-slate-400 mb-1">Description</label>
                              <textarea
                                value={globalConfig.marche?.description || ""}
                                onChange={(e) => setGlobalConfig({
                                  ...globalConfig,
                                  marche: { ...globalConfig.marche, description: e.target.value }
                                })}
                                rows={3}
                                className="w-full bg-slate-900 border border-slate-700 rounded-lg px-3 py-2 text-white"
                              />
                            </div>

                            <h4 className="font-medium text-slate-300 mt-4">Objectifs Annuels</h4>
                            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                              <div>
                                <label className="block text-sm text-slate-400 mb-1">CA Annuel (€)</label>
                                <input
                                  type="number"
                                  value={globalConfig.marche?.objectifs_annuels?.ca_annuel || 0}
                                  onChange={(e) => setGlobalConfig({
                                    ...globalConfig,
                                    marche: { 
                                      ...globalConfig.marche, 
                                      objectifs_annuels: { 
                                        ...globalConfig.marche?.objectifs_annuels, 
                                        ca_annuel: parseInt(e.target.value) 
                                      }
                                    }
                                  })}
                                  className="w-full bg-slate-900 border border-slate-700 rounded-lg px-3 py-2 text-white"
                                />
                              </div>
                              <div>
                                <label className="block text-sm text-slate-400 mb-1">Nb Dossiers</label>
                                <input
                                  type="number"
                                  value={globalConfig.marche?.objectifs_annuels?.nb_dossiers || 0}
                                  onChange={(e) => setGlobalConfig({
                                    ...globalConfig,
                                    marche: { 
                                      ...globalConfig.marche, 
                                      objectifs_annuels: { 
                                        ...globalConfig.marche?.objectifs_annuels, 
                                        nb_dossiers: parseInt(e.target.value) 
                                      }
                                    }
                                  })}
                                  className="w-full bg-slate-900 border border-slate-700 rounded-lg px-3 py-2 text-white"
                                />
                              </div>
                              <div>
                                <label className="block text-sm text-slate-400 mb-1">Taux Conversion (%)</label>
                                <input
                                  type="number"
                                  value={globalConfig.marche?.objectifs_annuels?.taux_conversion || 0}
                                  onChange={(e) => setGlobalConfig({
                                    ...globalConfig,
                                    marche: { 
                                      ...globalConfig.marche, 
                                      objectifs_annuels: { 
                                        ...globalConfig.marche?.objectifs_annuels, 
                                        taux_conversion: parseInt(e.target.value) 
                                      }
                                    }
                                  })}
                                  className="w-full bg-slate-900 border border-slate-700 rounded-lg px-3 py-2 text-white"
                                />
                              </div>
                            </div>

                            <button
                              onClick={() => saveGlobalConfigSection("marche", globalConfig.marche)}
                              disabled={globalConfigSaving}
                              className="mt-4 px-4 py-2 bg-blue-600 hover:bg-blue-500 rounded-lg text-white font-medium flex items-center gap-2"
                            >
                              {globalConfigSaving ? <RefreshCw className="w-4 h-4 animate-spin" /> : <Save className="w-4 h-4" />}
                              Sauvegarder
                            </button>
                          </div>
                        </div>
                      )}

                      {/* Onglet Dashboards */}
                      {globalConfigTab === "dashboards" && (
                        <div className="space-y-4">
                          <div className="bg-slate-800/50 rounded-xl border border-slate-700/50 p-6">
                            <h3 className="font-semibold text-green-400 flex items-center gap-2 mb-4">
                              <BarChart3 className="w-5 h-5" />
                              Visibilité des Dashboards
                            </h3>
                            <p className="text-sm text-slate-400 mb-4">
                              Activez ou désactivez les dashboards visibles sur la page d'accueil pour tous les utilisateurs.
                            </p>
                            
                            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
                              {dashboardConfig?.dashboards && Object.entries(dashboardConfig.dashboards).map(([key, config]) => (
                                <div 
                                  key={key}
                                  className={`p-3 rounded-lg border transition-all ${
                                    globalConfig?.dashboards_config?.[key]?.visible !== false
                                      ? 'bg-green-500/10 border-green-500/30'
                                      : 'bg-slate-700/30 border-slate-600/30 opacity-60'
                                  }`}
                                >
                                  <div className="flex items-center justify-between">
                                    <div className="flex items-center gap-2">
                                      <span className="text-lg">{config.label?.split(' ')[0]}</span>
                                      <span className="text-sm text-white font-medium">
                                        {config.label?.split(' ').slice(1).join(' ')}
                                      </span>
                                    </div>
                                    <button
                                      onClick={() => {
                                        const newVisibility = {
                                          ...globalConfig?.dashboards_config,
                                          [key]: {
                                            visible: !(globalConfig?.dashboards_config?.[key]?.visible !== false),
                                            order: config.order || 0
                                          }
                                        };
                                        setGlobalConfig({
                                          ...globalConfig,
                                          dashboards_config: newVisibility
                                        });
                                      }}
                                      className={`p-1.5 rounded-lg transition-colors ${
                                        globalConfig?.dashboards_config?.[key]?.visible !== false
                                          ? 'bg-green-500/20 text-green-400'
                                          : 'bg-slate-600/50 text-slate-400'
                                      }`}
                                    >
                                      {globalConfig?.dashboards_config?.[key]?.visible !== false ? (
                                        <Eye className="w-4 h-4" />
                                      ) : (
                                        <EyeOff className="w-4 h-4" />
                                      )}
                                    </button>
                                  </div>
                                  <p className="text-xs text-slate-500 mt-1">{config.desc}</p>
                                </div>
                              ))}
                            </div>

                            <button
                              onClick={() => saveGlobalConfigSection("dashboards-visibility", globalConfig?.dashboards_config || {})}
                              disabled={globalConfigSaving}
                              className="mt-6 px-4 py-2 bg-green-600 hover:bg-green-500 rounded-lg text-white font-medium flex items-center gap-2"
                            >
                              {globalConfigSaving ? <RefreshCw className="w-4 h-4 animate-spin" /> : <Save className="w-4 h-4" />}
                              Sauvegarder la Visibilité
                            </button>
                          </div>
                        </div>
                      )}

                      {/* Onglet Widgets & Colonnes (Configuration par dashboard) */}
                      {globalConfigTab === "widgets" && (
                        <div className="space-y-6">
                          {/* Sélection du Dashboard */}
                          <div className="bg-slate-800/50 rounded-xl border border-slate-700/50 p-4">
                            <label className="block text-sm text-slate-400 mb-2">Sélectionnez le dashboard à configurer</label>
                            <div className="flex flex-wrap gap-2">
                              {[
                                { id: "telepro", label: "📞 Télépro", color: "blue" },
                                { id: "calendrier", label: "📅 Calendrier", color: "green" },
                                { id: "grands_comptes", label: "💼 Grands Comptes", color: "purple" },
                                { id: "comite_direction_ia", label: "🤖 Comité IA", color: "amber" }
                              ].map(dash => (
                                <button
                                  key={dash.id}
                                  onClick={() => setSelectedDashboardConfig(dash.id)}
                                  className={`px-4 py-2 rounded-lg text-sm font-medium transition-all ${
                                    selectedDashboardConfig === dash.id
                                      ? `bg-${dash.color}-500/20 text-${dash.color}-400 border border-${dash.color}-500/30`
                                      : 'bg-slate-700/50 text-slate-400 hover:text-white hover:bg-slate-700'
                                  }`}
                                >
                                  {dash.label}
                                </button>
                              ))}
                            </div>
                          </div>

                          {dashboardConfigLoading ? (
                            <div className="flex items-center justify-center py-12">
                              <RefreshCw className="w-8 h-8 animate-spin text-cyan-400" />
                            </div>
                          ) : dashboardsConfig[selectedDashboardConfig] ? (
                            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                              {/* Configuration des Widgets */}
                              <div className="bg-slate-800/50 rounded-xl border border-slate-700/50 p-6">
                                <h3 className="font-semibold text-cyan-400 flex items-center gap-2 mb-4">
                                  <LayoutGrid className="w-5 h-5" />
                                  Widgets
                                </h3>
                                <p className="text-sm text-slate-400 mb-4">
                                  Activez/désactivez les widgets et personnalisez leurs libellés
                                </p>
                                
                                <div className="space-y-3">
                                  {Object.entries(dashboardsConfig[selectedDashboardConfig]?.widgets || {})
                                    .sort((a, b) => (a[1].order || 0) - (b[1].order || 0))
                                    .map(([widgetId, widget]) => (
                                    <div 
                                      key={widgetId}
                                      className={`flex items-center gap-3 p-3 rounded-lg border transition-all ${
                                        widget.enabled 
                                          ? 'bg-cyan-500/10 border-cyan-500/30' 
                                          : 'bg-slate-700/30 border-slate-600/30'
                                      }`}
                                    >
                                      <button
                                        onClick={() => toggleWidget(selectedDashboardConfig, widgetId)}
                                        className={`w-10 h-6 rounded-full transition-all relative ${
                                          widget.enabled ? 'bg-cyan-500' : 'bg-slate-600'
                                        }`}
                                      >
                                        <div className={`absolute top-1 w-4 h-4 rounded-full bg-white transition-all ${
                                          widget.enabled ? 'right-1' : 'left-1'
                                        }`} />
                                      </button>
                                      <input
                                        type="text"
                                        value={widget.label || widgetId}
                                        onChange={(e) => updateLabel(selectedDashboardConfig, 'widgets', widgetId, e.target.value)}
                                        className="flex-1 bg-transparent border-none text-white text-sm focus:outline-none focus:ring-1 focus:ring-cyan-500/50 rounded px-2 py-1"
                                      />
                                      <span className="text-xs text-slate-500">#{widget.order || 0}</span>
                                    </div>
                                  ))}
                                </div>
                              </div>

                              {/* Configuration des Colonnes */}
                              <div className="bg-slate-800/50 rounded-xl border border-slate-700/50 p-6">
                                <h3 className="font-semibold text-emerald-400 flex items-center gap-2 mb-4">
                                  <TableProperties className="w-5 h-5" />
                                  Colonnes du Tableau
                                </h3>
                                <p className="text-sm text-slate-400 mb-4">
                                  Activez/désactivez les colonnes et personnalisez leurs en-têtes
                                </p>
                                
                                {Object.keys(dashboardsConfig[selectedDashboardConfig]?.columns || {}).length > 0 ? (
                                  <div className="space-y-3">
                                    {Object.entries(dashboardsConfig[selectedDashboardConfig]?.columns || {})
                                      .sort((a, b) => (a[1].order || 0) - (b[1].order || 0))
                                      .map(([columnId, column]) => (
                                      <div 
                                        key={columnId}
                                        className={`flex items-center gap-3 p-3 rounded-lg border transition-all ${
                                          column.enabled 
                                            ? 'bg-emerald-500/10 border-emerald-500/30' 
                                            : 'bg-slate-700/30 border-slate-600/30'
                                        }`}
                                      >
                                        <button
                                          onClick={() => toggleColumn(selectedDashboardConfig, columnId)}
                                          className={`w-10 h-6 rounded-full transition-all relative ${
                                            column.enabled ? 'bg-emerald-500' : 'bg-slate-600'
                                          }`}
                                        >
                                          <div className={`absolute top-1 w-4 h-4 rounded-full bg-white transition-all ${
                                            column.enabled ? 'right-1' : 'left-1'
                                          }`} />
                                        </button>
                                        <input
                                          type="text"
                                          value={column.label || columnId}
                                          onChange={(e) => updateLabel(selectedDashboardConfig, 'columns', columnId, e.target.value)}
                                          className="flex-1 bg-transparent border-none text-white text-sm focus:outline-none focus:ring-1 focus:ring-emerald-500/50 rounded px-2 py-1"
                                        />
                                        <span className="text-xs text-slate-500">#{column.order || 0}</span>
                                      </div>
                                    ))}
                                  </div>
                                ) : (
                                  <div className="text-center py-8 text-slate-500">
                                    <TableProperties className="w-12 h-12 mx-auto mb-2 opacity-50" />
                                    <p>Ce dashboard n'a pas de tableau configurable</p>
                                  </div>
                                )}
                              </div>
                            </div>
                          ) : (
                            <div className="text-center py-12 text-slate-400">
                              <LayoutGrid className="w-12 h-12 mx-auto mb-4 opacity-50" />
                              <p>Aucune configuration trouvée pour ce dashboard</p>
                              <p className="text-sm text-slate-500 mt-2">La configuration par défaut sera appliquée</p>
                            </div>
                          )}

                          {/* Bouton de sauvegarde */}
                          {dashboardsConfig[selectedDashboardConfig] && (
                            <div className="flex justify-end">
                              <button
                                onClick={() => saveDashboardConfig(selectedDashboardConfig, dashboardsConfig[selectedDashboardConfig])}
                                disabled={globalConfigSaving}
                                className="px-6 py-3 bg-cyan-600 hover:bg-cyan-500 rounded-lg text-white font-medium flex items-center gap-2"
                              >
                                {globalConfigSaving ? <RefreshCw className="w-4 h-4 animate-spin" /> : <Save className="w-4 h-4" />}
                                Sauvegarder la Configuration
                              </button>
                            </div>
                          )}
                        </div>
                      )}
                    </>
                  )}
                </div>
              )}

              {/* CONFIGURATION DES CHAMPS FICHE CLIENT - Nouveau Configurateur Dynamique */}
              {activeSection === "client-fields-config" && (
                <div className="space-y-6">
                  {/* Header */}
                  <div className="bg-gradient-to-r from-purple-500/10 to-pink-500/10 border border-purple-500/30 rounded-xl p-4">
                    <div className="flex items-center gap-3">
                      <div className="w-10 h-10 rounded-xl bg-purple-500/20 flex items-center justify-center">
                        <TableProperties className="w-5 h-5 text-purple-400" />
                      </div>
                      <div>
                        <h2 className="font-bold text-white">Configurateur de Modale Client</h2>
                        <p className="text-sm text-slate-400">
                          Personnalisez les sections et champs affichés dans les modales client
                        </p>
                      </div>
                    </div>
                  </div>

                  {/* Composant de configuration avancé */}
                  <ClientFieldsConfigurator />

                  {/* Légende */}
                  <div className="bg-slate-800/30 rounded-xl p-4 border border-slate-700/30">
                    <h4 className="font-medium text-slate-300 mb-2">💡 Comment ça marche ?</h4>
                    <ul className="text-sm text-slate-400 space-y-1">
                      <li>• <span className="text-purple-400">Glissez-déposez</span> les sections pour les réordonner</li>
                      <li>• <span className="text-purple-400">Créez des sections</span> avec des champs Google Sheet ou personnalisés</li>
                      <li>• Configurez <span className="text-purple-400">Modal Principal</span> (fiche complète) et <span className="text-purple-400">Modal Pipeline</span> (vue simplifiée)</li>
                      <li>• L'IA suggère automatiquement une icône pertinente lors de la création de section</li>
                    </ul>
                  </div>
                </div>
              )}

              {/* CONFIGURATION SÉLECTIONS DYNAMIQUES */}
              {activeSection === "dynamic-tabs-config" && (
                <div className="space-y-6">
                  {/* Header */}
                  <div className="bg-gradient-to-r from-indigo-500/10 to-violet-500/10 border border-indigo-500/30 rounded-xl p-4">
                    <div className="flex items-center gap-3">
                      <div className="w-10 h-10 rounded-xl bg-indigo-500/20 flex items-center justify-center">
                        <Layers className="w-5 h-5 text-indigo-400" />
                      </div>
                      <div>
                        <h2 className="font-bold text-white">Sélections Dynamiques</h2>
                        <p className="text-sm text-slate-400">
                          Configurez les onglets affichés dans le modal client (Informations, Échanges, RDV, etc.)
                        </p>
                      </div>
                    </div>
                  </div>

                  {/* Composant de configuration */}
                  <DynamicTabsConfig />
                </div>
              )}

              {/* CONFIGURATION CONDITIONS DE RÈGLEMENT */}
              {activeSection === "payment-conditions-config" && (
                <PaymentConditionsConfig />
              )}

              {/* CONFIGURATION SOURCES DE LEAD */}
              {activeSection === "lead-sources-config" && (
                <LeadSourcesConfigPanel />
              )}

              {/* CONFIGURATION STATUTS QUALIFICATION */}
              {activeSection === "statuts-qualification-config" && (
                <StatutsQualificationConfigPanel />
              )}

              {/* VARIABLES CRM */}
              {activeSection === "crm-variables" && (
                <CrmVariablesList />
              )}

              {/* CONFIGURATION TARIFS RÉNO ÉNERGIE */}
              {activeSection === "tarifs-reno-config" && (
                <TarifsRenoConfig />
              )}

              {/* CONFIGURATION TÉLÉPRO */}
              {activeSection === "telepro-config" && (
                <div className="space-y-6">
                  {/* Header */}
                  <div className="bg-gradient-to-r from-blue-500/10 to-cyan-500/10 border border-blue-500/30 rounded-xl p-4">
                    <div className="flex items-center gap-3">
                      <div className="w-10 h-10 rounded-xl bg-blue-500/20 flex items-center justify-center">
                        <Phone className="w-5 h-5 text-blue-400" />
                      </div>
                      <div>
                        <h2 className="font-bold text-white">Configuration Dashboard Télépro</h2>
                        <p className="text-sm text-slate-400">Personnalisez les alertes et messages SAN-IA du dashboard Télépro</p>
                      </div>
                    </div>
                  </div>

                  {/* Onglets */}
                  <div className="flex gap-2 bg-slate-800/50 p-1 rounded-xl">
                    {[
                      { id: "alertes", label: "🚨 Alertes & Seuils", color: "orange" },
                      { id: "messages", label: "🤖 Messages SAN-IA", color: "purple" }
                    ].map(tab => (
                      <button
                        key={tab.id}
                        onClick={() => setTeleproConfigTab(tab.id)}
                        className={`flex-1 px-4 py-2 rounded-lg text-sm font-medium transition-all ${
                          teleproConfigTab === tab.id 
                            ? `bg-${tab.color}-500/20 text-${tab.color}-400 border border-${tab.color}-500/30`
                            : 'text-slate-400 hover:text-white hover:bg-slate-700/50'
                        }`}
                      >
                        {tab.label}
                      </button>
                    ))}
                  </div>

                  {globalConfigLoading ? (
                    <div className="flex items-center justify-center py-12">
                      <RefreshCw className="w-8 h-8 animate-spin text-blue-400" />
                    </div>
                  ) : (
                    <>
                      {/* Onglet Alertes */}
                      {teleproConfigTab === "alertes" && globalConfig && (
                        <div className="space-y-6">
                          {/* Seuils généraux */}
                          <div className="bg-slate-800/50 rounded-xl border border-slate-700/50 p-6 space-y-4">
                            <h3 className="font-semibold text-orange-400 flex items-center gap-2">
                              <AlertTriangle className="w-5 h-5" />
                              Seuils d'Alertes
                            </h3>
                            <p className="text-sm text-slate-400">
                              Ces seuils déclenchent des messages spécifiques dans la bannière SAN-IA.
                            </p>
                            
                            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                              <div>
                                <label className="block text-sm text-slate-400 mb-1">Appels avant suggestion pause</label>
                                <input
                                  type="number"
                                  value={globalConfig.alertes?.seuils?.appels_avant_pause || 50}
                                  onChange={(e) => setGlobalConfig({
                                    ...globalConfig,
                                    alertes: { 
                                      ...globalConfig.alertes, 
                                      seuils: { ...globalConfig.alertes?.seuils, appels_avant_pause: parseInt(e.target.value) }
                                    }
                                  })}
                                  className="w-full bg-slate-900 border border-slate-700 rounded-lg px-3 py-2 text-white"
                                />
                              </div>
                              <div>
                                <label className="block text-sm text-slate-400 mb-1">Perte de vitesse (%)</label>
                                <input
                                  type="number"
                                  value={globalConfig.alertes?.seuils?.perte_vitesse_pourcentage || 20}
                                  onChange={(e) => setGlobalConfig({
                                    ...globalConfig,
                                    alertes: { 
                                      ...globalConfig.alertes, 
                                      seuils: { ...globalConfig.alertes?.seuils, perte_vitesse_pourcentage: parseInt(e.target.value) }
                                    }
                                  })}
                                  className="w-full bg-slate-900 border border-slate-700 rounded-lg px-3 py-2 text-white"
                                />
                              </div>
                              <div>
                                <label className="block text-sm text-slate-400 mb-1">CQ en retard après (heures)</label>
                                <input
                                  type="number"
                                  value={globalConfig.alertes?.seuils?.cq_retard_heures || 48}
                                  onChange={(e) => setGlobalConfig({
                                    ...globalConfig,
                                    alertes: { 
                                      ...globalConfig.alertes, 
                                      seuils: { ...globalConfig.alertes?.seuils, cq_retard_heures: parseInt(e.target.value) }
                                    }
                                  })}
                                  className="w-full bg-slate-900 border border-slate-700 rounded-lg px-3 py-2 text-white"
                                />
                              </div>
                            </div>
                          </div>

                          {/* Règles de confirmation RDV */}
                          <div className="bg-gradient-to-r from-blue-500/10 to-cyan-500/10 rounded-xl border border-blue-500/30 p-6 space-y-4">
                            <h3 className="font-semibold text-blue-400 flex items-center gap-2">
                              <Calendar className="w-5 h-5" />
                              Règles de Confirmation RDV (R1)
                            </h3>
                            <p className="text-sm text-slate-400">
                              Définit quand alerter pour les RDV non confirmés.
                            </p>
                            
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                              <div className="bg-slate-800/50 rounded-lg p-4">
                                <label className="block text-sm text-blue-400 font-medium mb-2">⏰ Heure limite le Jour J</label>
                                <input
                                  type="time"
                                  value={globalConfig.alertes?.confirmation_rdv?.heure_limite || "10:30"}
                                  onChange={(e) => setGlobalConfig({
                                    ...globalConfig,
                                    alertes: { 
                                      ...globalConfig.alertes, 
                                      confirmation_rdv: { 
                                        ...globalConfig.alertes?.confirmation_rdv, 
                                        heure_limite: e.target.value 
                                      }
                                    }
                                  })}
                                  className="w-full bg-slate-900 border border-slate-700 rounded-lg px-3 py-2 text-white"
                                />
                                <p className="text-xs text-slate-500 mt-1">Heure limite pour confirmer le jour du RDV</p>
                              </div>
                              
                              <div className="bg-slate-800/50 rounded-lg p-4 space-y-3">
                                <label className="block text-sm text-blue-400 font-medium">📋 Règles appliquées</label>
                                <div className="space-y-2 text-sm">
                                  <div className="flex items-start gap-2">
                                    <span className="text-green-400">✓</span>
                                    <div>
                                      <span className="text-white font-medium">RDV Mardi → Vendredi :</span>
                                      <span className="text-slate-400 ml-1">Veille ou Jour J avant {globalConfig.alertes?.confirmation_rdv?.heure_limite || "10:30"}</span>
                                    </div>
                                  </div>
                                  <div className="flex items-start gap-2">
                                    <span className="text-green-400">✓</span>
                                    <div>
                                      <span className="text-white font-medium">RDV Lundi :</span>
                                      <span className="text-slate-400 ml-1">Vendredi ou Lundi avant {globalConfig.alertes?.confirmation_rdv?.heure_limite || "10:30"}</span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <h4 className="font-medium text-slate-300 mt-4">Messages d'alerte RDV</h4>
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                              <div>
                                <label className="block text-sm text-slate-400 mb-1">RDV de demain non confirmé</label>
                                <input
                                  type="text"
                                  value={globalConfig.alertes?.confirmation_rdv?.messages?.rdv_demain || "⏰ RDV de demain non confirmé ! Client: {client} - Contacte-le avant ce soir !"}
                                  onChange={(e) => setGlobalConfig({
                                    ...globalConfig,
                                    alertes: { 
                                      ...globalConfig.alertes, 
                                      confirmation_rdv: { 
                                        ...globalConfig.alertes?.confirmation_rdv, 
                                        messages: {
                                          ...globalConfig.alertes?.confirmation_rdv?.messages,
                                          rdv_demain: e.target.value
                                        }
                                      }
                                    }
                                  })}
                                  className="w-full bg-slate-900 border border-slate-700 rounded-lg px-3 py-2 text-white text-sm"
                                  placeholder="Utiliser {client} pour le nom du client"
                                />
                              </div>
                              <div>
                                <label className="block text-sm text-slate-400 mb-1">RDV Jour J (urgent)</label>
                                <input
                                  type="text"
                                  value={globalConfig.alertes?.confirmation_rdv?.messages?.rdv_jour_j || "🚨 RDV AUJOURD'HUI non confirmé ! {client} - Appelle MAINTENANT !"}
                                  onChange={(e) => setGlobalConfig({
                                    ...globalConfig,
                                    alertes: { 
                                      ...globalConfig.alertes, 
                                      confirmation_rdv: { 
                                        ...globalConfig.alertes?.confirmation_rdv, 
                                        messages: {
                                          ...globalConfig.alertes?.confirmation_rdv?.messages,
                                          rdv_jour_j: e.target.value
                                        }
                                      }
                                    }
                                  })}
                                  className="w-full bg-slate-900 border border-slate-700 rounded-lg px-3 py-2 text-white text-sm"
                                />
                              </div>
                              <div>
                                <label className="block text-sm text-slate-400 mb-1">RDV Lundi (alerté vendredi)</label>
                                <input
                                  type="text"
                                  value={globalConfig.alertes?.confirmation_rdv?.messages?.rdv_lundi_vendredi || "📅 RDV de lundi non confirmé ! Appelle {client} avant ce soir ou lundi avant 10h30"}
                                  onChange={(e) => setGlobalConfig({
                                    ...globalConfig,
                                    alertes: { 
                                      ...globalConfig.alertes, 
                                      confirmation_rdv: { 
                                        ...globalConfig.alertes?.confirmation_rdv, 
                                        messages: {
                                          ...globalConfig.alertes?.confirmation_rdv?.messages,
                                          rdv_lundi_vendredi: e.target.value
                                        }
                                      }
                                    }
                                  })}
                                  className="w-full bg-slate-900 border border-slate-700 rounded-lg px-3 py-2 text-white text-sm"
                                />
                              </div>
                              <div>
                                <label className="block text-sm text-slate-400 mb-1">RDV Lundi matin (urgent)</label>
                                <input
                                  type="text"
                                  value={globalConfig.alertes?.confirmation_rdv?.messages?.rdv_lundi_matin || "🚨 RDV AUJOURD'HUI (lundi) non confirmé ! {client} - Appelle avant 10h30 !"}
                                  onChange={(e) => setGlobalConfig({
                                    ...globalConfig,
                                    alertes: { 
                                      ...globalConfig.alertes, 
                                      confirmation_rdv: { 
                                        ...globalConfig.alertes?.confirmation_rdv, 
                                        messages: {
                                          ...globalConfig.alertes?.confirmation_rdv?.messages,
                                          rdv_lundi_matin: e.target.value
                                        }
                                      }
                                    }
                                  })}
                                  className="w-full bg-slate-900 border border-slate-700 rounded-lg px-3 py-2 text-white text-sm"
                                />
                              </div>
                            </div>
                          </div>

                          {/* Messages d'alertes généraux */}
                          <div className="bg-slate-800/50 rounded-xl border border-slate-700/50 p-6 space-y-4">
                            <h4 className="font-medium text-slate-300">Messages d'Alertes Généraux</h4>
                            <p className="text-xs text-slate-500">Un message par ligne. Variables : {"{appels}"}, {"{current}"}, {"{last}"}, {"{perte}"}, {"{count}"}</p>
                            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                              <div>
                                <label className="block text-sm text-slate-400 mb-1">Pause recommandée</label>
                                <textarea
                                  value={(globalConfig.alertes?.messages?.pause_recommandee || []).join("\n")}
                                  onChange={(e) => setGlobalConfig({
                                    ...globalConfig,
                                    alertes: { 
                                      ...globalConfig.alertes, 
                                      messages: { 
                                        ...globalConfig.alertes?.messages, 
                                        pause_recommandee: e.target.value.split("\n").filter(l => l.trim()) 
                                      }
                                    }
                                  })}
                                  rows={3}
                                  className="w-full bg-slate-900 border border-slate-700 rounded-lg px-3 py-2 text-white text-sm"
                                  placeholder="Tu as passé {appels} appels ! Prends une pause ☕"
                                />
                              </div>
                              <div>
                                <label className="block text-sm text-slate-400 mb-1">Perte de vitesse</label>
                                <textarea
                                  value={(globalConfig.alertes?.messages?.perte_vitesse || []).join("\n")}
                                  onChange={(e) => setGlobalConfig({
                                    ...globalConfig,
                                    alertes: { 
                                      ...globalConfig.alertes, 
                                      messages: { 
                                        ...globalConfig.alertes?.messages, 
                                        perte_vitesse: e.target.value.split("\n").filter(l => l.trim()) 
                                      }
                                    }
                                  })}
                                  rows={3}
                                  className="w-full bg-slate-900 border border-slate-700 rounded-lg px-3 py-2 text-white text-sm"
                                  placeholder="Tu es à {current} contre {last} habituellement..."
                                />
                              </div>
                              <div>
                                <label className="block text-sm text-slate-400 mb-1">CQ en retard</label>
                                <textarea
                                  value={(globalConfig.alertes?.messages?.cq_retard || []).join("\n")}
                                  onChange={(e) => setGlobalConfig({
                                    ...globalConfig,
                                    alertes: { 
                                      ...globalConfig.alertes, 
                                      messages: { 
                                        ...globalConfig.alertes?.messages, 
                                        cq_retard: e.target.value.split("\n").filter(l => l.trim()) 
                                      }
                                    }
                                  })}
                                  rows={3}
                                  className="w-full bg-slate-900 border border-slate-700 rounded-lg px-3 py-2 text-white text-sm"
                                  placeholder="{count} CQ en attente depuis 48h..."
                                />
                              </div>
                            </div>
                          </div>

                          <button
                            onClick={() => saveGlobalConfigSection("alertes", globalConfig.alertes)}
                            disabled={globalConfigSaving}
                            className="px-4 py-2 bg-orange-600 hover:bg-orange-500 rounded-lg text-white font-medium flex items-center gap-2"
                          >
                            {globalConfigSaving ? <RefreshCw className="w-4 h-4 animate-spin" /> : <Save className="w-4 h-4" />}
                            Sauvegarder les Alertes
                          </button>
                        </div>
                      )}

                      {/* Onglet Messages SAN-IA */}
                      {teleproConfigTab === "messages" && globalConfig && (
                        <div className="space-y-4">
                          <div className="bg-slate-800/50 rounded-xl border border-slate-700/50 p-6 space-y-6">
                            <h3 className="font-semibold text-purple-400 flex items-center gap-2">
                              <Bot className="w-5 h-5" />
                              Messages SAN-IA (Bannière Télépro)
                            </h3>
                            <p className="text-sm text-slate-400">
                              Ces messages s'affichent dans la bannière rotative en haut du dashboard Télépro.
                            </p>
                            
                            {/* Messages Loi des Nombres */}
                            <div>
                              <label className="block text-sm text-slate-400 mb-2">Messages "Loi des Nombres" (un par ligne)</label>
                              <textarea
                                value={(globalConfig.sania_messages?.loi_nombres || []).join("\n")}
                                onChange={(e) => setGlobalConfig({
                                  ...globalConfig,
                                  sania_messages: { 
                                    ...globalConfig.sania_messages, 
                                    loi_nombres: e.target.value.split("\n").filter(l => l.trim())
                                  }
                                })}
                                rows={4}
                                className="w-full bg-slate-900 border border-slate-700 rounded-lg px-3 py-2 text-white text-sm"
                              />
                            </div>

                            {/* Messages Confirmation RDV */}
                            <div>
                              <label className="block text-sm text-slate-400 mb-2">Messages "Confirmation RDV" (un par ligne)</label>
                              <textarea
                                value={(globalConfig.sania_messages?.confirmation_rdv || []).join("\n")}
                                onChange={(e) => setGlobalConfig({
                                  ...globalConfig,
                                  sania_messages: { 
                                    ...globalConfig.sania_messages, 
                                    confirmation_rdv: e.target.value.split("\n").filter(l => l.trim())
                                  }
                                })}
                                rows={4}
                                className="w-full bg-slate-900 border border-slate-700 rounded-lg px-3 py-2 text-white text-sm"
                              />
                            </div>

                            {/* Messages Pause */}
                            <div>
                              <label className="block text-sm text-slate-400 mb-2">Messages "Pause" (un par ligne)</label>
                              <textarea
                                value={(globalConfig.sania_messages?.pause || []).join("\n")}
                                onChange={(e) => setGlobalConfig({
                                  ...globalConfig,
                                  sania_messages: { 
                                    ...globalConfig.sania_messages, 
                                    pause: e.target.value.split("\n").filter(l => l.trim())
                                  }
                                })}
                                rows={4}
                                className="w-full bg-slate-900 border border-slate-700 rounded-lg px-3 py-2 text-white text-sm"
                              />
                            </div>

                            {/* Messages CQ */}
                            <div>
                              <label className="block text-sm text-slate-400 mb-2">Messages "Contrôle Qualité" (un par ligne)</label>
                              <textarea
                                value={(globalConfig.sania_messages?.cq || []).join("\n")}
                                onChange={(e) => setGlobalConfig({
                                  ...globalConfig,
                                  sania_messages: { 
                                    ...globalConfig.sania_messages, 
                                    cq: e.target.value.split("\n").filter(l => l.trim())
                                  }
                                })}
                                rows={4}
                                className="w-full bg-slate-900 border border-slate-700 rounded-lg px-3 py-2 text-white text-sm"
                              />
                            </div>

                            {/* Messages Perte de Vitesse */}
                            <div>
                              <label className="block text-sm text-slate-400 mb-2">
                                Messages "Perte de Vitesse" (utilisez {"{current}"} et {"{last}"} pour les valeurs dynamiques)
                              </label>
                              <textarea
                                value={(globalConfig.sania_messages?.perte_vitesse || []).join("\n")}
                                onChange={(e) => setGlobalConfig({
                                  ...globalConfig,
                                  sania_messages: { 
                                    ...globalConfig.sania_messages, 
                                    perte_vitesse: e.target.value.split("\n").filter(l => l.trim())
                                  }
                                })}
                                rows={3}
                                className="w-full bg-slate-900 border border-slate-700 rounded-lg px-3 py-2 text-white text-sm"
                              />
                            </div>

                            {/* Messages Bonne Semaine */}
                            <div>
                              <label className="block text-sm text-slate-400 mb-2">
                                Messages "Bonne Semaine" (utilisez {"{current}"} et {"{last}"})
                              </label>
                              <textarea
                                value={(globalConfig.sania_messages?.bonne_semaine || []).join("\n")}
                                onChange={(e) => setGlobalConfig({
                                  ...globalConfig,
                                  sania_messages: { 
                                    ...globalConfig.sania_messages, 
                                    bonne_semaine: e.target.value.split("\n").filter(l => l.trim())
                                  }
                                })}
                                rows={3}
                                className="w-full bg-slate-900 border border-slate-700 rounded-lg px-3 py-2 text-white text-sm"
                              />
                            </div>

                            {/* Messages Record */}
                            <div>
                              <label className="block text-sm text-slate-400 mb-2">
                                Messages "Record" (utilisez {"{record}"} et {"{current}"})
                              </label>
                              <textarea
                                value={(globalConfig.sania_messages?.record || []).join("\n")}
                                onChange={(e) => setGlobalConfig({
                                  ...globalConfig,
                                  sania_messages: { 
                                    ...globalConfig.sania_messages, 
                                    record: e.target.value.split("\n").filter(l => l.trim())
                                  }
                                })}
                                rows={3}
                                className="w-full bg-slate-900 border border-slate-700 rounded-lg px-3 py-2 text-white text-sm"
                              />
                            </div>

                            {/* Messages Leader */}
                            <div>
                              <label className="block text-sm text-slate-400 mb-2">
                                Messages "Leader" (utilisez {"{name}"}, {"{rdv}"}, {"{appels}"})
                              </label>
                              <textarea
                                value={(globalConfig.sania_messages?.leader || []).join("\n")}
                                onChange={(e) => setGlobalConfig({
                                  ...globalConfig,
                                  sania_messages: { 
                                    ...globalConfig.sania_messages, 
                                    leader: e.target.value.split("\n").filter(l => l.trim())
                                  }
                                })}
                                rows={3}
                                className="w-full bg-slate-900 border border-slate-700 rounded-lg px-3 py-2 text-white text-sm"
                              />
                            </div>

                            {/* Messages Motivation */}
                            <div>
                              <label className="block text-sm text-slate-400 mb-2">Messages "Motivation" (un par ligne)</label>
                              <textarea
                                value={(globalConfig.sania_messages?.motivation || []).join("\n")}
                                onChange={(e) => setGlobalConfig({
                                  ...globalConfig,
                                  sania_messages: { 
                                    ...globalConfig.sania_messages, 
                                    motivation: e.target.value.split("\n").filter(l => l.trim())
                                  }
                                })}
                                rows={3}
                                className="w-full bg-slate-900 border border-slate-700 rounded-lg px-3 py-2 text-white text-sm"
                              />
                            </div>

                            {/* Blagues */}
                            <div>
                              <label className="block text-sm text-slate-400 mb-2">Blagues (une par ligne - affichées aléatoirement)</label>
                              <textarea
                                value={(globalConfig.sania_messages?.blagues || []).join("\n")}
                                onChange={(e) => setGlobalConfig({
                                  ...globalConfig,
                                  sania_messages: { 
                                    ...globalConfig.sania_messages, 
                                    blagues: e.target.value.split("\n").filter(l => l.trim())
                                  }
                                })}
                                rows={5}
                                className="w-full bg-slate-900 border border-slate-700 rounded-lg px-3 py-2 text-white text-sm"
                                placeholder="Entrez vos blagues ici, une par ligne..."
                              />
                            </div>

                            <button
                              onClick={() => saveGlobalConfigSection("sania-messages", globalConfig.sania_messages)}
                              disabled={globalConfigSaving}
                              className="mt-4 px-4 py-2 bg-purple-600 hover:bg-purple-500 rounded-lg text-white font-medium flex items-center gap-2"
                            >
                              {globalConfigSaving ? <RefreshCw className="w-4 h-4 animate-spin" /> : <Save className="w-4 h-4" />}
                              Sauvegarder les Messages SAN-IA
                            </button>
                          </div>
                        </div>
                      )}
                    </>
                  )}
                </div>
              )}

              {/* CONFIGURATION IA */}
              {activeSection === "ai" && (
                <div className="space-y-6">
                  <div className={`rounded-xl border p-6 ${aiEnabled ? 'bg-emerald-500/10 border-emerald-500/30' : 'bg-red-500/10 border-red-500/30'}`}>
                    <div className="flex items-center justify-between">
                      <div className="flex items-center gap-4">
                        <div className={`w-12 h-12 rounded-xl flex items-center justify-center ${aiEnabled ? 'bg-emerald-500/20' : 'bg-red-500/20'}`}>
                          <Sparkles className={`w-6 h-6 ${aiEnabled ? 'text-emerald-400' : 'text-red-400'}`} />
                        </div>
                        <div>
                          <h3 className="font-semibold text-lg">{aiEnabled ? 'IA Activée' : 'IA Désactivée'}</h3>
                          <p className="text-slate-400">{aiConfig ? `${aiConfig.provider} / ${aiConfig.model}` : 'Configuration par défaut'}</p>
                        </div>
                      </div>
                      <label className="relative inline-flex items-center cursor-pointer">
                        <input type="checkbox" checked={aiEnabled} onChange={(e) => setAiEnabled(e.target.checked)} className="sr-only peer" />
                        <div className="w-14 h-7 bg-slate-700 rounded-full peer peer-checked:bg-emerald-600 after:content-[''] after:absolute after:top-0.5 after:left-[4px] after:bg-white after:rounded-full after:h-6 after:w-6 after:transition-all peer-checked:after:translate-x-full"></div>
                      </label>
                    </div>
                  </div>
                  
                  <div className="bg-slate-800/50 rounded-xl border border-slate-700/50 p-6">
                    <h3 className="font-semibold mb-4">Choisir le modèle IA</h3>
                    <div className="flex gap-2 mb-6">
                      {Object.keys(availableModels).map(provider => (
                        <button key={provider} onClick={() => { setSelectedProvider(provider); setSelectedModel(availableModels[provider]?.[0]?.id || ""); }}
                          className={`px-4 py-2 rounded-lg capitalize ${selectedProvider === provider ? 'bg-purple-500/20 text-purple-400 border border-purple-500/30' : 'bg-slate-700 hover:bg-slate-600'}`}>
                          {provider}
                        </button>
                      ))}
                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-3 mb-6">
                      {(availableModels[selectedProvider] || []).map(model => (
                        <button key={model.id} onClick={() => setSelectedModel(model.id)}
                          className={`p-4 rounded-lg text-left ${selectedModel === model.id ? 'bg-purple-500/20 border-2 border-purple-500' : 'bg-slate-900/50 border border-slate-700 hover:border-slate-500'}`}>
                          <div className="flex items-center gap-2 mb-1">
                            {selectedModel === model.id && <Check className="w-4 h-4 text-purple-400" />}
                            <span className="font-medium">{model.name}</span>
                          </div>
                          <p className="text-sm text-slate-400">{model.description}</p>
                        </button>
                      ))}
                    </div>
                    <button onClick={saveAiConfig} disabled={savingAi} className="w-full px-6 py-3 bg-purple-600 hover:bg-purple-700 disabled:opacity-50 rounded-lg flex items-center justify-center gap-2 font-medium">
                      {savingAi ? <RefreshCw className="w-5 h-5 animate-spin" /> : <Check className="w-5 h-5" />}
                      Sauvegarder
                    </button>
                  </div>
                </div>
              )}

              {/* INTEGRATIONS & CLES */}
              {activeSection === "integrations" && (
                <IntegrationsClesDashboard isPlatformAdmin={isPlatformAdmin} />
              )}

              {/* SECURITY DASHBOARD */}
              {activeSection === "security-dashboard" && (
                <SecurityDashboard authUser={authUser} />
              )}

              {/* CONFIGURATION DASHBOARDS (unified) */}
              {activeSection === "dashboards-config" && (
                <DashboardConfigPanel />
              )}

              {/* CONSOLE YAEL */}
              {activeSection === "yael-console" && (
                <YaelConsole />
              )}

              {/* BILLING DASHBOARD */}
              {activeSection === "billing-dashboard" && (
                <BillingDashboard authUser={authUser} />
              )}


              {/* PROMPTS IA */}
              {activeSection === "prompts" && (
                <div className="space-y-6">
                  <div className="bg-blue-500/10 border border-blue-500/30 rounded-xl p-4">
                    <p className="text-sm text-blue-300">
                      <Sparkles className="w-4 h-4 inline mr-2" />
                      Les prompts configurent le comportement de l'IA dans différentes parties de l'application.
                    </p>
                  </div>
                  
                  {/* Catégorie: Télépro - Bannière SAN-IA */}
                  <div className="space-y-3">
                    <div className="flex items-center gap-3 px-2">
                      <div className="w-8 h-8 rounded-lg bg-blue-500/20 flex items-center justify-center">
                        <Phone className="w-4 h-4 text-blue-400" />
                      </div>
                      <div>
                        <h3 className="font-semibold text-blue-400">Télépro - Bannière SAN-IA</h3>
                        <p className="text-xs text-slate-500">Messages affichés dans le dashboard Télépro</p>
                      </div>
                    </div>
                    <div className="bg-slate-800/30 rounded-xl border border-slate-700/30 p-4 space-y-3">
                      {prompts.filter(p => p.category === 'telepro').map(prompt => (
                        <PromptCard 
                          key={prompt.id} 
                          prompt={prompt} 
                          isEditing={editingPrompt === prompt.id}
                          promptValue={promptValue}
                          onEdit={() => { setEditingPrompt(editingPrompt === prompt.id ? null : prompt.id); setPromptValue(prompt.value); }}
                          onValueChange={setPromptValue}
                          onSave={() => savePrompt(prompt.id)}
                          onCancel={() => setEditingPrompt(null)}
                        />
                      ))}
                    </div>
                  </div>

                  {/* Catégorie: Rapprochement Bancaire */}
                  <div className="space-y-3">
                    <div className="flex items-center gap-3 px-2">
                      <div className="w-8 h-8 rounded-lg bg-orange-500/20 flex items-center justify-center">
                        <FileText className="w-4 h-4 text-orange-400" />
                      </div>
                      <div>
                        <h3 className="font-semibold text-orange-400">Rapprochement Bancaire</h3>
                        <p className="text-xs text-slate-500">Instructions pour le matching factures/clients</p>
                      </div>
                    </div>
                    <div className="bg-slate-800/30 rounded-xl border border-slate-700/30 p-4 space-y-3">
                      {prompts.filter(p => p.category === 'rapprochement').map(prompt => (
                        <PromptCard 
                          key={prompt.id} 
                          prompt={prompt} 
                          isEditing={editingPrompt === prompt.id}
                          promptValue={promptValue}
                          onEdit={() => { setEditingPrompt(editingPrompt === prompt.id ? null : prompt.id); setPromptValue(prompt.value); }}
                          onValueChange={setPromptValue}
                          onSave={() => savePrompt(prompt.id)}
                          onCancel={() => setEditingPrompt(null)}
                        />
                      ))}
                      {prompts.filter(p => p.category === 'rapprochement').length === 0 && (
                        <p className="text-slate-500 text-sm text-center py-4">Aucun prompt dans cette catégorie</p>
                      )}
                    </div>
                  </div>

                  {/* Catégorie: Autres */}
                  {prompts.filter(p => !['telepro', 'rapprochement'].includes(p.category)).length > 0 && (
                    <div className="space-y-3">
                      <div className="flex items-center gap-3 px-2">
                        <div className="w-8 h-8 rounded-lg bg-purple-500/20 flex items-center justify-center">
                          <Settings className="w-4 h-4 text-purple-400" />
                        </div>
                        <div>
                          <h3 className="font-semibold text-purple-400">Autres</h3>
                          <p className="text-xs text-slate-500">Prompts généraux</p>
                        </div>
                      </div>
                      <div className="bg-slate-800/30 rounded-xl border border-slate-700/30 p-4 space-y-3">
                        {prompts.filter(p => !['telepro', 'rapprochement'].includes(p.category)).map(prompt => (
                          <PromptCard 
                            key={prompt.id} 
                            prompt={prompt} 
                            isEditing={editingPrompt === prompt.id}
                            promptValue={promptValue}
                            onEdit={() => { setEditingPrompt(editingPrompt === prompt.id ? null : prompt.id); setPromptValue(prompt.value); }}
                            onValueChange={setPromptValue}
                            onSave={() => savePrompt(prompt.id)}
                            onCancel={() => setEditingPrompt(null)}
                          />
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              )}

              {/* WEBHOOKS */}
              {activeSection === "webhooks" && (
                <div className="space-y-4">
                  <div className="bg-amber-500/10 border border-amber-500/30 rounded-xl p-4 mb-6">
                    <p className="text-sm text-amber-300">
                      <Webhook className="w-4 h-4 inline mr-2" />
                      Les webhooks permettent de notifier des services externes lors d'événements dans le CRM.
                    </p>
                  </div>
                  
                  {webhooks.map(webhook => (
                    <div key={webhook.id} className={`rounded-xl border p-5 ${webhook.enabled ? 'bg-slate-800/50 border-slate-700/50' : 'bg-slate-800/30 border-slate-700/30'}`}>
                      <div className="flex items-center justify-between mb-3">
                        <div>
                          <h4 className="font-semibold flex items-center gap-2">
                            {webhook.name}
                            <span className={`px-2 py-0.5 rounded text-xs ${webhook.enabled ? 'bg-green-500/20 text-green-400' : 'bg-slate-700 text-slate-500'}`}>
                              {webhook.enabled ? 'Actif' : 'Inactif'}
                            </span>
                          </h4>
                          <p className="text-sm text-slate-400">{webhook.description}</p>
                          <code className="text-xs text-slate-500">{webhook.event}</code>
                        </div>
                        <button onClick={() => { setEditingWebhook(editingWebhook === webhook.id ? null : webhook.id); setWebhookUrl(webhook.url || ""); setWebhookEnabled(webhook.enabled || false); }} className="p-2 hover:bg-slate-700 rounded-lg text-blue-400">
                          <Edit2 className="w-4 h-4" />
                        </button>
                      </div>
                      
                      {editingWebhook === webhook.id && (
                        <div className="pt-3 border-t border-slate-700 space-y-3">
                          <div className="flex gap-3">
                            <input type="url" value={webhookUrl} onChange={(e) => setWebhookUrl(e.target.value)} placeholder="https://votre-service.com/webhook" className="flex-1 bg-slate-900 border border-slate-700 rounded-lg px-4 py-2 font-mono text-sm" />
                            <label className="flex items-center gap-2 px-4 py-2 bg-slate-700 rounded-lg cursor-pointer">
                              <input type="checkbox" checked={webhookEnabled} onChange={(e) => setWebhookEnabled(e.target.checked)} className="rounded" />
                              <span className="text-sm">Actif</span>
                            </label>
                          </div>
                          <div className="flex gap-2">
                            <button onClick={() => saveWebhook(webhook.id)} className="px-4 py-2 bg-green-600 hover:bg-green-700 rounded-lg flex items-center gap-2 text-sm">
                              <Save className="w-4 h-4" /> Sauver
                            </button>
                            <button onClick={() => setEditingWebhook(null)} className="px-4 py-2 bg-slate-700 hover:bg-slate-600 rounded-lg text-sm">
                              Annuler
                            </button>
                          </div>
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              )}

              {/* DIAGNOSTIC DISTANT */}
              {activeSection === "diagnostic" && (
                <div className="space-y-6">
                  <IntegrationsHealthPanel token={localStorage.getItem("auth_token")} />
                  <DiagnosticPanel token={localStorage.getItem("auth_token")} />
                </div>
              )}

              {/* BASE DE DONNÉES */}
              {activeSection === "database" && (
                <div className="space-y-6">
                  <div className="bg-red-500/10 border border-red-500/30 rounded-xl p-4">
                    <p className="text-sm text-red-300">
                      <AlertTriangle className="w-4 h-4 inline mr-2" />
                      Attention : La suppression des données est irréversible. Les collections protégées ne peuvent pas être vidées.
                    </p>
                  </div>
                  
                  <div className="bg-slate-800/50 rounded-xl border border-slate-700/50 overflow-hidden">
                    <div className="px-6 py-4 border-b border-slate-700/50">
                      <h3 className="font-semibold">Collections MongoDB ({collections.length})</h3>
                    </div>
                    <div className="divide-y divide-slate-700/50">
                      {collections.map(coll => {
                        const isProtected = ["authorized_emails", "users", "ai_config", "admin_config"].includes(coll.name);
                        return (
                          <div key={coll.name} className="flex items-center justify-between px-6 py-4 hover:bg-slate-700/20">
                            <div className="flex items-center gap-4">
                              <div className={`w-10 h-10 rounded-lg flex items-center justify-center ${isProtected ? 'bg-amber-500/20' : 'bg-slate-700'}`}>
                                {isProtected ? <Shield className="w-5 h-5 text-amber-400" /> : <Database className="w-5 h-5 text-slate-400" />}
                              </div>
                              <div>
                                <p className="font-medium font-mono">{coll.name}</p>
                                <p className="text-sm text-slate-400">{coll.count.toLocaleString()} documents</p>
                              </div>
                            </div>
                            {!isProtected && coll.count > 0 && (
                              <button onClick={() => clearCollection(coll.name)} className="p-2 text-red-400 hover:bg-red-500/20 rounded-lg" title="Vider la collection">
                                <Trash className="w-5 h-5" />
                              </button>
                            )}
                            {isProtected && (
                              <span className="px-2 py-1 bg-amber-500/20 text-amber-400 rounded text-xs">Protégé</span>
                            )}
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
              )}

              {/* LOGS */}
              {activeSection === "logs" && (
                <div className="space-y-4">
                  <div className="flex gap-2 mb-4">
                    <button onClick={() => setLogType("backend")} className={`px-4 py-2 rounded-lg ${logType === "backend" ? "bg-blue-500/20 text-blue-400 border border-blue-500/30" : "bg-slate-700 hover:bg-slate-600"}`}>
                      Backend
                    </button>
                    <button onClick={() => setLogType("frontend")} className={`px-4 py-2 rounded-lg ${logType === "frontend" ? "bg-green-500/20 text-green-400 border border-green-500/30" : "bg-slate-700 hover:bg-slate-600"}`}>
                      Frontend
                    </button>
                    <button onClick={loadLogs} className="ml-auto px-4 py-2 bg-slate-700 hover:bg-slate-600 rounded-lg flex items-center gap-2">
                      <RefreshCw className={`w-4 h-4 ${loadingLogs ? 'animate-spin' : ''}`} />
                      Actualiser
                    </button>
                  </div>
                  
                  <div className="bg-slate-950 rounded-xl border border-slate-800 p-4 font-mono text-xs overflow-x-auto max-h-[600px] overflow-y-auto">
                    {loadingLogs ? (
                      <div className="flex items-center justify-center py-10">
                        <RefreshCw className="w-6 h-6 animate-spin text-slate-500" />
                      </div>
                    ) : logs.length === 0 ? (
                      <p className="text-slate-500 text-center py-10">Aucun log disponible</p>
                    ) : (
                      logs.map((line, i) => (
                        <div key={i} className={`py-0.5 ${line.includes('ERROR') ? 'text-red-400' : line.includes('WARNING') ? 'text-amber-400' : line.includes('INFO') ? 'text-green-400' : 'text-slate-400'}`}>
                          {line}
                        </div>
                      ))
                    )}
                  </div>
                </div>
              )}
            </>
          )}
        </main>
      </div>
    </div>
  );
}

function StatCard({ icon: Icon, label, value, color, subtitle }) {
  const colors = {
    blue: "from-blue-500/20 to-blue-600/10 border-blue-500/30 text-blue-400",
    green: "from-green-500/20 to-green-600/10 border-green-500/30 text-green-400",
    purple: "from-purple-500/20 to-purple-600/10 border-purple-500/30 text-purple-400",
    orange: "from-orange-500/20 to-orange-600/10 border-orange-500/30 text-orange-400",
    cyan: "from-cyan-500/20 to-cyan-600/10 border-cyan-500/30 text-cyan-400",
    emerald: "from-emerald-500/20 to-emerald-600/10 border-emerald-500/30 text-emerald-400",
    red: "from-red-500/20 to-red-600/10 border-red-500/30 text-red-400",
  };
  
  return (
    <div className={`bg-gradient-to-br ${colors[color]} border rounded-xl p-5`}>
      <div className="flex items-center gap-3 mb-3">
        <div className="w-10 h-10 rounded-lg bg-slate-900/50 flex items-center justify-center">
          <Icon className="w-5 h-5" />
        </div>
        <span className="text-slate-400 text-sm">{label}</span>
      </div>
      <p className="text-3xl font-bold">{typeof value === 'number' ? value.toLocaleString() : value}</p>
      {subtitle && <p className="text-xs text-slate-500 mt-1">{subtitle}</p>}
    </div>
  );
}

function PromptCard({ prompt, isEditing, promptValue, onEdit, onValueChange, onSave, onCancel }) {
  // Détecter si c'est un JSON array
  const isJsonArray = prompt.value?.trim().startsWith('[');
  
  // Icons selon le type de prompt
  const getPromptIcon = (id) => {
    if (id.includes('blague')) return '🎭';
    if (id.includes('loi_nombres')) return '📊';
    if (id.includes('confirmation')) return '✅';
    if (id.includes('pause')) return '☕';
    if (id.includes('system')) return '🤖';
    if (id.includes('welcome')) return '👋';
    if (id.includes('contextual')) return '💬';
    return '📝';
  };
  
  return (
    <div className="bg-slate-800/50 rounded-lg border border-slate-700/50 p-4">
      <div className="flex items-start justify-between mb-2">
        <div className="flex items-start gap-3">
          <span className="text-xl">{getPromptIcon(prompt.id)}</span>
          <div>
            <h4 className="font-medium text-sm">{prompt.name.replace('SAN-IA - ', '').replace('SAN-IA Banner - ', '')}</h4>
            <p className="text-xs text-slate-500 mt-0.5">{prompt.description}</p>
          </div>
        </div>
        <button onClick={onEdit} className="p-1.5 hover:bg-slate-700 rounded-lg text-blue-400">
          {isEditing ? <ChevronUp className="w-4 h-4" /> : <Edit2 className="w-4 h-4" />}
        </button>
      </div>
      
      {isEditing ? (
        <div className="space-y-3 mt-3">
          {isJsonArray && (
            <div className="bg-amber-500/10 border border-amber-500/30 rounded-lg p-2 text-xs text-amber-300">
              ⚠️ Format JSON Array - Respectez la syntaxe : ["message 1", "message 2", ...]
            </div>
          )}
          <textarea 
            value={promptValue} 
            onChange={(e) => onValueChange(e.target.value)} 
            rows={isJsonArray ? 8 : 4} 
            className="w-full bg-slate-900 border border-slate-700 rounded-lg px-3 py-2 text-sm font-mono" 
          />
          <div className="flex gap-2">
            <button onClick={onSave} className="px-3 py-1.5 bg-green-600 hover:bg-green-700 rounded-lg flex items-center gap-1.5 text-xs">
              <Save className="w-3 h-3" /> Sauvegarder
            </button>
            <button onClick={onCancel} className="px-3 py-1.5 bg-slate-700 hover:bg-slate-600 rounded-lg text-xs">
              Annuler
            </button>
          </div>
        </div>
      ) : (
        <div className="mt-2">
          {isJsonArray ? (
            <div className="text-xs text-slate-500 bg-slate-900/50 rounded-lg p-2 max-h-16 overflow-hidden">
              <span className="text-purple-400">{(() => {
                try {
                  const arr = JSON.parse(prompt.value);
                  return `${arr.length} messages configurés`;
                } catch {
                  return 'Format JSON invalide';
                }
              })()}</span>
            </div>
          ) : (
            <pre className="text-xs text-slate-500 bg-slate-900/50 rounded-lg p-2 overflow-x-auto max-h-16 whitespace-pre-wrap">
              {prompt.value?.substring(0, 150)}{prompt.value?.length > 150 ? '...' : ''}
            </pre>
          )}
        </div>
      )}
    </div>
  );
}


// Composant pour gérer les permissions d'un utilisateur
function UserPermissionsRow({ user, onDelete, onUpdatePermissions, onToggleStatus, dashboardConfig, collaborateursConfig, onUpdateProfile, onRefreshCollabs, imapConfigs }) {
  const [expanded, setExpanded] = useState(false);
  const [saving, setSaving] = useState(false);
  const [togglingStatus, setTogglingStatus] = useState(false);
  const [addingCollab, setAddingCollab] = useState(null); // role_id si on ajoute
  const [newCollabName, setNewCollabName] = useState('');
  
  // Gestion du mot de passe
  const [showPasswordModal, setShowPasswordModal] = useState(false);
  const [newPassword, setNewPassword] = useState('');
  const [settingPassword, setSettingPassword] = useState(false);
  
  // Alias par rôle (nouveau système multi-alias)
  const [aliases, setAliases] = useState(user.collaborateur_aliases || {});
  
  // Numéro WhatsApp du collaborateur
  const [whatsappPhone, setWhatsappPhone] = useState(user.whatsapp_phone || '');
  
  // Rattachement AMO
  const [linkedAmoId, setLinkedAmoId] = useState(user.linked_amo_id || '');
  const [amoList, setAmoList] = useState([]);
  
  // Clone numerique
  const [clonable, setClonable] = useState(user.clonable || false);
  const [togglingClone, setTogglingClone] = useState(false);
  
  // Emails connectes (from imap_configs)
  const connectedEmails = (imapConfigs || []).filter(c => 
    (c.assigned_users || []).includes(user.email)
  );
  
  // Ringover stats
  const [ringoverStats, setRingoverStats] = useState(null);
  const [loadingRingover, setLoadingRingover] = useState(false);
  
  // Charger la liste des AMO quand le panneau s'ouvre
  useEffect(() => {
    if (expanded && amoList.length === 0) {
      const token = localStorage.getItem("auth_token");
      authFetch(`${getApiUrl()}/api/amo-mar/select-options`, {
        credentials: "include",
        headers: token ? { Authorization: `Bearer ${token}` } : {},
      })
        .then(r => r.ok ? r.json() : { amo: [] })
        .then(d => setAmoList(d.amo || []))
        .catch(() => {});
    }
  }, [expanded, amoList.length]);
  
  // Charger les stats Ringover quand le panneau s'ouvre
  useEffect(() => {
    if (expanded && !ringoverStats && !loadingRingover) {
      setLoadingRingover(true);
      const token = localStorage.getItem("auth_token");
      authFetch(`${getApiUrl()}/api/clones/users/${encodeURIComponent(user.email)}/ringover-stats`, {
        credentials: "include",
        headers: token ? { Authorization: `Bearer ${token}` } : {},
      })
        .then(r => r.ok ? r.json() : null)
        .then(d => { if (d) setRingoverStats(d); })
        .catch(() => {})
        .finally(() => setLoadingRingover(false));
    }
  }, [expanded, ringoverStats, loadingRingover, user.email]);
  
  // Statut actif de l'utilisateur (par défaut: true si non défini)
  const isActive = user.is_active !== false;
  
  // Fonction pour ajouter un collaborateur à la liste permanente
  const handleAddCollab = async (roleId) => {
    if (!newCollabName.trim()) return;
    
    try {
      const token = localStorage.getItem("auth_token");
      const resp = await authFetch(`${getApiUrl()}/api/config/collaborateurs/add`, {
        method: 'POST',
        credentials: "include",
        headers: {
          'Content-Type': 'application/json',
          ...(token ? { Authorization: `Bearer ${token}` } : {}),
        },
        body: JSON.stringify({ name: newCollabName.trim(), roles: [roleId] })
      });
      
      if (resp.ok) {
        // Rafraîchir la liste des collaborateurs
        if (onRefreshCollabs) onRefreshCollabs();
        // Sélectionner le nouveau collaborateur
        handleAliasChange(roleId, newCollabName.trim());
        setNewCollabName('');
        setAddingCollab(null);
      }
    } catch (e) {
      console.error('Erreur ajout collaborateur:', e);
    }
  };
  
  // Valeurs par défaut pour les permissions financières
  const defaultFinancePermissions = {
    voir_montant_devis: false,
    voir_montant_rac: false,
    voir_montant_encaissements_rac: false,
    voir_montant_acomptes: false,
    voir_montant_soldes: false,
    voir_montant_travaux_supp: false,
    confirmer_reception_date: false
  };
  
  // Utiliser la config centralisée si disponible, sinon fallback sur les valeurs en dur
  // Les dashboards compta sont désactivés par défaut
  const defaultDashboardAccess = dashboardConfig?.default_access || {
    recherche: true, salle_reunion: true, telepro: true, r1: true,
    administratif: true, amo: true, r2: true, chantiers: true,
    compta_finances: false, compta_fi_new: false, consolidation_v2: false,
    super_batard_compta: false, factures_fournisseurs: false, aides_comp: true,
    tc_pac_iso: true, communications_ia: false, marketing: false,
    grands_comptes: false, calendrier: true, formations: true,
    comite_direction: false, super_batard: false, simulateur_aides: true,
    tests: false
  };
  
  // Labels des dashboards (depuis la config centralisée ou fallback)
  const dashboardLabels = dashboardConfig?.labels || {
    recherche: { label: "🔍 Recherche", desc: "Recherche multi-critères", color: "purple" },
    salle_reunion: { label: "🏛️ Salle de Réunion", desc: "Réunions virtuelles IA", color: "purple" },
    telepro: { label: "📞 Télépro", desc: "Prospection téléphonique", color: "blue" },
    r1: { label: "🔍 R1", desc: "Prévisite audit technique", color: "green" },
    administratif: { label: "📋 Administratif", desc: "Gestion des dossiers", color: "slate" },
    amo: { label: "🏢 AMO", desc: "Assistance maîtrise d'ouvrage", color: "violet" },
    r2: { label: "📐 R2", desc: "Sortie architecte", color: "cyan" },
    chantiers: { label: "🚚 Chantiers", desc: "Suivi des travaux", color: "orange" },
    compta_finances: { label: "💰 Compta / Finances", desc: "Rapprochements & Stats", color: "emerald" },
    compta_fi_new: { label: "🚀 COMPTA FI NEW", desc: "Validation Pennylane", color: "emerald" },
    consolidation_v2: { label: "🧪 Compta (Test)", desc: "Version test consolidation", color: "yellow" },
    super_batard_compta: { label: "🔴 Admin Compta", desc: "Administration comptabilité", color: "red" },
    factures_fournisseurs: { label: "📄 Factures Fournisseurs", desc: "Dépôt & suivi factures", color: "orange" },
    aides_comp: { label: "💝 Aides Comp.", desc: "Aides complémentaires", color: "pink" },
    tc_pac_iso: { label: "⚙️ TC/PAC ISO", desc: "Techniques & PAC", color: "indigo" },
    communications_ia: { label: "📨 Communications IA", desc: "Traitement & Enrichissement", color: "sky" },
    marketing: { label: "📣 Marketing & Com", desc: "Acquisition & Communication", color: "rose" },
    grands_comptes: { label: "🏢 Grands Comptes", desc: "CCAS & Prescripteurs", color: "amber" },
    calendrier: { label: "📅 Calendrier", desc: "RDV R1 & R2", color: "teal" },
    formations: { label: "📚 Formations", desc: "Formation MaPrimeAdapt' & Simulations", color: "indigo" },
    comite_direction: { label: "👔 Comité de Direction", desc: "Échanges avec les directeurs IA", color: "amber" },
    super_batard: { label: "😈 Super Batard", desc: "Admin & Configuration IA", color: "red" },
    simulateur_aides: { label: "🏠 Simulateur Aides", desc: "Calcul aides rénovation", color: "lime" },
    tests: { label: "🧪 Tests", desc: "Environnement de test modales", color: "purple" }
  };
  
  // Initialiser avec les permissions de l'utilisateur ou les défauts
  const [permissions, setPermissions] = useState(() => {
    return { ...defaultFinancePermissions, ...(user.finance_permissions || {}) };
  });
  
  const [dashboardAccess, setDashboardAccess] = useState(() => {
    return { ...defaultDashboardAccess, ...(user.dashboard_access || {}) };
  });
  
  // Permissions d'accès aux plannings d'équipes
  const [planningPermissions, setPlanningPermissions] = useState(() => {
    return user.planning_permissions || {};
  });
  
  // Liste des équipes disponibles (chargée depuis l'API)
  const [availableTeams, setAvailableTeams] = useState([]);
  
  // Charger les équipes disponibles
  useEffect(() => {
    const loadTeams = async () => {
      try {
        const token = localStorage.getItem("auth_token");
        const resp = await authFetch(`${API}/teams`, {
          credentials: "include",
          headers: token ? { Authorization: `Bearer ${token}` } : {},
        });
        if (resp.ok) {
          const data = await resp.json();
          setAvailableTeams(data.teams || []);
        }
      } catch (e) {
        console.error("Erreur chargement équipes:", e);
      }
    };
    loadTeams();
  }, []);
  
  // Synchroniser quand user change (important pour les mises à jour après sauvegarde)
  useEffect(() => {
    setPermissions({ ...defaultFinancePermissions, ...(user.finance_permissions || {}) });
    setDashboardAccess({ ...defaultDashboardAccess, ...(user.dashboard_access || {}) });
    setAliases(user.collaborateur_aliases || {});
    setPlanningPermissions(user.planning_permissions || {});
    setWhatsappPhone(user.whatsapp_phone || '');
    setLinkedAmoId(user.linked_amo_id || '');
  }, [user.email, user.finance_permissions, user.dashboard_access, user.collaborateur_aliases, user.planning_permissions, user.whatsapp_phone, user.linked_amo_id]);

  const permissionLabels = {
    voir_montant_devis: { label: "💰 Montant Devis", desc: "Voir le montant du devis" },
    voir_montant_rac: { label: "💵 Montant RAC", desc: "Voir le montant du RAC" },
    voir_montant_encaissements_rac: { label: "📥 Encaissements RAC", desc: "Voir les encaissements RAC et dates" },
    voir_montant_acomptes: { label: "🏦 Acomptes", desc: "Voir les montants des acomptes" },
    voir_montant_soldes: { label: "💎 Soldes", desc: "Voir les montants des soldes" },
    voir_montant_travaux_supp: { label: "🔧 Travaux Supp.", desc: "Voir les travaux supplémentaires" },
    confirmer_reception_date: { label: "✅ Confirmer réception", desc: "Confirmer réception + date (sans montant)" }
  };

  const handleToggle = (key) => {
    setPermissions(prev => ({ ...prev, [key]: !prev[key] }));
  };

  const handleDashboardToggle = (key) => {
    setDashboardAccess(prev => ({ ...prev, [key]: !prev[key] }));
  };
  
  const handleAliasChange = (roleId, value) => {
    setAliases(prev => ({ ...prev, [roleId]: value }));
  };
  
  // Gérer le changement de permission planning
  const handlePlanningPermissionChange = (teamId, level) => {
    setPlanningPermissions(prev => {
      const newPerms = { ...prev };
      if (level === "default") {
        // Supprimer la permission explicite pour revenir au défaut
        delete newPerms[teamId];
      } else {
        newPerms[teamId] = level;
      }
      return newPerms;
    });
  };
  
  // Déterminer la permission effective pour une équipe
  const getEffectivePlanningPermission = (teamId) => {
    // Si permission explicite définie
    if (planningPermissions[teamId]) {
      return planningPermissions[teamId];
    }
    // Sinon, par défaut: "write" si assigné à l'équipe, "none" sinon
    if (aliases[teamId]) {
      return "write";
    }
    return "none";
  };

  const handleSave = async () => {
    setSaving(true);
    console.log("📤 Saving permissions:", { permissions, dashboardAccess, aliases, planningPermissions, whatsappPhone });
    await onUpdatePermissions(permissions, dashboardAccess, planningPermissions);
    
    // Sauvegarder les aliases multi-rôles ET le numéro WhatsApp ET le rattachement AMO
    await onUpdateProfile(aliases, whatsappPhone, linkedAmoId);
    
    setSaving(false);
    setExpanded(false);
  };
  
  const handleSetPassword = async () => {
    if (!newPassword || newPassword.length < 6) {
      alert('Le mot de passe doit contenir au moins 6 caractères');
      return;
    }
    
    setSettingPassword(true);
    try {
      const resp = await authFetch(`${API}/admin/users/${encodeURIComponent(user.email)}/set-password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: 'include',
        body: JSON.stringify({ email: user.email, password: newPassword })
      });
      
      if (resp.ok) {
        alert('Mot de passe défini avec succès');
        setShowPasswordModal(false);
        setNewPassword('');
        // Mettre à jour l'affichage du badge MDP sans recharger la page
        user.password_hash = true;
      } else {
        const data = await resp.json();
        alert(data.detail || 'Erreur lors de la définition du mot de passe');
      }
    } catch (e) {
      console.error(e);
      alert('Erreur de connexion');
    }
    setSettingPassword(false);
  };
  
  // Toggle clone numerique
  const handleToggleClone = async () => {
    setTogglingClone(true);
    const newVal = !clonable;
    try {
      await authFetch(`${API}/api/clones/users/${encodeURIComponent(user.email)}/clonable`, {
        method: 'PATCH',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ clonable: newVal })
      });
      setClonable(newVal);
    } catch (e) {
      console.error('Erreur toggle clone:', e);
    }
    setTogglingClone(false);
  };

  // Count active permissions
  let activeCount = 0;
  const permKeys = Object.keys(permissions);
  for (let i = 0; i < permKeys.length; i++) {
    if (permissions[permKeys[i]]) activeCount++;
  }
  
  // Count dashboard access
  let dashboardCount = 0;
  const dashKeys = Object.keys(dashboardAccess);
  for (let i = 0; i < dashKeys.length; i++) {
    if (dashboardAccess[dashKeys[i]]) dashboardCount++;
  }

  return (
    <div className={`border-b border-slate-700/50 last:border-b-0 ${!isActive ? 'opacity-60' : ''}`}>
      <div 
        onClick={() => setExpanded(!expanded)}
        className="flex items-center justify-between px-6 py-4 hover:bg-slate-700/20 cursor-pointer"
      >
        <div className="flex items-center gap-4">
          <div className={`w-10 h-10 rounded-lg flex items-center justify-center ${user.role === 'admin' ? 'bg-amber-500/20' : 'bg-slate-700'}`}>
            {user.role === 'admin' ? (
              <svg className="w-5 h-5 text-amber-400" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" /></svg>
            ) : (
              <svg className="w-5 h-5 text-slate-400" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" /></svg>
            )}
          </div>
          <div>
            <div className="flex items-center gap-2">
              <p className="font-medium">{user.email}</p>
              {!isActive && (
                <span className="px-2 py-0.5 bg-red-500/30 text-red-400 rounded text-xs font-medium">
                  Désactivé
                </span>
              )}
            </div>
            <div className="flex items-center gap-2 flex-wrap">
              <span className="text-sm text-slate-400">{user.role === 'admin' ? 'Administrateur' : 'Utilisateur'}</span>
              {user.password_hash && (
                <span className="px-2 py-0.5 bg-green-500/20 text-green-400 rounded text-xs" title="Connexion par mot de passe activée">
                  🔐 MDP
                </span>
              )}
              {dashboardCount > 0 && (
                <span className="px-2 py-0.5 bg-blue-500/20 text-blue-400 rounded text-xs">
                  {dashboardCount} dashboard{dashboardCount > 1 ? 's' : ''}
                </span>
              )}
              {activeCount > 0 && (
                <span className="px-2 py-0.5 bg-emerald-500/20 text-emerald-400 rounded text-xs">
                  {activeCount} perm. finance
                </span>
              )}
              {user.whatsapp_phone && (
                <span className="px-2 py-0.5 bg-green-500/20 text-green-400 rounded text-xs" title={user.whatsapp_phone}>
                  📱 WhatsApp
                </span>
              )}
              {user.linked_amo_name && (
                <span className="px-2 py-0.5 bg-amber-500/20 text-amber-400 rounded text-xs" title={`Rattaché à ${user.linked_amo_name}`}>
                  🏢 {user.linked_amo_name}
                </span>
              )}
              {clonable && (
                <span className="px-2 py-0.5 bg-violet-500/20 text-violet-400 rounded text-xs" title="Clone numerique actif">
                  🧬 Clone
                </span>
              )}
              {connectedEmails.length > 0 && (
                <span className="px-2 py-0.5 bg-blue-500/20 text-blue-400 rounded text-xs" title={connectedEmails.map(c => c.email_address).join(', ')}>
                  📧 {connectedEmails.length} email{connectedEmails.length > 1 ? 's' : ''}
                </span>
              )}
              {ringoverStats && ringoverStats.connected && (
                <span className="px-2 py-0.5 bg-emerald-500/20 text-emerald-400 rounded text-xs" title={`${ringoverStats.calls.total} appels, ${ringoverStats.sms.total} SMS`}>
                  📞 {ringoverStats.alias}
                </span>
              )}
            </div>
          </div>
        </div>
        <div className="flex items-center gap-2">
          {/* Bouton Activer/Désactiver */}
          <button 
            onClick={(e) => { 
              e.stopPropagation(); 
              setTogglingStatus(true);
              onToggleStatus(!isActive).finally(() => setTogglingStatus(false));
            }}
            disabled={togglingStatus}
            className={`p-2 rounded-lg transition-colors ${
              isActive 
                ? 'text-orange-400 hover:bg-orange-500/20' 
                : 'text-green-400 hover:bg-green-500/20'
            }`}
            title={isActive ? 'Désactiver l\'utilisateur' : 'Réactiver l\'utilisateur'}
          >
            {togglingStatus ? (
              <svg className="w-5 h-5 animate-spin" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" /></svg>
            ) : isActive ? (
              <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636" /></svg>
            ) : (
              <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
            )}
          </button>
          {/* Bouton Définir mot de passe */}
          <button 
            onClick={(e) => { e.stopPropagation(); setShowPasswordModal(true); }}
            className={`p-2 rounded-lg transition-colors ${user.password_hash ? 'text-green-400 hover:bg-green-500/20' : 'text-slate-400 hover:bg-slate-500/20'}`}
            title={user.password_hash ? 'Modifier le mot de passe' : 'Définir un mot de passe'}
          >
            <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 7a2 2 0 012 2m4 0a6 6 0 01-7.743 5.743L11 17H9v2H7v2H4a1 1 0 01-1-1v-2.586a1 1 0 01.293-.707l5.964-5.964A6 6 0 1121 9z" /></svg>
          </button>
          <svg className={`w-5 h-5 text-slate-400 transition-transform ${expanded ? 'rotate-180' : ''}`} fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" /></svg>
          <button 
            onClick={(e) => { e.stopPropagation(); onDelete(); }} 
            className="p-2 text-red-400 hover:bg-red-500/20 rounded-lg"
          >
            <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" /></svg>
          </button>
        </div>
      </div>
      
      {/* Modale pour définir le mot de passe */}
      {showPasswordModal && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50" onClick={() => setShowPasswordModal(false)}>
          <div className="bg-slate-800 rounded-xl p-6 w-full max-w-md mx-4" onClick={e => e.stopPropagation()}>
            <h3 className="text-lg font-semibold text-white mb-4">
              🔐 {user.password_hash ? 'Modifier' : 'Définir'} le mot de passe
            </h3>
            <p className="text-slate-400 text-sm mb-4">
              Pour <span className="text-amber-400">{user.email}</span>
            </p>
            <input
              type="password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              placeholder="Nouveau mot de passe (min. 6 caractères)"
              className="w-full px-4 py-3 bg-slate-700 border border-slate-600 rounded-lg text-white placeholder-slate-500 focus:border-amber-500 focus:ring-1 focus:ring-amber-500 mb-4"
            />
            <div className="flex gap-3">
              <button
                onClick={() => { setShowPasswordModal(false); setNewPassword(''); }}
                className="flex-1 px-4 py-2 bg-slate-700 text-slate-300 rounded-lg hover:bg-slate-600"
              >
                Annuler
              </button>
              <button
                onClick={handleSetPassword}
                disabled={settingPassword || newPassword.length < 6}
                className="flex-1 px-4 py-2 bg-amber-500 text-white rounded-lg hover:bg-amber-600 disabled:opacity-50"
              >
                {settingPassword ? 'En cours...' : 'Confirmer'}
              </button>
            </div>
          </div>
        </div>
      )}
      
      {expanded && (
        <div className="px-6 pb-4 pt-2 bg-slate-900/50">
          {/* Section Profil Collaborateur */}
          <h4 className="text-sm font-medium text-amber-400 mb-3 flex items-center gap-2">
            <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" /></svg>
            Profil Collaborateur
          </h4>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
            {/* Alias par rôle - Multi-colonnes */}
            {(collaborateursConfig?.roles || []).map(role => (
              <div key={role.id}>
                <label className="block text-xs text-slate-400 mb-1">{role.label} {role.type === 'externe' && <span className="text-amber-400">(externe)</span>}</label>
                {role.type === 'externe' ? (
                  /* Rôle externe (AMO) : Société + Nom du collaborateur */
                  <div className="space-y-2">
                    <div className="flex gap-2">
                      <select
                        value={aliases[role.id]?.societe || ""}
                        onChange={(e) => handleAliasChange(role.id, { ...aliases[role.id], societe: e.target.value })}
                        className="flex-1 px-3 py-2 bg-slate-800 border border-slate-700 rounded-lg text-white text-sm focus:border-amber-500"
                      >
                        <option value="">-- Société --</option>
                        {(role.collaborateurs || []).map(name => (
                          <option key={name} value={name}>{name}</option>
                        ))}
                      </select>
                      <input
                        type="text"
                        placeholder="Autre société..."
                        value={role.collaborateurs?.includes(aliases[role.id]?.societe) ? "" : (aliases[role.id]?.societe || "")}
                        onChange={(e) => handleAliasChange(role.id, { ...aliases[role.id], societe: e.target.value })}
                        className="w-32 px-2 py-2 bg-slate-800 border border-slate-700 rounded-lg text-white text-sm focus:border-amber-500"
                      />
                    </div>
                    <input
                      type="text"
                      placeholder="Nom du collaborateur (ex: Jean Dupont)"
                      value={aliases[role.id]?.nom || ""}
                      onChange={(e) => handleAliasChange(role.id, { ...aliases[role.id], nom: e.target.value })}
                      className="w-full px-3 py-2 bg-slate-800 border border-slate-700 rounded-lg text-white text-sm focus:border-amber-500"
                    />
                  </div>
                ) : role.has_dropdown ? (
                  /* Rôle interne avec dropdown */
                  <div className="space-y-2">
                    <div className="flex gap-2">
                      <select
                        value={aliases[role.id] || ""}
                        onChange={(e) => handleAliasChange(role.id, e.target.value)}
                        className="flex-1 px-3 py-2 bg-slate-800 border border-slate-700 rounded-lg text-white text-sm focus:border-amber-500 focus:ring-1 focus:ring-amber-500"
                      >
                        <option value="">-- Aucun --</option>
                        {(role.collaborateurs || []).map(name => (
                          <option key={name} value={name}>{name}</option>
                        ))}
                      </select>
                      <button
                        type="button"
                        onClick={() => setAddingCollab(addingCollab === role.id ? null : role.id)}
                        className={`px-3 py-2 rounded-lg text-sm font-medium transition-colors ${
                          addingCollab === role.id 
                            ? 'bg-amber-500 text-black' 
                            : 'bg-slate-700 hover:bg-slate-600 text-white'
                        }`}
                        title="Ajouter un nouveau collaborateur à la liste"
                      >
                        {addingCollab === role.id ? '×' : '+'}
                      </button>
                    </div>
                    {addingCollab === role.id && (
                      <div className="flex gap-2 animate-fadeIn">
                        <input
                          type="text"
                          placeholder="Nom du nouveau collaborateur..."
                          value={newCollabName}
                          onChange={(e) => setNewCollabName(e.target.value)}
                          onKeyPress={(e) => e.key === 'Enter' && handleAddCollab(role.id)}
                          className="flex-1 px-3 py-2 bg-slate-900 border border-amber-500/50 rounded-lg text-white text-sm focus:border-amber-500"
                          autoFocus
                        />
                        <button
                          type="button"
                          onClick={() => handleAddCollab(role.id)}
                          disabled={!newCollabName.trim()}
                          className="px-4 py-2 bg-amber-500 hover:bg-amber-400 disabled:opacity-50 text-black rounded-lg text-sm font-medium"
                        >
                          Ajouter
                        </button>
                      </div>
                    )}
                  </div>
                ) : (
                  /* Rôle interne saisie libre */
                  <input
                    type="text"
                    placeholder="Saisir le nom..."
                    value={aliases[role.id] || ""}
                    onChange={(e) => handleAliasChange(role.id, e.target.value)}
                    className="w-full px-3 py-2 bg-slate-800 border border-slate-700 rounded-lg text-white text-sm focus:border-amber-500"
                  />
                )}
                <p className="text-xs text-slate-500 mt-1">{role.description}</p>
              </div>
            ))}
          </div>

          {/* Numéro WhatsApp du collaborateur */}
          <div className="mb-6 bg-green-500/10 border border-green-500/30 rounded-lg p-4">
            <label className="block text-sm font-medium text-green-400 mb-2 flex items-center gap-2">
              <MessageCircle className="w-4 h-4" />
              Numéro WhatsApp
            </label>
            <input
              type="tel"
              placeholder="+33 6 12 34 56 78"
              value={whatsappPhone}
              onChange={(e) => setWhatsappPhone(e.target.value)}
              className="w-full md:w-1/2 px-3 py-2 bg-slate-800 border border-slate-700 rounded-lg text-white text-sm focus:border-green-500 focus:ring-1 focus:ring-green-500"
              data-testid="user-whatsapp-phone"
            />
            <p className="text-xs text-slate-500 mt-2">
              Ce numéro sera utilisé pour les notifications WhatsApp automatiques (rappels RDV, alertes NRP, etc.)
            </p>
          </div>

          {/* Rattachement AMO */}
          <div className="mb-6 bg-amber-500/10 border border-amber-500/30 rounded-lg p-4">
            <label className="block text-sm font-medium text-amber-400 mb-2 flex items-center gap-2">
              <Building2 className="w-4 h-4" />
              Rattachement AMO
            </label>
            <p className="text-xs text-slate-400 mb-3">
              Si cet utilisateur est un AMO externe, rattachez-le à une société AMO. Il ne verra que les clients qui lui sont attribués.
            </p>
            <select
              value={linkedAmoId}
              onChange={(e) => setLinkedAmoId(e.target.value)}
              className="w-full md:w-1/2 px-3 py-2 bg-slate-800 border border-slate-700 rounded-lg text-white text-sm focus:border-amber-500 focus:ring-1 focus:ring-amber-500"
              data-testid="user-linked-amo"
            >
              <option value="">-- Aucun rattachement AMO --</option>
              {amoList.map(a => (
                <option key={a.id} value={a.id}>{a.nom}</option>
              ))}
            </select>
            {linkedAmoId && (
              <div className="mt-2 flex items-center gap-2 text-xs text-amber-300">
                <Building2 className="w-3 h-3" />
                Cet utilisateur verra uniquement les clients attribués à cet AMO
              </div>
            )}
          </div>

          {/* Clone Numerique */}
          <div className={`mb-6 border rounded-lg p-4 ${clonable ? 'bg-violet-500/10 border-violet-500/30' : 'bg-slate-800/50 border-slate-700'}`}>
            <div className="flex items-center justify-between">
              <div>
                <label className="block text-sm font-medium text-violet-400 mb-1 flex items-center gap-2">
                  <Brain className="w-4 h-4" />
                  Clone Numerique
                </label>
                <p className="text-xs text-slate-500">
                  {clonable 
                    ? 'Clone actif — visible dans Supervision & Direction > Clones Numeriques' 
                    : 'Activer pour creer un clone numerique de ce collaborateur'}
                </p>
              </div>
              <button
                data-testid={`clone-toggle-${user.email}`}
                onClick={handleToggleClone}
                disabled={togglingClone}
                className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors flex items-center gap-2 ${
                  clonable 
                    ? 'bg-violet-600 text-white hover:bg-violet-500' 
                    : 'bg-slate-700 text-slate-300 hover:bg-slate-600'
                }`}
              >
                {togglingClone ? (
                  <svg className="w-4 h-4 animate-spin" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" /></svg>
                ) : (
                  <Brain className="w-4 h-4" />
                )}
                {clonable ? 'Clone actif' : 'Activer le clone'}
              </button>
            </div>
          </div>

          {/* Emails connectes */}
          <div className="mb-6 border rounded-lg p-4 bg-slate-800/50 border-slate-700">
            <label className="block text-sm font-medium text-blue-400 mb-2 flex items-center gap-2">
              <Mail className="w-4 h-4" />
              Boites email connectees
            </label>
            {connectedEmails.length === 0 ? (
              <p className="text-xs text-slate-500">
                Aucune boite email attribuee. Configurez depuis <strong className="text-blue-400">Connecteur Email</strong>.
              </p>
            ) : (
              <div className="space-y-2">
                {connectedEmails.map((config) => {
                  const typeColors = {
                    clients: 'bg-emerald-500/20 text-emerald-400',
                    factures: 'bg-amber-500/20 text-amber-400',
                    both: 'bg-purple-500/20 text-purple-400',
                  };
                  const typeLabels = { clients: 'Clients', factures: 'Factures', both: 'Les deux' };
                  return (
                    <div key={config.email_address} data-testid={`connected-email-${config.email_address}`}
                      className="flex items-center gap-3 px-3 py-2 bg-slate-900/50 rounded-lg border border-slate-700/50"
                    >
                      <div className={`w-8 h-8 rounded-lg flex items-center justify-center ${typeColors[config.email_type] || typeColors.clients}`}>
                        <Mail className="w-4 h-4" />
                      </div>
                      <div className="flex-1 min-w-0">
                        <p className="text-sm text-white truncate">{config.email_address}</p>
                        <p className="text-[10px] text-slate-500">
                          {config.last_sync ? `Sync: ${new Date(config.last_sync).toLocaleString('fr-FR')}` : 'Jamais sync'}
                        </p>
                      </div>
                      <span className={`px-2 py-0.5 rounded text-[10px] ${typeColors[config.email_type] || typeColors.clients}`}>
                        {typeLabels[config.email_type] || 'Clients'}
                      </span>
                      <span className={`w-2 h-2 rounded-full ${config.status === 'connected' ? 'bg-emerald-400' : 'bg-red-400'}`} />
                    </div>
                  );
                })}
              </div>
            )}
          </div>

          {/* Activite Ringover */}
          <div className="mb-6 border rounded-lg p-4 bg-slate-800/50 border-slate-700">
            <label className="block text-sm font-medium text-blue-400 mb-2 flex items-center gap-2">
              <Phone className="w-4 h-4" />
              Activite Ringover
            </label>
            {loadingRingover ? (
              <p className="text-xs text-slate-500">Chargement...</p>
            ) : !ringoverStats || !ringoverStats.connected ? (
              <p className="text-xs text-slate-500">
                Aucun identifiant Ringover configure. Renseignez l'alias dans <strong className="text-blue-400">Profil Collaborateur</strong> ci-dessus.
              </p>
            ) : (
              <div className="space-y-3">
                {/* Alias badge */}
                <div className="flex items-center gap-2">
                  <span className="text-xs text-slate-400">Alias :</span>
                  <span className="px-2 py-0.5 bg-blue-500/20 text-blue-400 rounded text-xs font-mono">{ringoverStats.alias}</span>
                </div>
                
                {/* Stats grid */}
                <div className="grid grid-cols-2 gap-3">
                  {/* Calls */}
                  <div className="bg-slate-900/50 rounded-lg border border-slate-700/50 p-3">
                    <div className="flex items-center gap-2 mb-2">
                      <Phone className="w-3.5 h-3.5 text-emerald-400" />
                      <span className="text-xs font-medium text-white">Appels</span>
                      <span className="ml-auto text-sm font-bold text-emerald-400">{ringoverStats.calls.total}</span>
                    </div>
                    <div className="flex gap-3 text-[10px] text-slate-400">
                      <span className="flex items-center gap-1">
                        <span className="w-1.5 h-1.5 rounded-full bg-green-400"></span>
                        {ringoverStats.calls.in} entrants
                      </span>
                      <span className="flex items-center gap-1">
                        <span className="w-1.5 h-1.5 rounded-full bg-blue-400"></span>
                        {ringoverStats.calls.out} sortants
                      </span>
                      {ringoverStats.calls.nrp > 0 && (
                        <span className="flex items-center gap-1">
                          <span className="w-1.5 h-1.5 rounded-full bg-red-400"></span>
                          {ringoverStats.calls.nrp} NRP
                        </span>
                      )}
                    </div>
                    {ringoverStats.calls.last && (
                      <div className="mt-2 pt-2 border-t border-slate-700/30 text-[10px] text-slate-500">
                        Dernier : {new Date(ringoverStats.calls.last.start_time).toLocaleString('fr-FR')}
                        {ringoverStats.calls.last.contact_name && ` — ${ringoverStats.calls.last.contact_name}`}
                        {!ringoverStats.calls.last.contact_name && ringoverStats.calls.last.contact_number && ` — ${ringoverStats.calls.last.contact_number}`}
                      </div>
                    )}
                  </div>
                  
                  {/* SMS */}
                  <div className="bg-slate-900/50 rounded-lg border border-slate-700/50 p-3">
                    <div className="flex items-center gap-2 mb-2">
                      <MessageSquare className="w-3.5 h-3.5 text-amber-400" />
                      <span className="text-xs font-medium text-white">SMS</span>
                      <span className="ml-auto text-sm font-bold text-amber-400">{ringoverStats.sms.total}</span>
                    </div>
                    <div className="flex gap-3 text-[10px] text-slate-400">
                      <span className="flex items-center gap-1">
                        <span className="w-1.5 h-1.5 rounded-full bg-green-400"></span>
                        {ringoverStats.sms.in} recus
                      </span>
                      <span className="flex items-center gap-1">
                        <span className="w-1.5 h-1.5 rounded-full bg-blue-400"></span>
                        {ringoverStats.sms.out} envoyes
                      </span>
                    </div>
                    {ringoverStats.sms.last && (
                      <div className="mt-2 pt-2 border-t border-slate-700/30 text-[10px] text-slate-500">
                        Dernier : {new Date(ringoverStats.sms.last.timestamp).toLocaleString('fr-FR')}
                        {ringoverStats.sms.last.contact_number && ` — ${ringoverStats.sms.last.contact_number}`}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )}
          </div>

          {/* Section Acces aux Dashboards */}
          <h4 className="text-sm font-medium text-blue-400 mb-3 flex items-center gap-2">
            <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 5a1 1 0 011-1h14a1 1 0 011 1v2a1 1 0 01-1 1H5a1 1 0 01-1-1V5zM4 13a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H5a1 1 0 01-1-1v-6zM16 13a1 1 0 011-1h2a1 1 0 011 1v6a1 1 0 01-1 1h-2a1 1 0 01-1-1v-6z" /></svg>
            Accès aux Dashboards
          </h4>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-2 mb-6">
            {Object.entries(dashboardLabels).map(([key, { label, desc, color }]) => (
              <label 
                key={key} 
                className={`flex flex-col p-3 rounded-lg cursor-pointer transition-colors ${
                  dashboardAccess[key] 
                    ? `bg-${color}-500/20 border border-${color}-500/30` 
                    : 'bg-slate-800 border border-slate-700 opacity-60'
                }`}
                style={{
                  backgroundColor: dashboardAccess[key] ? `rgba(var(--${color}-500), 0.2)` : undefined,
                  borderColor: dashboardAccess[key] ? `rgba(var(--${color}-500), 0.3)` : undefined
                }}
              >
                <div className="flex items-center justify-between mb-1">
                  <span className="text-sm font-medium">{label}</span>
                  <input
                    type="checkbox"
                    checked={dashboardAccess[key]}
                    onChange={() => handleDashboardToggle(key)}
                    className="w-4 h-4 rounded border-slate-600 text-blue-500 focus:ring-blue-500 bg-slate-700"
                  />
                </div>
                <p className="text-xs text-slate-500">{desc}</p>
              </label>
            ))}
          </div>

          {/* Section Permissions Planning */}
          <h4 className="text-sm font-medium text-cyan-400 mb-3 flex items-center gap-2">
            <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" /></svg>
            Permissions Planning (Équipes)
          </h4>
          <p className="text-xs text-slate-500 mb-3">
            Par défaut, un collaborateur a accès en <span className="text-emerald-400">écriture</span> aux équipes auxquelles il est assigné (via Profil Collaborateur).
            Vous pouvez personnaliser l'accès à chaque équipe ci-dessous.
          </p>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-2 mb-6">
            {availableTeams.map(team => {
              const effectiveLevel = getEffectivePlanningPermission(team.id);
              const isAssigned = !!aliases[team.id];
              const hasExplicitPermission = team.id in planningPermissions;
              
              return (
                <div 
                  key={team.id} 
                  className={`flex items-center justify-between p-3 rounded-lg border ${
                    effectiveLevel === 'write' 
                      ? 'bg-emerald-500/10 border-emerald-500/30' 
                      : effectiveLevel === 'read'
                        ? 'bg-blue-500/10 border-blue-500/30'
                        : 'bg-slate-800 border-slate-700'
                  }`}
                >
                  <div className="flex items-center gap-2">
                    <span 
                      className="w-3 h-3 rounded-full" 
                      style={{ backgroundColor: team.color || '#6b7280' }}
                    />
                    <div>
                      <span className="text-sm font-medium">{team.name}</span>
                      {isAssigned && !hasExplicitPermission && (
                        <span className="ml-2 text-xs text-slate-400">(assigné)</span>
                      )}
                      {hasExplicitPermission && (
                        <span className="ml-2 text-xs text-cyan-400">(personnalisé)</span>
                      )}
                    </div>
                  </div>
                  <select
                    value={hasExplicitPermission ? planningPermissions[team.id] : "default"}
                    onChange={(e) => handlePlanningPermissionChange(team.id, e.target.value)}
                    className={`px-2 py-1 rounded text-xs font-medium ${
                      effectiveLevel === 'write' 
                        ? 'bg-emerald-600 text-white' 
                        : effectiveLevel === 'read'
                          ? 'bg-blue-600 text-white'
                          : 'bg-slate-600 text-slate-300'
                    }`}
                  >
                    <option value="default">
                      {isAssigned ? '✏️ Défaut (Écriture)' : '🚫 Défaut (Aucun)'}
                    </option>
                    <option value="write">✏️ Écriture</option>
                    <option value="read">👁️ Lecture</option>
                    <option value="none">🚫 Aucun</option>
                  </select>
                </div>
              );
            })}
          </div>
          
          {/* Légende des permissions */}
          <div className="flex flex-wrap gap-4 mb-6 text-xs">
            <div className="flex items-center gap-1">
              <span className="w-3 h-3 rounded bg-emerald-500"></span>
              <span className="text-slate-400">Écriture: Voir & créer/modifier RDV</span>
            </div>
            <div className="flex items-center gap-1">
              <span className="w-3 h-3 rounded bg-blue-500"></span>
              <span className="text-slate-400">Lecture: Voir les RDV uniquement</span>
            </div>
            <div className="flex items-center gap-1">
              <span className="w-3 h-3 rounded bg-slate-600"></span>
              <span className="text-slate-400">Aucun: Équipe masquée</span>
            </div>
          </div>

          {/* Section Permissions Financières */}
          <h4 className="text-sm font-medium text-emerald-400 mb-3 flex items-center gap-2">
            <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
            Permissions Financières
          </h4>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
            {Object.entries(permissionLabels).map(([key, { label, desc }]) => (
              <label 
                key={key} 
                className={`flex items-center justify-between p-3 rounded-lg cursor-pointer transition-colors ${
                  permissions[key] ? 'bg-emerald-500/20 border border-emerald-500/30' : 'bg-slate-800 border border-slate-700'
                }`}
              >
                <div>
                  <span className="text-sm font-medium">{label}</span>
                  <p className="text-xs text-slate-500">{desc}</p>
                </div>
                <input
                  type="checkbox"
                  checked={permissions[key]}
                  onChange={() => handleToggle(key)}
                  className="w-5 h-5 rounded border-slate-600 text-emerald-500 focus:ring-emerald-500 bg-slate-700"
                />
              </label>
            ))}
          </div>
          
          <div className="mt-4 flex justify-end gap-2">
            <button 
              onClick={() => setExpanded(false)} 
              className="px-4 py-2 bg-slate-700 hover:bg-slate-600 rounded-lg text-sm"
            >
              Annuler
            </button>
            <button 
              onClick={handleSave}
              disabled={saving}
              className="px-4 py-2 bg-emerald-600 hover:bg-emerald-700 disabled:opacity-50 rounded-lg text-sm flex items-center gap-2"
            >
              {saving ? (
                <svg className="w-4 h-4 animate-spin" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" /></svg>
              ) : (
                <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" /></svg>
              )}
              Sauvegarder
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

